/* MV Sortiment assets/mv-sortiment.vorlagen.js · Agent W-V · 2026-10-07 */
/*
  Modul "vorlagen" (Waechter window.__mvSortiment.vorlagen; Listener nur auf document und window, Zustand im DOM
  und im localStorage des Browsers). Paket W-V, Inhaber 06.10.2026: "Auch so Aufstellungsvertrag Beispiele,
  Business Plan und all sowas brauchen wir". Faktenbasis:
  docs/mv-vending/sortiment/recherche/recht-vertraege-businessplan-2026-10-07.md (Abschnitte 1 bis 3).

  Drei Werkzeuge, je eine Sektion mit Wurzel [data-mv-vorlagen="<werkzeug>"]:
    vertrag       sections/mv-vertrag-generator.liquid - Aufstellungsvertrag: Klauseln je Auswahl, Paragraphen
                  fortlaufend nummeriert, Verweise und Anlagen, Pruefhinweise an rechtlich offenen Stellen,
                  Strompauschale aus dem Jahresverbrauch des Geraets (Datenblock der Sektion).
    businessplan  sections/mv-businessplan.liquid - Plan ueber 36 Monate; Umsatz und laufende Kosten je Standort
                  rechnet rechne() aus assets/mv-sortiment.rechner.js (Paket D5, gleiche Annahmen), dazu
                  Abschreibung, Kredit, Leasing, Liquiditaet, Kennzahlen, Balkengrafik (SVG), CSV.
    pflichten     sections/mv-pflichten-check.liquid - Pflichten je Antwort mit Grundlage, Kurzbegruendung,
                  Links, Haken und Fortschritt.
  Gemeinsam: Schrittleiste, Formular links, lebendes Dokument rechts ([data-mv-vorlagen-dokument], dort gilt
  die Ergebnis-Ausnahme der Pruefregeln), Druck ueber das Attribut data-mv-vorlagen-druck an html, Kopieren als
  Text, Speichern als HTML, Text oder CSV (Blob im Browser), Beispiel laden, Eingaben loeschen.

  Die Texte entstehen in reinen Funktionen (unter Node ueber module.exports; Tests _tests/wv-vorlagen.test.mjs).
  Ein Dokument ist ein Objekt { werkzeug, titel, untertitel, kopf, abschnitte, anlagen, unterschriften,
  rechtshinweis, stand }; dokumentText, dokumentMarkdown und dokumentHtml geben es aus, das DOM baut das Skript
  nur mit createElement und textContent. Kein Server: kein Netzwerkzugriff; Eingaben bleiben im Browser
  (Schluessel SPEICHER). Sichtbare Texte mit Umlauten als Unicode-Escapes (Datei bleibt ASCII).
  Doku _docs/wv-vorlagen.md.
  Nachtrag K-2 (07.10.2026, _docs/k2-werkzeuge.md): Businessplan mit AfA-Vorschlag je Geraetetyp (afaVorschlag:
  reine Getraenkeautomaten sieben, sonst fuenf Jahre; Feld folgt, bis der Nutzer es selbst setzt) und Kartengebuehren
  als Beispielwerte im Kapitel "Annahmen und Quellen" (Inhaberfrage 35). Nachtrag aus I-1 (i1-inhalte.md Abschnitt 12):
  Linkkarte L des Pflichten-Checks je Thema auf die vertiefenden R-W-Beitraege statt der alten Recht-Beitraege.
  Nachtrag D-B (08.10.2026, _docs/db-businessplan.md): Businessplan v2 aus assets/mv-sortiment.businessplan.js. Hier nur
  Aufrufe und Exporte: Bausteine fremder Art gehen an das Modul (erweitere() unter Node, im Browser der Waechter
  window.__mvSortiment.businessplan), die HTML-Datei bekommt dessen Druckregeln, aktualisiere() rechnet und zeichnet
  ueber das Modul, businessplan() liefert im Browser mit Modul den Plan v2 (auch fuer den Downloads-Hub); ohne Modul
  bleibt alles wie bisher.
  Nachtrag A-2b (10.10.2026, _docs/a2b-konto-werkzeuge.md): Die drei Werkzeuge speichern ueber das Kundenkonto
  (assets/mv-sortiment.konto.js, MVKonto) statt unter SPEICHER: Schluessel KONTO (vertrag-aufstellung, businessplan,
  pflichten-check), Stand { v: 1, werte, schritt, erledigt (nur Pflichten-Check), titel } (kontoStand). Ohne Login wie
  bisher nur im Browser (Spiegel mv-konto:<schluessel>), mit Login zusaetzlich im Konto; die Altschluessel SPEICHER
  wandern einmalig in den Spiegel (MVKonto.migration). api.kontoSelbst = true: die Bruecke des Businessplans
  (assets/mv-sortiment.businessplan.js, A-2a) tritt zurueck, der Businessplan-Stand behaelt ihr Format (Titel = Name
  des Vorhabens). Aufstellungsvertrag: Firmen, Anschriften, Vertretung, Steuer- und Telefonnummern der Parteien und
  die Anschrift des Standorts (PERSONEN_FELDER) kommen nie in den Stand; sie bleiben nur im Browser unter
  PERSONEN_SPEICHER (Plan Abschnitt 2.6: keine Adressdaten im Stand), angemeldet erklaert das der Satz
  TEXTE.ui.kontoPersonen unter der Statuszeile. Gespeichert wird nur ein geaenderter Stand; vor der ersten Antwort des
  Kontos wartet blosses Blaettern (Schritt) auf das Konto. Mit Login zeigt das Werkzeug einen abweichenden Konto-Stand
  (anderes Geraet, im Konto geloescht) per Neustart der Wurzel, solange noch nichts eingegeben wurde; sonst gilt die
  Seite und geht ins Konto ("Eingaben loeschen" loescht dort). Statuszeile [data-mv-konto-hinweis] im Kopf. Mit MVKonto
  wird nur dort gespeichert (Plan, Vertrag Abschnitt 3); ohne MVKonto (Rueckfall) wie vor A-2b unter SPEICHER.
  Nachtrag Paket H (13.10.2026, _docs/h-vorlagen-recht.md; Rechtspruefung ohne Anwalt vom 12.10.2026, Inhaber: "Ne
  mach du ohne Anwalt"): Rechtshinweis des Vertrags mit Haftung fuer Vorsatz und grobe Fahrlaessigkeit statt eines
  Ausschlusses (N-2; BGB 276 Abs. 3), Schlussklausel ohne Ersetzungsklausel (N-2; BGB 306 Abs. 2); Pflichten-Check
  mit den Hinweisen gluecksspiel, eichrecht und einweg_schild (nur mit Pfand), Grundpreis-Satz fuer Non-Food in
  preisangabe (Text je Antwort ueber textWenn, im Katalog immer) und neuem Titel von jugend_alkohol (N-4);
  AfA-Vorschlag sieben Jahre auch fuer Kaffee- und Heissgetraenkeautomaten (Typ kaffee) und die UnoCool-Baureihe
  (M-8, AfA-Tabelle AV 7.4.1; afaGetraenkeGeraet).
*/
(function () {
  'use strict';

  var VERSION = '2026-10-07.1';
  var WERKZEUGE = ['vertrag', 'businessplan', 'pflichten'];
  var SPEICHER = { vertrag: 'mv-vorlagen:vertrag', businessplan: 'mv-vorlagen:businessplan', pflichten: 'mv-vorlagen:pflichten' };
  var LUECKE = '________________';          /* Schreiblinie fuer eine fehlende Angabe */
  var LINIE = '______________________________'; /* Unterschriftslinie */
  var NBSP = '\u00a0';
  var MONATE = 36;
  var UST_GERAET = 19;      /* Regelsatz auf Geraete: ohne Vorsteuerabzug zahlt der Kleinunternehmer brutto (Recherche 2.3) */
  var STROMPREIS_CT = 27;   /* Gewerbestrom 27,15 ct je kWh (Recherche 2.2, Q33); Standard des Settings strompreis_ct (ganze Cent) */
  var AFA_JAHRE = 5;        /* amtliche AfA-Tabelle AV 7.4.2 Warenautomaten (Recherche 2.3, Q7) */
  var AFA_JAHRE_GETRAENKE = 7; /* AV 7.4.1 Getraenkeautomaten (Recherche 2.3, Q7); Vorschlag je Geraetetyp, K-2 07.10.2026 */
  var GERAET_STANDARD = { name: 'X10 Dual Screen Lite', preis: 5900 }; /* wie das Rechenbeispiel D5 */
  var ANNAHMEN_STANDARD = { wareneinsatz: 50, grundkosten: 65, karteFix: 14, karteProzent: 2.5, kartenanteil: 55, miete: 'prozent', mieteProzent: 10, mieteFix: 100, mwst: 13 };
  var REITER_STANDARD = {
    buero: { verkaeufe: 15, preis: 2.2, tage: 21 },
    produktion: { verkaeufe: 25, preis: 2.2, tage: 26 },
    fitness: { verkaeufe: 20, preis: 2.8, tage: 30 },
    schule: { verkaeufe: 30, preis: 1.8, tage: 19 },
    klinik: { verkaeufe: 25, preis: 2.4, tage: 30 },
    hotel: { verkaeufe: 15, preis: 3, tage: 30 }
  };
  var TYP_NAME = { buero: 'B\u00fcro und Verwaltung', produktion: 'Produktion und Werkstatt', fitness: 'Fitnessstudio', schule: 'Schule und Hochschule', klinik: 'Klinik und Pflege', hotel: 'Hotel und Gastgewerbe' };

  var TEXTE = {
    stand: '07.10.2026',
    kurz: {
      vertrag: 'Muster ohne Rechtsberatung \u2013 vor Unterzeichnung anwaltlich pr\u00fcfen lassen.',
      businessplan: 'Muster ohne Rechts- und Steuerberatung \u2013 alle Zahlen sind Annahmen, keine Ertragszusage.',
      pflichten: '\u00dcberblick ohne Rechtsberatung \u2013 ersetzt keine Pr\u00fcfung im Einzelfall.'
    },
    rechtshinweis: {
      vertrag: 'Dieses Dokument ist ein Muster, das Sie mit dem Vertragsgenerator von MV Vending aus Ihren eigenen Angaben erstellt haben. Es ist keine Rechtsberatung und ersetzt keine Pr\u00fcfung im Einzelfall. Die Klauseln beruhen auf \u00f6ffentlich zug\u00e4nglichen Quellen wie Gesetzen, Urteilen und Merkbl\u00e4ttern von Beh\u00f6rden; Gesetze und Rechtsprechung k\u00f6nnen sich seit dem Stand der Vorlage ge\u00e4ndert haben. Stellen mit Pr\u00fcfhinweis sind rechtlich nicht abschlie\u00dfend gekl\u00e4rt. Lassen Sie den Vertrag vor der Unterzeichnung anwaltlich pr\u00fcfen und entfernen Sie die Pr\u00fcfhinweise. F\u00fcr Vollst\u00e4ndigkeit, Richtigkeit und Wirksamkeit des Musters \u00fcbernehmen wir keine Gew\u00e4hr; wir haften nur f\u00fcr Vorsatz und grobe Fahrl\u00e4ssigkeit.',
      businessplan: 'Dieser Businessplan ist ein Muster, das Sie mit dem Businessplan-Generator von MV Vending aus Ihren eigenen Angaben erstellt haben. Er ist keine Rechts-, Steuer- oder Finanzierungsberatung, ersetzt keine Pr\u00fcfung im Einzelfall und ist keine Ertragszusage. Alle Zahlen beruhen auf Ihren Eingaben und den genannten Annahmen; tats\u00e4chliche Ums\u00e4tze und Kosten h\u00e4ngen von Standort, Sortiment und Betrieb ab. Lassen Sie den Plan vor der Vorlage bei Bank oder F\u00f6rderstelle steuerlich pr\u00fcfen. Zinsen und F\u00f6rderbedingungen erfragen Sie tagesaktuell bei Ihrer Hausbank.',
      pflichten: 'Diese Liste ist ein \u00dcberblick, den Sie mit dem Pflichten-Check von MV Vending aus Ihren Angaben erstellt haben. Sie ist keine Rechts- oder Steuerberatung, nicht abschlie\u00dfend und ersetzt keine Pr\u00fcfung im Einzelfall. L\u00e4nder und Gemeinden k\u00f6nnen zus\u00e4tzliche Regeln haben. Punkte mit \u201ePr\u00fcfen\u201c kl\u00e4ren Sie im Einzelfall mit Gewerbeamt, Lebensmittel\u00fcberwachung, Gesundheitsamt, Steuerberatung oder Anwalt.'
    },
    titel: {
      vertrag: 'Aufstellungsvertrag f\u00fcr Warenautomaten',
      businessplan: 'Businessplan',
      pflichten: 'Pflichten-Checkliste f\u00fcr Ihren Automaten',
      katalog: 'Pflichten-Checkliste f\u00fcr Automatenbetreiber'
    },
    marke: { vertrag: 'Muster', businessplan: 'Muster', pflichten: 'Checkliste' },
    datei: { vertrag: 'aufstellungsvertrag-muster', businessplan: 'businessplan-muster', pflichten: 'pflichten-checkliste' },
    pruefhinweis: 'Pr\u00fcfhinweis',
    hinweis: 'Hinweis',
    offen: 'Noch nicht ausgef\u00fcllt.',
    rechtshinweisTitel: 'Rechtshinweis',
    standTitel: 'Stand der Vorlage',
    grundlage: 'Grundlage',
    giltFuer: 'Gilt f\u00fcr',
    mehr: 'Mehr dazu',
    angaben: 'Ihre Angaben',
    erledigt: 'erledigt',
    von: 'von',
    status: { pflicht: 'Pflicht', pruefen: 'Pr\u00fcfen', verbot: 'Verbot', hinweis: 'Entlastung' },
    ui: {
      beispiel: 'Beispiel geladen. Passen Sie die Angaben an Ihren Fall an.',
      geleert: 'Alle Eingaben in diesem Werkzeug sind gel\u00f6scht.',
      leerenFrage: 'Alle Eingaben in diesem Werkzeug l\u00f6schen?',
      kopiert: 'Text kopiert.',
      kopierenHand: 'Der Text ist markiert. Kopieren Sie ihn mit Strg und C oder mit Cmd und C.',
      gespeichert: 'Datei gespeichert.',
      kontoPersonen: 'Firmen, Namen, Anschriften, Steuer- und Telefonnummern der Vertragsparteien bleiben nur in diesem Browser \u2013 im Konto speichern wir sie nicht.',
      fehler: 'Das Dokument l\u00e4sst sich gerade nicht erstellen. Laden Sie die Seite bitte neu.',
      schritt: 'Schritt',
      vorschlagLeer: 'Tragen Sie den Jahresverbrauch laut Datenblatt ein, dann erscheint ein Vorschlag.',
      vorschlag: 'Vorschlag',
      proMonat: 'pro Monat',
      jeKwh: 'je kWh',
      eigenesGeraet: 'Anderes Ger\u00e4t mit eigenem Preis',
      eigenesGeraetName: 'Eigenes Ger\u00e4t',
      netto: 'netto',
      geraeteTitel: 'Ger\u00e4t',
      standortTitel: 'Standort'
    }
  };

  /* Schritte der Formulare (Titel = Legende im Liquid) und gueltige Bezuege ins Dokument */
  var SCHRITTE = {
    vertrag: [
      { id: 'parteien', titel: 'Vertragsparteien' },
      { id: 'standort', titel: 'Standort und Ger\u00e4te' },
      { id: 'verguetung', titel: 'Verg\u00fctung und Strom' },
      { id: 'betrieb', titel: 'Betrieb und Pflichten' },
      { id: 'laufzeit', titel: 'Laufzeit und K\u00fcndigung' },
      { id: 'haftung', titel: 'Haftung und Eigentum' },
      { id: 'sortiment', titel: 'Sortiment und Sonderf\u00e4lle' },
      { id: 'abschluss', titel: 'Abschluss und Anlagen' }
    ],
    businessplan: [
      { id: 'vorhaben', titel: 'Vorhaben' },
      { id: 'gruender', titel: 'Gr\u00fcnderin oder Gr\u00fcnder' },
      { id: 'standorte', titel: 'Standorte und Ger\u00e4te' },
      { id: 'sortiment', titel: 'Sortiment und Preise' },
      { id: 'kosten', titel: 'Laufende Kosten' },
      { id: 'investition', titel: 'Investition' },
      { id: 'finanzierung', titel: 'Finanzierung' },
      { id: 'risiken', titel: 'Chancen und Risiken' },
      { id: 'meilensteine', titel: 'Meilensteine' }
    ],
    pflichten: [
      { id: 'gewerbe', titel: 'Gewerbe und Steuern' },
      { id: 'standort', titel: 'Standort' },
      { id: 'sortiment', titel: 'Sortiment' },
      { id: 'betrieb', titel: 'Zahlung und Daten' }
    ]
  };

  var KLAUSEL_TITEL = {
    gegenstand: 'Vertragsgegenstand', standort: 'Standort und Stellfl\u00e4che', aufstellung: 'Aufstellung, Anschluss und Standsicherheit', strom: 'Strom',
    verguetung: 'Standortverg\u00fctung', betreiber: 'Pflichten des Betreibers', hygiene: 'Hygiene und K\u00fchlung', standortgeber: 'Pflichten des Standortgebers',
    zugang: 'Zugang und Servicezeiten', sortiment: 'Sortiment und Preise', pfand: 'Pfand und R\u00fccknahme', zahlung: 'Zahlungssysteme, Telemetrie und Datenschutz',
    jugendschutz: 'Jugendschutz', haftung: 'Haftung und Versicherung', eigentum: 'Eigentum und Schutz vor Pf\u00e4ndung', exklusiv: 'Exklusivit\u00e4t',
    werbung: 'Werbung und Gestaltung', laufzeit: 'Vertragsdauer und K\u00fcndigung', ende: 'Vertragsende und R\u00fcckgabe', nachfolge: 'Rechtsnachfolge',
    sonder: 'Besondere Vereinbarungen', schluss: 'Schlussbestimmungen'
  };
  var KAPITEL = ['zusammenfassung', 'vorhaben', 'gruender', 'standorte', 'sortiment', 'investition', 'finanzierung', 'plan', 'liquiditaet', 'risiken',
    'meilensteine', 'annahmen', 'unterlagen'];
  var PFLICHT_GRUPPEN = [
    { id: 'anmeldung', titel: 'Gewerbe und Anmeldung' },
    { id: 'steuern', titel: 'Steuern und Kasse' },
    { id: 'lebensmittel', titel: 'Lebensmittel und Hygiene' },
    { id: 'jugendschutz', titel: 'Jugendschutz' },
    { id: 'preise', titel: 'Preise, Pfand und Verpackung' },
    { id: 'technik', titel: 'Technik, Sicherheit und Standort' },
    { id: 'vertraege', titel: 'Vertr\u00e4ge, Daten und Versicherung' }
  ];
  var BEZUEGE = {
    vertrag: Object.keys(KLAUSEL_TITEL).concat(['kopf', 'anlagen', 'unterschriften']),
    businessplan: KAPITEL.slice(),
    pflichten: PFLICHT_GRUPPEN.map(function (g) { return g.id; }).concat(['kopf'])
  };

  /* D-B: Erweiterung fuer Bausteine des Businessplans v2 (assets/mv-sortiment.businessplan.js) */
  var ERWEITERUNG = null;
  function erweitere(modul) {
    ERWEITERUNG = modul && typeof modul === 'object' ? modul : null;
    return ERWEITERUNG;
  }
  function erweiterungImBrowser() {
    var mv = typeof window !== 'undefined' ? window.__mvSortiment : null;
    return mv && mv.businessplan && typeof mv.businessplan.dokument === 'function' ? mv.businessplan : null;
  }
  function erweiterung() {
    return ERWEITERUNG || erweiterungImBrowser();
  }
  function erweiterterBlock(fn, b, o, u) {
    var e = erweiterung();
    return e && typeof e[fn] === 'function' ? e[fn](b, o, u) : null;
  }

  /* ------------------------------------------------------------------ Zahlen und Texte */

  /* Deutsche und englische Schreibweise: "2,50", "2.5", "1.234,5", "1.234", " 40 % " */
  function zahl(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : NaN;
    if (wert === null || wert === undefined || typeof wert === 'boolean') return NaN;
    var s = String(wert).replace(/[\s\u00a0\u20ac%]/g, '');
    if (!s) return NaN;
    var minus = false;
    if (/^[-\u2212]/.test(s)) {
      minus = true;
      s = s.slice(1);
    }
    if (s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
    if (!/^\d+(\.\d+)?$/.test(s)) return NaN;
    var n = parseFloat(s);
    return minus ? -n : n;
  }

  function positiv(x) {
    var n = zahl(x);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function ganz(x) {
    var n = zahl(x);
    return isFinite(n) && n >= 0 ? Math.round(n) : NaN;
  }

  function tausender(text) {
    return text.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* de-DE: Tausenderpunkt, Dezimalkomma, echtes Minus; stellen = feste Nachkommastellen, sonst hoechstens zwei */
  function zahlText(n, stellen) {
    var x = typeof n === 'number' ? n : zahl(n);
    if (!isFinite(x)) return '\u2013';
    var fest = typeof stellen === 'number' && stellen >= 0;
    var faktor = Math.pow(10, fest ? stellen : 2);
    var r = Math.round(Math.abs(x) * faktor) / faktor;
    var teile = (fest ? r.toFixed(stellen) : String(r)).split('.');
    var text = tausender(teile[0]) + (teile[1] ? ',' + teile[1] : '');
    return x < 0 && r !== 0 ? '\u2212' + text : text;
  }

  /* Zahl als Feldwert wie getippt: Dezimalkomma, kein Tausenderpunkt; leer bei ungueltig */
  function feldZahl(n) {
    var x = typeof n === 'number' ? n : zahl(n);
    return isFinite(x) ? String(x).replace('.', ',') : '';
  }

  /* Betrag mit U+00A0 vor dem Eurozeichen; ohne stellen ganze Euro */
  function euro(n, stellen) {
    var x = typeof n === 'number' ? n : zahl(n);
    if (!isFinite(x)) return '\u2013';
    var s = typeof stellen === 'number' && stellen > 0 ? stellen : 0;
    var r = s === 0 ? Math.round(x) : x;
    return zahlText(r === 0 ? 0 : r, s) + NBSP + '\u20ac';
  }

  function prozent(n) {
    return zahlText(n) + NBSP + '%';
  }

  function datumText(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || '').trim());
    return m ? m[3] + '.' + m[2] + '.' + m[1] : '';
  }

  function txt(x) {
    return x === null || x === undefined ? '' : String(x).replace(/\s+/g, ' ').trim();
  }

  /* Angabe oder Schreiblinie */
  function oder(x) {
    return txt(x) || LUECKE;
  }

  function istJa(x) {
    return x === true || x === 'true' || x === '1' || x === 1 || x === 'on';
  }

  function eigen(o, k) {
    return Object.prototype.hasOwnProperty.call(o, k);
  }

  function kopie(o) {
    var z = {};
    for (var k in o) if (eigen(o, k)) z[k] = o[k];
    return z;
  }

  /* flache Werte ueberlagern (Standard + Eingaben); nur Text und Wahrheitswerte */
  function mischeFlach(basis, werte) {
    var z = kopie(basis || {});
    var w = werte || {};
    for (var k in w) {
      if (!eigen(w, k)) continue;
      var v = w[k];
      if (typeof v === 'string' || typeof v === 'boolean') z[k] = v;
      else if (typeof v === 'number' && isFinite(v)) z[k] = String(v);
    }
    return z;
  }

  /* "a.b" und "liste.0.feld" -> verschachtelt; Luecken in Listen fallen weg */
  function ausFlach(werte) {
    var o = {};
    var w = werte || {};
    Object.keys(w).forEach(function (k) {
      var teile = k.split('.');
      var z = o;
      for (var i = 0; i < teile.length - 1; i++) {
        var t = teile[i];
        if (z[t] === undefined || z[t] === null || typeof z[t] !== 'object') z[t] = /^\d+$/.test(teile[i + 1]) ? [] : {};
        z = z[t];
      }
      z[teile[teile.length - 1]] = w[k];
    });
    return verdichte(o);
  }

  function verdichte(x) {
    if (Array.isArray(x)) {
      var liste = [];
      for (var i = 0; i < x.length; i++) if (x[i] !== undefined) liste.push(verdichte(x[i]));
      return liste;
    }
    if (x && typeof x === 'object') {
      var o = {};
      for (var k in x) if (eigen(x, k)) o[k] = verdichte(x[k]);
      return o;
    }
    return x;
  }

  function zuFlach(obj, praefix, ziel) {
    var z = ziel || {};
    Object.keys(obj || {}).forEach(function (k) {
      var v = obj[k];
      var n = praefix ? praefix + '.' + k : k;
      if (v && typeof v === 'object') zuFlach(v, n, z);
      else z[n] = v;
    });
    return z;
  }

  /* Kurzfassung fuer data-konfiguration der Lightbox: Teile mit Mittelpunkt, hoechstens 900 Zeichen */
  function konfigurationText(teile) {
    var liste = [];
    for (var i = 0; i < (teile || []).length; i++) {
      var t = txt(teile[i]);
      if (t) liste.push(t);
    }
    return liste.join(' \u00b7 ').slice(0, 900);
  }

  function kontextTexte(kontext, w) {
    var t = (kontext && kontext.daten && kontext.daten.texte) || (kontext && kontext.texte) || {};
    return {
      kurz: txt(t.kurz) || TEXTE.kurz[w],
      rechtshinweis: txt(t.rechtshinweis) || TEXTE.rechtshinweis[w],
      stand: txt(t.stand) || TEXTE.stand
    };
  }

  /* ------------------------------------------------------------------ Bausteine des Dokuments */

  function absatz(text, nr) {
    return { art: 'absatz', text: text, nr: nr || '' };
  }

  function liste(punkte) {
    return { art: 'liste', punkte: punkte };
  }

  function hinweis(text, label) {
    return { art: 'hinweis', text: text, label: label || TEXTE.pruefhinweis };
  }

  function tabelle(titel, kopf, zeilen, zahlen) {
    return { art: 'tabelle', titel: titel || '', kopf: kopf, zeilen: zeilen, zahlen: zahlen || [] };
  }

  /* (1), (2) ... nur bei mehr als einem Absatz */
  function nummeriere(bloecke) {
    var n = 0;
    bloecke.forEach(function (b) { if (b.art === 'absatz') n += 1; });
    if (n < 2) return bloecke;
    var i = 0;
    bloecke.forEach(function (b) {
      if (b.art === 'absatz') {
        i += 1;
        b.nr = '(' + i + ')';
      }
    });
    return bloecke;
  }

  /* ------------------------------------------------------------------ Ausgabe als Text und Markdown */

  function blockText(b) {
    switch (b.art) {
      case 'absatz': return [(b.nr ? b.nr + ' ' : '') + b.text];
      case 'liste': return b.punkte.map(function (p) { return '\u2013 ' + p; });
      case 'hinweis': return [(b.label || TEXTE.pruefhinweis) + ': ' + b.text];
      case 'tabelle': return (b.titel ? [b.titel + ':'] : []).concat([b.kopf.join(' | ')], b.zeilen.map(function (z) { return z.join(' | '); }));
      case 'kennzahlen': return b.werte.map(function (w) { return w.label + ': ' + w.wert + (w.text ? ' (' + w.text + ')' : ''); });
      case 'grafik': return [b.titel + ': ' + b.beschreibung];
      case 'zeile': return [b.text];
      case 'partei': return [b.zeilen.join(', '), '\u2013 nachfolgend \u201e' + b.rolle + '\u201c \u2013'];
      case 'pflicht': return [(b.erledigt ? '[x] ' : '[ ] ') + b.titel + ' (' + b.statusText + ')', b.text, TEXTE.grundlage + ': ' + b.norm]
        .concat(b.fuer ? [TEXTE.giltFuer + ': ' + b.fuer] : [], b.links.length ? [TEXTE.mehr + ': ' + b.links.map(function (l) { return l.text; }).join('; ')] : []);
      case 'fortschritt': return [b.erledigt + ' ' + TEXTE.von + ' ' + b.gesamt + ' ' + TEXTE.erledigt];
      case 'angaben': return [TEXTE.angaben + ': ' + b.punkte.join(' \u00b7 ')];
      default: return erweiterterBlock('blockText', b) || [];
    }
  }

  function unterschriftText(u) {
    return [(u.ort ? u.ort + ', ' : '') + 'den ' + LINIE, u.rolle + ': ' + u.name + ' \u2013 Unterschrift: ' + LINIE];
  }

  function dokumentText(dok) {
    var z = [dok.titel];
    if (dok.untertitel) z.push(dok.untertitel);
    if (dok.kopf && dok.kopf.length) {
      z.push('');
      dok.kopf.forEach(function (b) { z.push.apply(z, blockText(b)); });
    }
    (dok.abschnitte || []).forEach(function (a) {
      z.push('', (a.nr ? a.nr + ' ' : '') + a.titel);
      a.bloecke.forEach(function (b) { z.push.apply(z, blockText(b)); });
    });
    (dok.anlagen || []).forEach(function (a) {
      z.push('', a.nr + ' \u2013 ' + a.titel);
      a.bloecke.forEach(function (b) { z.push.apply(z, blockText(b)); });
    });
    if (dok.unterschriften && dok.unterschriften.length) {
      dok.unterschriften.forEach(function (u) { z.push(''); z.push.apply(z, unterschriftText(u)); });
    }
    if (dok.rechtshinweis) z.push('', TEXTE.rechtshinweisTitel, dok.rechtshinweis);
    if (dok.stand) z.push(TEXTE.standTitel + ': ' + dok.stand);
    return z.join('\n') + '\n';
  }

  function zelle(t) {
    return String(t).replace(/\|/g, '\\|');
  }

  function blockMarkdown(b) {
    switch (b.art) {
      case 'absatz': return [(b.nr ? b.nr + ' ' : '') + b.text];
      case 'liste': return b.punkte.map(function (p) { return '- ' + p; });
      case 'hinweis': return ['> **' + (b.label || TEXTE.pruefhinweis) + ':** ' + b.text];
      case 'tabelle': {
        var z = b.titel ? ['**' + b.titel + '**', ''] : [];
        z.push('| ' + b.kopf.map(zelle).join(' | ') + ' |');
        z.push('|' + b.kopf.map(function (_, i) { return b.zahlen.indexOf(i) !== -1 ? ' ---: ' : ' --- '; }).join('|') + '|');
        b.zeilen.forEach(function (r) { z.push('| ' + r.map(zelle).join(' | ') + ' |'); });
        return z;
      }
      case 'kennzahlen': return b.werte.map(function (w) { return '- **' + w.label + ':** ' + w.wert + (w.text ? ' \u2013 ' + w.text : ''); });
      case 'grafik': return ['_' + b.titel + ': ' + b.beschreibung + '_'];
      case 'zeile': return [b.text];
      case 'partei': return [b.zeilen.join(', ') + '  ', '\u2013 nachfolgend \u201e' + b.rolle + '\u201c \u2013'];
      case 'pflicht': {
        var p = ['- [' + (b.erledigt ? 'x' : ' ') + '] **' + b.titel + '** (' + b.statusText + ')  ', '  ' + b.text + '  ', '  ' + TEXTE.grundlage + ': ' + b.norm + (b.fuer || b.links.length ? '  ' : '')];
        if (b.fuer) p.push('  ' + TEXTE.giltFuer + ': ' + b.fuer + (b.links.length ? '  ' : ''));
        if (b.links.length) p.push('  ' + TEXTE.mehr + ': ' + b.links.map(function (l) { return l.text; }).join('; '));
        return p;
      }
      case 'fortschritt': return ['**' + b.erledigt + ' ' + TEXTE.von + ' ' + b.gesamt + ' ' + TEXTE.erledigt + '**'];
      case 'angaben': return ['**' + TEXTE.angaben + ':** ' + b.punkte.join(' \u00b7 ')];
      default: return erweiterterBlock('blockMarkdown', b) || [];
    }
  }

  function bloeckeMarkdown(bloecke, z) {
    bloecke.forEach(function (b, i) {
      if (i > 0 || b) z.push('');
      z.push.apply(z, blockMarkdown(b));
    });
  }

  function dokumentMarkdown(dok) {
    var z = ['# ' + dok.titel];
    if (dok.untertitel) z.push('', '_' + dok.untertitel + '_');
    if (dok.kopf && dok.kopf.length) bloeckeMarkdown(dok.kopf, z);
    (dok.abschnitte || []).forEach(function (a) {
      z.push('', '## ' + (a.nr ? a.nr + ' ' : '') + a.titel);
      bloeckeMarkdown(a.bloecke, z);
    });
    (dok.anlagen || []).forEach(function (a) {
      z.push('', '## ' + a.nr + ' \u2013 ' + a.titel);
      bloeckeMarkdown(a.bloecke, z);
    });
    (dok.unterschriften || []).forEach(function (u) {
      var t = unterschriftText(u);
      z.push('', t[0] + '  ', t[1]);
    });
    if (dok.rechtshinweis) z.push('', '---', '', '**' + TEXTE.rechtshinweisTitel + ':** ' + dok.rechtshinweis);
    if (dok.stand) z.push('', TEXTE.standTitel + ': ' + dok.stand);
    return z.join('\n') + '\n';
  }

  /* ------------------------------------------------------------------ Ausgabe als HTML (Datei und Test) */

  /* Satz fuer Blatt und HTML-Datei: geschuetztes Leerzeichen nach Paragraphenzeichen und Normkuerzeln vor Ziffern
     (kein Zeilenumbruch zwischen "\u00a7" und "307"); Text- und Markdown-Ausgabe bleiben schlicht */
  var SATZ_RE = /(\u00a7\u00a7?|Abs\.|Nr\.|Art\.|Anlage|Satz)[ ](?=\d)/g;
  function satz(t) {
    return String(t).replace(SATZ_RE, '$1' + NBSP);
  }

  function esc(t) {
    return satz(t === null || t === undefined ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Balken je Monat: Hoehe proportional zum Wert, Nulllinie zwischen Plus und Minus; reine Geometrie */
  function balkenAus(werte, opt) {
    var o = opt || {};
    var breite = o.breite || 720;
    var hoehe = o.hoehe || 240;
    var oben = 12;
    var unten = 30;
    var rand = 8;
    var max = 0;
    var min = 0;
    werte.forEach(function (w) {
      if (w > max) max = w;
      if (w < min) min = w;
    });
    var spanne = max - min || 1;
    var skala = (hoehe - oben - unten) / spanne;
    var nulllinie = oben + max * skala;
    var n = werte.length || 1;
    var schritt = (breite - 2 * rand) / n;
    var b = schritt * 0.7;
    var balken = werte.map(function (w, i) {
      var h = Math.abs(w) * skala;
      return { monat: i + 1, wert: w, x: rand + i * schritt + (schritt - b) / 2, b: b, h: h, y: w < 0 ? nulllinie : nulllinie - h, art: w < 0 ? 'minus' : 'plus' };
    });
    var jahre = [];
    var trenner = [];
    for (var j = 0; j * 12 < n; j++) {
      jahre.push({ text: 'Jahr ' + (j + 1), x: rand + (j * 12 + 6) * schritt, y: hoehe - 8 });
      if (j > 0) trenner.push(rand + j * 12 * schritt);
    }
    return { breite: breite, hoehe: hoehe, nulllinie: nulllinie, balken: balken, jahre: jahre, trenner: trenner, max: max, min: min };
  }

  function balken(plan, opt) {
    return balkenAus(plan.monate.map(function (z) { return z.ergebnis; }), opt);
  }

  var DOK_KLASSE = {
    dok: 'mv-vorlagen-dok', kopf: 'mv-vorlagen-dok__kopf', marke: 'mv-vorlagen-dok__marke', titel: 'mv-vorlagen-dok__titel', untertitel: 'mv-vorlagen-dok__untertitel',
    abschnitt: 'mv-vorlagen-dok__abschnitt', anlage: 'mv-vorlagen-dok__anlage', ueberschrift: 'mv-vorlagen-dok__ueberschrift', nr: 'mv-vorlagen-dok__nr',
    absatz: 'mv-vorlagen-dok__absatz', absatznr: 'mv-vorlagen-dok__absatznr', liste: 'mv-vorlagen-dok__liste', hinweis: 'mv-vorlagen-dok__hinweis',
    hinweisTitel: 'mv-vorlagen-dok__hinweis-titel', tabelle: 'mv-vorlagen-dok__tabelle', tab: 'mv-vorlagen-dok__tab', tabTitel: 'mv-vorlagen-dok__tab-titel',
    zahl: 'mv-vorlagen-dok__zahl', rechtshinweis: 'mv-vorlagen-dok__rechtshinweis', rechtshinweisTitel: 'mv-vorlagen-dok__rechtshinweis-titel',
    rechtshinweisText: 'mv-vorlagen-dok__rechtshinweis-text', stand: 'mv-vorlagen-dok__stand'
  };

  function html(tag, klasse, inhalt, attr) {
    var a = klasse ? ' class="' + esc(klasse) + '"' : '';
    var w = attr || {};
    for (var k in w) if (eigen(w, k) && w[k] !== null && w[k] !== undefined && w[k] !== false) a += w[k] === true ? ' ' + k : ' ' + k + '="' + esc(w[k]) + '"';
    return '<' + tag + a + '>' + (inhalt || '') + '</' + tag + '>';
  }

  function svgHtml(werte, titel, beschreibung, id) {
    var g = balkenAus(werte, { breite: 720, hoehe: 240 });
    var s = '<svg class="mv-bplan-grafik" viewBox="0 0 720 240" role="img" aria-labelledby="' + esc(id) + '-t ' + esc(id) + '-d">';
    s += '<title id="' + esc(id) + '-t">' + esc(titel) + '</title><desc id="' + esc(id) + '-d">' + esc(beschreibung) + '</desc>';
    g.trenner.forEach(function (x) { s += '<line class="mv-bplan-trenner" x1="' + x.toFixed(1) + '" y1="8" x2="' + x.toFixed(1) + '" y2="' + (g.hoehe - 26) + '"></line>'; });
    g.balken.forEach(function (b) {
      s += '<rect class="mv-bplan-balken mv-bplan-balken--' + b.art + '" x="' + b.x.toFixed(1) + '" y="' + b.y.toFixed(1) + '" width="' + b.b.toFixed(1) + '" height="' + Math.max(b.h, 0.5).toFixed(1) + '"></rect>';
    });
    s += '<line class="mv-bplan-null" x1="8" y1="' + g.nulllinie.toFixed(1) + '" x2="712" y2="' + g.nulllinie.toFixed(1) + '"></line>';
    g.jahre.forEach(function (j) { s += '<text class="mv-bplan-jahr" x="' + j.x.toFixed(1) + '" y="' + j.y + '" text-anchor="middle">' + esc(j.text) + '</text>'; });
    return s + '</svg>';
  }

  function blockHtml(b, o, nrPflicht) {
    switch (b.art) {
      case 'absatz': return html('p', DOK_KLASSE.absatz, (b.nr ? html('span', DOK_KLASSE.absatznr, esc(b.nr)) + ' ' : '') + esc(b.text));
      case 'liste': return html('ul', DOK_KLASSE.liste, b.punkte.map(function (p) { return html('li', '', esc(p)); }).join(''));
      case 'hinweis': return html('aside', DOK_KLASSE.hinweis, html('strong', DOK_KLASSE.hinweisTitel, esc((b.label || TEXTE.pruefhinweis) + ':')) + ' ' + esc(b.text), { role: 'note' });
      case 'tabelle': {
        var kopf = '<thead><tr>' + b.kopf.map(function (k, i) { return html('th', b.zahlen.indexOf(i) !== -1 ? DOK_KLASSE.zahl : '', esc(k), { scope: 'col' }); }).join('') + '</tr></thead>';
        var rumpf = '<tbody>' + b.zeilen.map(function (r) { return '<tr>' + r.map(function (c, i) { return html('td', b.zahlen.indexOf(i) !== -1 ? DOK_KLASSE.zahl : '', esc(c)); }).join('') + '</tr>'; }).join('') + '</tbody>';
        var cap = b.titel ? html('caption', DOK_KLASSE.tabTitel, esc(b.titel)) : '';
        return html('div', DOK_KLASSE.tabelle, html('table', DOK_KLASSE.tab, cap + kopf + rumpf), { role: 'region', tabindex: '0', 'aria-label': b.titel || b.kopf.join(', ') });
      }
      case 'kennzahlen': return html('ul', 'mv-bplan-kennzahlen', b.werte.map(function (w) {
        return html('li', 'mv-bplan-kennzahl', html('span', 'mv-bplan-kennzahl__label', esc(w.label)) + html('span', 'mv-bplan-kennzahl__wert', esc(w.wert)) + (w.text ? html('span', 'mv-bplan-kennzahl__text', esc(w.text)) : ''));
      }).join(''), { role: 'list' });
      case 'grafik': return html('figure', 'mv-bplan-figur', svgHtml(b.werte, b.titel, b.beschreibung, (o.id || 'mv-vorlagen') + '-grafik') + html('figcaption', 'mv-bplan-figur__text', esc(b.beschreibung)));
      case 'zeile': return html('p', 'mv-vertrag-zwischen', esc(b.text));
      case 'partei': return html('p', 'mv-vertrag-partei', html('span', 'mv-vertrag-partei__zeilen', esc(b.zeilen.join(', '))) + ' ' + html('span', 'mv-vertrag-partei__rolle', esc('\u2013 nachfolgend \u201e' + b.rolle + '\u201c \u2013')));
      case 'pflicht': {
        var hid = (o.id || 'mv-vorlagen') + '-haken-' + b.id;
        var links = b.links.map(function (l) { return o.standalone ? html('span', 'mv-pflicht-link', esc(l.text)) : html('a', 'mv-pflicht-link', esc(l.text), { href: l.href }); }).join(', ');
        var kopfZeile = html('div', 'mv-pflicht-eintrag__kopf',
          html('input', 'mv-pflicht-haken', '', { type: 'checkbox', id: hid, 'data-mv-pflicht-haken': b.id, checked: !!b.erledigt, disabled: !!o.standalone }).replace('></input>', '>') +
          html('label', 'mv-pflicht-titel', esc(b.titel), { for: hid }) +
          html('span', 'mv-pflicht-status mv-pflicht-status--' + b.status, esc(b.statusText)));
        var teile = kopfZeile + html('p', 'mv-pflicht-text', esc(b.text)) +
          html('p', 'mv-pflicht-norm', html('span', 'mv-pflicht-norm__label', esc(TEXTE.grundlage + ':')) + ' ' + esc(b.norm)) +
          (b.fuer ? html('p', 'mv-pflicht-fuer', esc(TEXTE.giltFuer + ': ' + b.fuer)) : '') +
          (b.links.length ? html('p', 'mv-pflicht-links', html('span', 'mv-pflicht-links__label', esc(TEXTE.mehr + ':')) + ' ' + links) : '');
        return html('li', 'mv-pflicht-eintrag mv-pflicht-eintrag--' + b.status, teile, { 'data-mv-pflicht-eintrag': b.id, 'data-mv-pflicht-erledigt': b.erledigt ? '' : null });
      }
      case 'fortschritt': return html('div', 'mv-pflicht-fortschritt', html('progress', 'mv-pflicht-fortschritt__balken', '', { max: String(Math.max(b.gesamt, 1)), value: String(b.erledigt), 'aria-label': TEXTE.erledigt }) +
        html('p', 'mv-pflicht-fortschritt__text', esc(b.erledigt + ' ' + TEXTE.von + ' ' + b.gesamt + ' ' + TEXTE.erledigt), { 'data-mv-pflicht-stand': '' }));
      case 'angaben': return html('p', 'mv-pflicht-angaben', html('span', 'mv-pflicht-angaben__label', esc(TEXTE.angaben + ':')) + ' ' + esc(b.punkte.join(' \u00b7 ')));
      default: return erweiterterBlock('blockHtml', b, o) || '';
    }
  }

  /* Bloecke eines Abschnitts; Pflichten als Liste */
  function bloeckeHtml(bloecke, o) {
    var s = '';
    var offen = false;
    bloecke.forEach(function (b) {
      if (b.art === 'pflicht' && !offen) { s += '<ul class="mv-pflicht-liste" role="list">'; offen = true; }
      if (b.art !== 'pflicht' && offen) { s += '</ul>'; offen = false; }
      s += blockHtml(b, o);
    });
    if (offen) s += '</ul>';
    return s;
  }

  var DRUCK_CSS = [
    '@page { size: A4; margin: 18mm 16mm 20mm; }',
    '* { box-sizing: border-box; }',
    'body { margin: 0; color: #1f2a40; background: #ffffff; font: 11pt/1.5 "Barlow", "Helvetica Neue", Arial, sans-serif; }',
    '.mv-vorlagen-seite { max-width: 46rem; margin: 0 auto; padding: 2rem 1.25rem; }',
    '.mv-vorlagen-dok__marke { display: inline-block; margin: 0 0 .5rem; padding: .1rem .6rem; border: 2px solid #4174c0; border-radius: 99px; color: #30405f; font-weight: 700; font-size: 9pt; letter-spacing: .08em; text-transform: uppercase; }',
    '.mv-vorlagen-dok__titel { margin: 0 0 .25rem; font-size: 20pt; line-height: 1.2; }',
    '.mv-vorlagen-dok__untertitel { margin: 0 0 1.25rem; color: #47546e; }',
    '.mv-vorlagen-dok__ueberschrift { margin: 1.4rem 0 .4rem; font-size: 13pt; break-after: avoid; }',
    '.mv-vorlagen-dok__nr { display: inline-block; min-width: 3.2em; }',
    '.mv-vorlagen-dok__absatz { margin: .35rem 0; }',
    '.mv-vorlagen-dok__absatznr { font-weight: 700; }',
    '.mv-vorlagen-dok__hinweis { margin: .5rem 0; padding: .5rem .75rem; border-left: 4px solid #4174c0; background: #f4f7fd; font-size: 10pt; break-inside: avoid; }',
    '.mv-vorlagen-dok__tab { width: 100%; border-collapse: collapse; margin: .5rem 0; font-size: 9.5pt; }',
    '.mv-vorlagen-dok__tab th, .mv-vorlagen-dok__tab td { padding: .3rem .4rem; border-bottom: 1px solid #c9d2e3; text-align: left; vertical-align: top; }',
    '.mv-vorlagen-dok__tab th { background: #dee6f9; }',
    '.mv-vorlagen-dok__zahl { text-align: right; white-space: nowrap; }',
    '.mv-vorlagen-dok__tab-titel { text-align: left; font-weight: 700; padding-bottom: .25rem; }',
    '.mv-bplan-kennzahlen { display: grid; grid-template-columns: repeat(3, 1fr); gap: .5rem; padding: 0; list-style: none; }',
    '.mv-bplan-kennzahl { padding: .5rem; border: 1px solid #c9d2e3; border-radius: 8px; display: flex; flex-direction: column; }',
    '.mv-bplan-kennzahl__wert { font-size: 14pt; font-weight: 700; }',
    '.mv-bplan-kennzahl__label, .mv-bplan-kennzahl__text { font-size: 9pt; }',
    '.mv-bplan-figur { margin: .75rem 0; }',
    '.mv-bplan-grafik { width: 100%; height: auto; }',
    '.mv-bplan-balken--plus { fill: #4174c0; } .mv-bplan-balken--minus { fill: #b42318; }',
    '.mv-bplan-null { stroke: #30405f; stroke-width: 1; } .mv-bplan-trenner { stroke: #c9d2e3; stroke-dasharray: 3 3; }',
    '.mv-bplan-jahr { font-size: 12px; fill: #30405f; }',
    '.mv-vertrag-partei { margin: .25rem 0 .75rem; } .mv-vertrag-partei__zeilen { font-weight: 700; } .mv-vertrag-partei__rolle { display: block; }',
    '.mv-vertrag-unterschriften { display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; margin-top: 2.5rem; break-inside: avoid; }',
    '.mv-vertrag-unterschrift__linie { display: block; height: 2.5rem; border-bottom: 1px solid #1f2a40; }',
    '.mv-pflicht-liste { padding: 0; list-style: none; }',
    '.mv-pflicht-eintrag { margin: .5rem 0; padding: .5rem 0; border-bottom: 1px solid #c9d2e3; break-inside: avoid; }',
    '.mv-pflicht-eintrag__kopf { display: flex; gap: .5rem; align-items: baseline; font-weight: 700; }',
    '.mv-pflicht-status { margin-left: auto; font-size: 9pt; text-transform: uppercase; letter-spacing: .04em; }',
    '.mv-pflicht-text, .mv-pflicht-norm, .mv-pflicht-fuer, .mv-pflicht-links { margin: .2rem 0 0 1.6rem; font-size: 10pt; }',
    '.mv-vorlagen-dok__rechtshinweis { margin-top: 2rem; padding-top: .75rem; border-top: 1px solid #c9d2e3; font-size: 9pt; color: #47546e; }',
    '@media print { .mv-vorlagen-seite { max-width: none; padding: 0; } a { color: inherit; } }'
  ].join('\n');

  /* opt.standalone: vollstaendige Seite mit Druckregeln (Datei); sonst nur das Dokument */
  function dokumentHtml(dok, opt) {
    var o = opt || {};
    var e = o.standalone ? { titel: 'h1', abschnitt: 'h2' } : { titel: 'h2', abschnitt: 'h3' };
    var kopf = html('p', DOK_KLASSE.marke, esc(TEXTE.marke[dok.werkzeug] || TEXTE.marke.vertrag)) + html(e.titel, DOK_KLASSE.titel, esc(dok.titel)) +
      (dok.untertitel ? html('p', DOK_KLASSE.untertitel, esc(dok.untertitel)) : '') + bloeckeHtml(dok.kopf || [], o);
    var s = html('header', DOK_KLASSE.kopf, kopf, { 'data-mv-vorlagen-teil': 'kopf' });
    (dok.abschnitte || []).forEach(function (a) {
      var h = html(e.abschnitt, DOK_KLASSE.ueberschrift, (a.nr ? html('span', DOK_KLASSE.nr, esc(a.nr)) + ' ' : '') + esc(a.titel));
      s += html('section', DOK_KLASSE.abschnitt, h + bloeckeHtml(a.bloecke, o), { 'data-mv-vorlagen-abschnitt': a.id });
    });
    (dok.anlagen || []).forEach(function (a) {
      var h = html(e.abschnitt, DOK_KLASSE.ueberschrift, html('span', DOK_KLASSE.nr, esc(a.nr)) + ' ' + esc('\u2013 ' + a.titel));
      s += html('section', DOK_KLASSE.abschnitt + ' ' + DOK_KLASSE.anlage, h + bloeckeHtml(a.bloecke, o), { 'data-mv-vorlagen-anlage': a.id });
    });
    if (dok.unterschriften && dok.unterschriften.length) {
      s += html('div', 'mv-vertrag-unterschriften', dok.unterschriften.map(function (u) {
        return html('div', 'mv-vertrag-unterschrift', html('p', 'mv-vertrag-unterschrift__ort', esc((u.ort ? u.ort + ', ' : '') + 'den')) + html('span', 'mv-vertrag-unterschrift__linie', '') +
          html('p', 'mv-vertrag-unterschrift__rolle', esc(u.rolle + ': ' + u.name)));
      }).join(''), { 'data-mv-vorlagen-teil': 'unterschriften' });
    }
    if (dok.rechtshinweis) {
      s += html('footer', DOK_KLASSE.rechtshinweis, html(e.abschnitt, DOK_KLASSE.rechtshinweisTitel, esc(TEXTE.rechtshinweisTitel)) + html('p', DOK_KLASSE.rechtshinweisText, esc(dok.rechtshinweis)) +
        (dok.stand ? html('p', DOK_KLASSE.stand, esc(TEXTE.standTitel + ': ' + dok.stand)) : ''));
    }
    var artikel = html('article', DOK_KLASSE.dok + ' ' + DOK_KLASSE.dok + '--' + dok.werkzeug, s);
    if (!o.standalone) return artikel;
    var zusatzCss = erweiterterBlock('druckCss', dok);
    return '<!doctype html>\n<html lang="de">\n<head>\n<meta charset="utf-8">\n<meta name="viewport" content="width=device-width, initial-scale=1">\n<title>' + esc(dok.titel) + '</title>\n<style>\n' + DRUCK_CSS +
      (zusatzCss ? '\n' + zusatzCss : '') + '\n</style>\n</head>\n<body>\n<main class="mv-vorlagen-seite">\n' + artikel + '\n</main>\n</body>\n</html>\n';
  }

  /* ------------------------------------------------------------------ Aufstellungsvertrag */

  var EIGENTUEMER = { betreiber: 'Betreiber', leasing: 'Leasinggeber', vorbehalt: 'Vorbehaltsverk\u00e4ufer' };
  var ABBAU = { unverzueglich: 'unverz\u00fcglich', woche: 'innerhalb einer Woche', zwei: 'innerhalb von zwei Wochen', monat: 'innerhalb eines Monats' };
  var ANKUENDIGUNG = { zwei: 'zwei Wochen', vier: 'vier Wochen', monat: 'einem Monat' };
  var MODELL_NAME = { fix: 'Festbetrag', umsatz: 'Umsatzanteil', misch: 'Grundbetrag und Umsatzanteil', keine: 'keine Verg\u00fctung' };
  var STROM_NAME = { standort: 'Standortgeber tr\u00e4gt den Strom', pauschale: 'Strompauschale', zaehler: 'Zwischenz\u00e4hler', inklusive: 'in der Verg\u00fctung enthalten' };

  function vertragStandard(daten) {
    /* Datenblock strompreisCt in ganzen Cent (Setting strompreis_ct); Feldwert in Euro mit zwei Stellen wie im Liquid */
    var ct = daten && typeof daten.strompreisCt === 'number' && isFinite(daten.strompreisCt) ? Math.round(daten.strompreisCt) : 0;
    if (ct < 1) ct = STROMPREIS_CT;
    return {
      'standortgeber.firma': '', 'standortgeber.anschrift': '', 'standortgeber.vertreter': '', 'standortgeber.steuer': '', 'standortgeber.kaufmann': false,
      'standortgeber.ansprechpartner': '',
      'betreiber.firma': '', 'betreiber.anschrift': '', 'betreiber.vertreter': '', 'betreiber.steuer': '', 'betreiber.kaufmann': false, 'betreiber.telefon': '',
      'standort.anschrift': '', 'standort.bereich': '', 'standort.breite': '', 'standort.tiefe': '', 'standort.lageplan': true,
      'geraete.0.titel': '', 'geraete.0.seriennummer': '', 'geraete.0.eigentuemer': 'betreiber', 'geraete_tausch': true,
      'verguetung.modell': 'umsatz', 'verguetung.betrag': '', 'verguetung.prozent': '', 'verguetung.abrechnung': 'monat', 'verguetung.einsicht': true, 'verguetung.gutschrift': true,
      'strom.art': 'standort', 'strom.pauschale': '', 'strom.kwh': '', 'strom.preis': zahlText(ct / 100, 2), 'strom.anpassung': true, 'strom.stromsteuer': false,
      'betrieb.zugang': '', 'betrieb.reaktion': '', 'betrieb.ankuendigung': 'vier', 'betrieb.umfeld': 'standortgeber', 'betrieb.kuehlware': false,
      'laufzeit.beginn': '', 'laufzeit.art': 'unbefristet', 'laufzeit.mindest': '12', 'laufzeit.verlaengerung': '12', 'laufzeit.frist': '3', 'laufzeit.abbau': 'zwei',
      'laufzeit.umsatzAusstieg': false, 'laufzeit.umsatzSchwelle': '', 'laufzeit.umsatzMonate': '3', 'laufzeit.standortAusstieg': false,
      'haftung.nachweis': true, 'haftung.grob': true, 'haftung.plakette': true, 'haftung.pfandrecht': true,
      'sortiment.pfand': false, 'sortiment.rueckgabe': 'standortgeber', 'sortiment.rueckgabestelle': '',
      'jugend.tabak': false, 'jugend.alkohol': false,
      'zahlung.karte': true, 'zahlung.telemetrie': true, 'zahlung.kamera': false, 'zahlung.speicherdauer': '', 'zahlung.betriebsrat': false,
      'sortiment.mitsprache': false, 'sortiment.ausschluesse': '', 'sortiment.preisliste': false,
      'exklusiv.an': false, 'exklusiv.warengruppen': '', 'exklusiv.ausnahmen': '',
      'werbung.an': false, 'werbung.text': '',
      'schluss.ort': '', 'schluss.gerichtsstand': 'keiner', 'anlagen.pruefprotokoll': false, 'anlagen.registrierung': false, 'schluss.sonder': ''
    };
  }

  /* fiktive Parteien (kein reales Unternehmen), vollstaendig ausgefuellt */
  function vertragBeispiel(daten) {
    return mischeFlach(vertragStandard(daten), {
      'standortgeber.firma': 'Muster Logistik GmbH', 'standortgeber.anschrift': 'Musterweg 12, 12345 Musterstadt',
      'standortgeber.vertreter': 'die Gesch\u00e4ftsf\u00fchrerin Erika Mustermann', 'standortgeber.steuer': 'DE999999999', 'standortgeber.kaufmann': true,
      'standortgeber.ansprechpartner': 'Herr Max Beispiel, Haustechnik',
      'betreiber.firma': 'Beispiel Vending e. K.', 'betreiber.anschrift': 'Beispielstra\u00dfe 5, 12345 Musterstadt', 'betreiber.vertreter': 'den Inhaber Max Mustermann',
      'betreiber.steuer': '000/000/00000', 'betreiber.kaufmann': true, 'betreiber.telefon': '0123 456789',
      'standort.bereich': 'Halle 2, Pausenraum im Erdgeschoss', 'standort.breite': '120', 'standort.tiefe': '100', 'standort.lageplan': true,
      'geraete.0.titel': 'X10 Dual Screen Lite', 'geraete.0.seriennummer': 'SN-0000-0001', 'geraete.0.eigentuemer': 'betreiber',
      'verguetung.modell': 'umsatz', 'verguetung.prozent': '10', 'verguetung.abrechnung': 'monat',
      'strom.art': 'pauschale', 'strom.pauschale': '20,25', 'strom.kwh': '900',
      'betrieb.zugang': 'montags bis freitags von 6 bis 22 Uhr', 'betrieb.reaktion': '2',
      'laufzeit.beginn': '2026-11-01', 'laufzeit.art': 'befristet', 'laufzeit.mindest': '12', 'laufzeit.verlaengerung': '12', 'laufzeit.frist': '3',
      'laufzeit.umsatzAusstieg': true, 'laufzeit.umsatzSchwelle': '300', 'laufzeit.umsatzMonate': '3', 'laufzeit.standortAusstieg': true,
      'sortiment.pfand': true, 'sortiment.rueckgabe': 'standortgeber', 'sortiment.rueckgabestelle': 'Sammelbeh\u00e4lter am Empfang',
      'sortiment.mitsprache': true, 'sortiment.ausschluesse': 'Energydrinks', 'sortiment.preisliste': true,
      'exklusiv.an': true, 'exklusiv.warengruppen': 'Snacks und Kaltgetr\u00e4nke', 'exklusiv.ausnahmen': 'die Kantine und die Kaffeek\u00fcche des Standortgebers',
      'werbung.an': true, 'werbung.text': 'Folierung im Design des Betreibers, auf Wunsch mit dem Logo des Standortgebers',
      'schluss.ort': 'Musterstadt', 'schluss.gerichtsstand': 'standortgeber', 'anlagen.pruefprotokoll': true, 'anlagen.registrierung': true
    });
  }

  var BOOL_VERTRAG = ['standortgeber.kaufmann', 'betreiber.kaufmann', 'standort.lageplan', 'geraete_tausch', 'verguetung.einsicht', 'verguetung.gutschrift',
    'strom.anpassung', 'strom.stromsteuer', 'betrieb.kuehlware', 'laufzeit.umsatzAusstieg', 'laufzeit.standortAusstieg', 'haftung.nachweis', 'haftung.grob',
    'haftung.plakette', 'haftung.pfandrecht', 'sortiment.pfand', 'jugend.tabak', 'jugend.alkohol', 'zahlung.karte', 'zahlung.telemetrie', 'zahlung.kamera',
    'zahlung.betriebsrat', 'sortiment.mitsprache', 'sortiment.preisliste', 'exklusiv.an', 'werbung.an', 'anlagen.pruefprotokoll', 'anlagen.registrierung'];

  function wahl(wert, erlaubt, standard) {
    return erlaubt.indexOf(wert) !== -1 ? wert : standard;
  }

  function vertragDaten(werte) {
    var w = mischeFlach(vertragStandard(), werte);
    BOOL_VERTRAG.forEach(function (k) { w[k] = istJa(w[k]); });
    var d = ausFlach(w);
    d.geraeteTausch = istJa(w.geraete_tausch);
    d.geraete = (d.geraete || []).filter(function (g) { return g && typeof g === 'object'; }).map(function (g) {
      return { titel: txt(g.titel), seriennummer: txt(g.seriennummer), eigentuemer: wahl(g.eigentuemer, ['betreiber', 'leasing', 'vorbehalt'], 'betreiber') };
    });
    if (!d.geraete.length) d.geraete = [{ titel: '', seriennummer: '', eigentuemer: 'betreiber' }];
    d.verguetung.modell = wahl(d.verguetung.modell, ['fix', 'umsatz', 'misch', 'keine'], 'umsatz');
    d.strom.art = wahl(d.strom.art, ['standort', 'pauschale', 'zaehler', 'inklusive'], 'standort');
    d.laufzeit.art = wahl(d.laufzeit.art, ['unbefristet', 'befristet'], 'unbefristet');
    d.laufzeit.abbau = wahl(d.laufzeit.abbau, Object.keys(ABBAU), 'zwei');
    d.betrieb.ankuendigung = wahl(d.betrieb.ankuendigung, Object.keys(ANKUENDIGUNG), 'vier');
    d.betrieb.umfeld = wahl(d.betrieb.umfeld, ['standortgeber', 'betreiber'], 'standortgeber');
    d.sortiment.rueckgabe = wahl(d.sortiment.rueckgabe, ['standortgeber', 'betreiber'], 'standortgeber');
    d.schluss.gerichtsstand = wahl(d.schluss.gerichtsstand, ['keiner', 'betreiber', 'standortgeber'], 'keiner');
    return d;
  }

  function vertragKlauseln(werte) {
    var d = vertragDaten(werte);
    var ids = ['gegenstand', 'standort', 'aufstellung', 'strom', 'verguetung', 'betreiber'];
    if (d.betrieb.kuehlware) ids.push('hygiene');
    ids.push('standortgeber', 'zugang', 'sortiment');
    if (d.sortiment.pfand) ids.push('pfand');
    ids.push('zahlung');
    if (d.jugend.tabak || d.jugend.alkohol) ids.push('jugendschutz');
    ids.push('haftung', 'eigentum');
    if (d.exklusiv.an) ids.push('exklusiv');
    if (d.werbung.an) ids.push('werbung');
    ids.push('laufzeit', 'ende', 'nachfolge');
    if (txt(d.schluss.sonder)) ids.push('sonder');
    ids.push('schluss');
    return ids;
  }

  function vertragAnlagen(d) {
    var a = [{ id: 'geraete', titel: 'Ger\u00e4teliste' }];
    if (d.standort.lageplan) a.push({ id: 'lageplan', titel: 'Lageplan oder Foto der Stellfl\u00e4che' });
    if (d.sortiment.preisliste) a.push({ id: 'preisliste', titel: 'Sortiment und Preise' });
    if (d.haftung.nachweis) a.push({ id: 'versicherung', titel: 'Nachweis der Betriebshaftpflichtversicherung' });
    if (d.anlagen.pruefprotokoll) a.push({ id: 'pruefprotokoll', titel: 'Pr\u00fcfprotokoll der elektrischen Pr\u00fcfung' });
    if (d.anlagen.registrierung) a.push({ id: 'registrierung', titel: 'Best\u00e4tigung der Registrierung bei der Lebensmittel\u00fcberwachung' });
    return a;
  }

  function betrag(x) {
    var n = zahl(x);
    return isFinite(n) && n >= 0 ? euro(n, 2) : LUECKE + NBSP + '\u20ac';
  }

  function pz(x) {
    var n = zahl(x);
    return isFinite(n) && n >= 0 ? prozent(n) : LUECKE + NBSP + '%';
  }

  function monateAkk(x) {
    var n = ganz(x);
    if (!isFinite(n)) return LUECKE + ' Monate';
    return n === 1 ? '1 Monat' : zahlText(n) + ' Monate';
  }

  function monateDat(x) {
    var n = ganz(x);
    if (!isFinite(n)) return LUECKE + ' Monaten';
    return n === 1 ? '1 Monat' : zahlText(n) + ' Monaten';
  }

  function werktage(x) {
    var n = ganz(x);
    if (!isFinite(n)) return LUECKE + ' Werktagen';
    return n === 1 ? '1 Werktag' : zahlText(n) + ' Werktagen';
  }

  function anzahl(x) {
    var n = ganz(x);
    return isFinite(n) ? zahlText(n) : LUECKE;
  }

  function cm(x) {
    var n = zahl(x);
    return (isFinite(n) && n > 0 ? zahlText(n) : LUECKE) + NBSP + 'cm';
  }

  var KLAUSELN = {
    gegenstand: function (c) {
      var b = [
        absatz('Der Standortgeber gestattet dem Betreiber, die in ' + c.an('geraete') + ' aufgef\u00fchrten Warenautomaten (nachfolgend \u201eAutomaten\u201c) am Standort nach ' + c.nr('standort') + ' aufzustellen und zu betreiben.'),
        absatz('Die Parteien schlie\u00dfen einen Gestattungsvertrag \u00fcber die Aufstellung; eine Vermietung von R\u00e4umen oder Fl\u00e4chen ist nicht beabsichtigt.'),
        hinweis('Der Bundesgerichtshof ordnet Automatenaufstellvertr\u00e4ge als Gestattungsvertr\u00e4ge eigener Art mit mietrechtlichen Elementen ein (Urteil vom 07.10.2020, XII ZR 145/19). Welche Vorschriften des Mietrechts im Einzelfall gelten, h\u00e4ngt von der Gestaltung ab \u2013 anwaltlich pr\u00fcfen lassen.')
      ];
      if (c.d.geraeteTausch) b.push(absatz('Der Betreiber darf die Automaten gegen gleichwertige Ger\u00e4te austauschen oder um Ger\u00e4te derselben Art erg\u00e4nzen, soweit die Stellfl\u00e4che nach ' + c.nr('standort') + ' ausreicht. Er informiert den Standortgeber vorher in Textform und passt ' + c.an('geraete') + ' an.'));
      return b;
    },
    standort: function (c) {
      var s = c.d.standort;
      var ort = txt(s.anschrift) || txt(c.d.standortgeber.anschrift);
      var masse = 'Die Stellfl\u00e4che misst ca. ' + cm(s.breite) + ' in der Breite und ' + cm(s.tiefe) + ' in der Tiefe.';
      if (c.an('lageplan')) masse += ' Lage und Fl\u00e4che zeigt ' + c.an('lageplan') + '.';
      return [
        absatz('Standort ist ' + oder(ort) + (txt(s.bereich) ? ', ' + txt(s.bereich) : '') + '.'),
        absatz(masse),
        absatz('Eine Verlegung innerhalb des Geb\u00e4udes ist nur im gegenseitigen Einvernehmen zul\u00e4ssig.')
      ];
    },
    aufstellung: function () {
      return [
        absatz('Der Betreiber stellt die Automaten fachgerecht nach der Anleitung des Herstellers auf und sichert sie gegen Kippen, soweit der Hersteller eine Wand- oder Bodenbefestigung vorsieht. Bohrungen und Befestigungen nimmt er nur nach Absprache mit dem Standortgeber vor.'),
        absatz('Jeder Automat wird an eine eigene, geerdete Steckdose angeschlossen; Mehrfachsteckdosen und Verl\u00e4ngerungskabel werden nicht verwendet. Der vom Hersteller vorgegebene Wandabstand f\u00fcr die Bel\u00fcftung wird eingehalten, direkte Sonneneinstrahlung wird vermieden.'),
        absatz('Die Automaten verengen keine Flucht- und Rettungswege und stehen nicht in notwendigen Treppenr\u00e4umen.')
      ];
    },
    strom: function (c) {
      var st = c.d.strom;
      var mod = c.d.verguetung.modell;
      var art = st.art === 'inklusive' && mod !== 'fix' && mod !== 'misch' ? 'standort' : st.art;
      var b = [];
      if (art === 'pauschale') {
        var faellig = mod === 'keine' ? 'f\u00e4llig monatlich nachtr\u00e4glich bis zum Ende des Folgemonats' : 'f\u00e4llig mit der Standortverg\u00fctung nach ' + c.nr('verguetung');
        b.push(absatz('Der Standortgeber stellt den Strom f\u00fcr den Betrieb der Automaten bereit.'));
        b.push(absatz('Der Betreiber zahlt daf\u00fcr eine Strompauschale von ' + betrag(st.pauschale) + ' netto pro Monat zuz\u00fcglich der gesetzlichen Umsatzsteuer, ' + faellig + '.'));
        if (st.anpassung) b.push(absatz('\u00c4ndert sich der Strompreis des Standortgebers wesentlich, passen die Parteien die Pauschale auf Verlangen einer Seite an. Grundlage ist der Jahresverbrauch der Automaten laut Herstellerangabe.'));
      } else if (art === 'zaehler') {
        b.push(absatz('Der Standortgeber stellt den Strom f\u00fcr den Betrieb der Automaten bereit. Der Verbrauch wird \u00fcber einen eigenen Zwischenz\u00e4hler erfasst, den der Betreiber auf seine Kosten setzen l\u00e4sst.'));
        b.push(absatz('Abgerechnet wird j\u00e4hrlich zum Arbeitspreis des Standortgebers ohne Aufschlag. Verwendet wird nur ein Z\u00e4hler, der den Anforderungen des Mess- und Eichrechts entspricht und dessen Eichfrist nicht abgelaufen ist (\u00a7 33 MessEG).'));
      } else if (art === 'inklusive') {
        b.push(absatz('Der Standortgeber stellt den Strom f\u00fcr den Betrieb der Automaten bereit. Der Strom ist mit der Standortverg\u00fctung nach ' + c.nr('verguetung') + ' abgegolten.'));
      } else {
        b.push(absatz('Der Standortgeber stellt den Strom f\u00fcr den Betrieb der Automaten ohne gesonderte Verg\u00fctung bereit.'));
      }
      if (st.stromsteuer) b.push(hinweis('Nutzt der Standortgeber eine Entlastung von der Stromsteuer, etwa als Unternehmen des Produzierenden Gewerbes, muss der Strom f\u00fcr Automaten eines anderen Unternehmens unter Umst\u00e4nden gesondert erfasst werden (\u00a7 17b Abs. 4 StromStV) \u2013 mit Hauptzollamt oder Steuerberatung pr\u00fcfen.'));
      return b;
    },
    verguetung: function (c) {
      var v = c.d.verguetung;
      var b = [];
      if (v.modell === 'keine') {
        b.push(absatz('Eine Standortverg\u00fctung wird nicht vereinbart. Die Parteien sind sich einig, dass die Versorgung des Standorts mit Waren \u00fcber die Automaten den Vorteil des Standortgebers darstellt.'));
        return b;
      }
      var netto = 'Netto-Umsatz sind die Verkaufserl\u00f6se ohne Umsatzsteuer und ohne Pfandbetr\u00e4ge.';
      if (v.modell === 'fix') b.push(absatz('Der Betreiber zahlt dem Standortgeber eine monatliche Standortverg\u00fctung von ' + betrag(v.betrag) + ' netto zuz\u00fcglich der gesetzlichen Umsatzsteuer. Sie ist monatlich im Voraus bis zum dritten Werktag eines Monats f\u00e4llig.'));
      else if (v.modell === 'umsatz') b.push(absatz('Der Betreiber zahlt dem Standortgeber ' + pz(v.prozent) + ' des Netto-Umsatzes der Automaten am Standort zuz\u00fcglich der gesetzlichen Umsatzsteuer. ' + netto));
      else b.push(absatz('Der Betreiber zahlt dem Standortgeber einen monatlichen Grundbetrag von ' + betrag(v.betrag) + ' netto und zus\u00e4tzlich ' + pz(v.prozent) + ' des Netto-Umsatzes der Automaten am Standort, jeweils zuz\u00fcglich der gesetzlichen Umsatzsteuer. ' + netto));
      if (v.modell !== 'fix') {
        b.push(absatz('Abgerechnet wird ' + (v.abrechnung === 'quartal' ? 'quartalsweise' : 'monatlich') + ' auf Grundlage der Verkaufsdaten der Automaten aus Telemetrie oder Z\u00e4hlwerk. Abrechnung und Zahlung erfolgen bis zum Ende des Monats, der auf den Abrechnungszeitraum folgt.' + (v.modell === 'misch' ? ' Der Grundbetrag ist monatlich im Voraus bis zum dritten Werktag eines Monats f\u00e4llig.' : '')));
        if (v.einsicht) b.push(absatz('Der Standortgeber kann einmal im Kalenderjahr Einsicht in die Verkaufsdaten nehmen, die der Abrechnung zugrunde liegen.'));
      }
      if (v.gutschrift) {
        b.push(absatz('Der Betreiber rechnet durch Gutschrift ab; der Standortgeber ist damit einverstanden.'));
        b.push(hinweis('Gutschriften sind Rechnungen. F\u00fcr Rechnungen zwischen Unternehmen gelten schrittweise Pflichten zur elektronischen Rechnung \u2013 steuerlich pr\u00fcfen lassen.'));
      }
      b.push(absatz('Das Recht zur Aufstellung ist keine steuerfreie Vermietung eines Grundst\u00fccks (Abschnitt 4.12.6 Abs. 2 Nr. 14 UStAE). Ist der Standortgeber Kleinunternehmer nach \u00a7 19 UStG, wird keine Umsatzsteuer berechnet.'));
      return b;
    },
    betreiber: function (c) {
      var d = c.d;
      var b = [
        absatz('Der Betreiber bef\u00fcllt, reinigt und wartet die Automaten auf eigene Kosten und Gefahr, einschlie\u00dflich Ausgabefach und Produktlift. Bei jeder Bef\u00fcllung pr\u00fcft er Mindesthaltbarkeits- und Verbrauchsdaten.'),
        absatz('St\u00f6rungen beseitigt der Betreiber innerhalb von ' + werktage(d.betrieb.reaktion) + ' nach Meldung.')
      ];
      if (d.betrieb.umfeld === 'betreiber') b.push(absatz('Der Betreiber h\u00e4lt das Umfeld der Automaten sauber und entsorgt die Verpackungsabf\u00e4lle, die dort anfallen.'));
      b.push(absatz('Der Betreiber h\u00e4lt die f\u00fcr den Betrieb geltenden Vorschriften ein, insbesondere des Lebensmittelrechts, der Preisangabenverordnung, des Jugendschutzgesetzes und des Verpackungsrechts. Er registriert den Betrieb bei der f\u00fcr den Standort zust\u00e4ndigen Lebensmittel\u00fcberwachung' +
        (c.an('registrierung') ? '; die Best\u00e4tigung liegt als ' + c.an('registrierung') + ' bei.' : '.')));
      b.push(absatz('Er bringt die Angaben nach \u00a7 14 Abs. 3 GewO (Name mit mindestens einem ausgeschriebenen Vornamen oder Firma, ladungsf\u00e4hige Anschrift, Anschrift der Hauptniederlassung) sichtbar an jedem Automaten an.'));
      b.push(absatz('Der Betreiber l\u00e4sst die Automaten vor der ersten Inbetriebnahme und danach in regelm\u00e4\u00dfigen Abst\u00e4nden elektrisch pr\u00fcfen (DGUV Vorschrift 3) und legt das Pr\u00fcfprotokoll auf Verlangen vor' +
        (c.an('pruefprotokoll') ? '; das Protokoll der ersten Pr\u00fcfung liegt als ' + c.an('pruefprotokoll') + ' bei.' : '.')));
      return b;
    },
    hygiene: function () {
      return [
        absatz('Der Betreiber h\u00e4lt die K\u00fchltemperatur passend zur empfindlichsten Ware ein, etwa h\u00f6chstens +7 \u00b0C f\u00fcr belegte Br\u00f6tchen, Feinkost und Desserts, und \u00fcberwacht sie. F\u00e4llt die K\u00fchlung aus, sperrt er die Abgabe oder entnimmt die betroffene Ware.'),
        absatz('Der Standortgeber informiert den Betreiber unverz\u00fcglich \u00fcber Stromausf\u00e4lle oder Abschaltungen, von denen er Kenntnis erh\u00e4lt.')
      ];
    },
    standortgeber: function (c) {
      var d = c.d;
      var b = [
        absatz('Der Standortgeber stellt die Stellfl\u00e4che und den Stromanschluss zur Verf\u00fcgung und gew\u00e4hrt dem Betreiber und seinen Beauftragten zu den Zeiten nach ' + c.nr('zugang') + ' Zutritt.'),
        absatz('Er meldet St\u00f6rungen, Sch\u00e4den und Auff\u00e4lligkeiten an den Automaten unverz\u00fcglich unter der St\u00f6rungsnummer des Betreibers ' + oder(d.betreiber.telefon) + '.'),
        absatz('Er \u00f6ffnet die Automaten nicht, verstellt sie nicht und sch\u00fctzt sie im Rahmen seines Hausrechts vor Besch\u00e4digung.')
      ];
      if (d.betrieb.umfeld !== 'betreiber') b.push(absatz('Er h\u00e4lt das Umfeld der Automaten sauber.'));
      b.push(absatz('Bauliche \u00c4nderungen oder Renovierungen, die den Betrieb der Automaten beeintr\u00e4chtigen, k\u00fcndigt er mit einer Frist von ' + ANKUENDIGUNG[d.betrieb.ankuendigung] + ' an.'));
      return b;
    },
    zugang: function (c) {
      var d = c.d;
      return [
        absatz('Der Betreiber hat zu folgenden Zeiten Zugang zu den Automaten: ' + oder(d.betrieb.zugang) + '.'),
        absatz('Erforderliche Schl\u00fcssel oder Zugangskarten stellt der Standortgeber gegen Quittung zur Verf\u00fcgung; sie werden bei Vertragsende zur\u00fcckgegeben.'),
        absatz('Bei St\u00f6rungen, die Ware oder Sicherheit gef\u00e4hrden, erm\u00f6glicht der Standortgeber auch kurzfristig Zugang. Der Betreiber beachtet die Hausordnung des Standortgebers.'),
        absatz('Ansprechpartner des Standortgebers vor Ort ist ' + oder(d.standortgeber.ansprechpartner) + '.')
      ];
    },
    sortiment: function (c) {
      var s = c.d.sortiment;
      var b = [absatz('Der Betreiber bestimmt Sortiment und Verkaufspreise. Die Preise stehen als Endpreise einschlie\u00dflich Umsatzsteuer am Automaten.')];
      if (s.mitsprache) b.push(absatz('W\u00fcnsche des Standortgebers zum Sortiment ber\u00fccksichtigt der Betreiber nach M\u00f6glichkeit.' + (txt(s.ausschluesse) ? ' Nicht angeboten werden: ' + txt(s.ausschluesse) + '.' : '')));
      if (c.an('preisliste')) b.push(absatz('Sortiment und Preise zu Vertragsbeginn zeigt ' + c.an('preisliste') + '; \u00c4nderungen bleiben dem Betreiber vorbehalten.'));
      return b;
    },
    pfand: function (c) {
      var s = c.d.sortiment;
      var ruecknahme = 'Der Betreiber gew\u00e4hrleistet die R\u00fccknahme der Verpackungen in zumutbarer Entfernung zu den Automaten (\u00a7 46 Abs. 2 Satz 5 VerpackDG).';
      var b = [absatz('F\u00fcr Getr\u00e4nke in pfandpflichtigen Einwegverpackungen weist der Betreiber das Pfand getrennt vom Verkaufspreis aus (\u00a7 7 PAngV).')];
      if (s.rueckgabe === 'betreiber') b.push(absatz(ruecknahme + ' Er stellt die R\u00fcckgabem\u00f6glichkeit selbst: ' + oder(s.rueckgabestelle) + '.'));
      else b.push(absatz(ruecknahme + ' Der Standortgeber stellt daf\u00fcr eine R\u00fcckgabestelle zur Verf\u00fcgung: ' + oder(s.rueckgabestelle) + '. Nimmt der Standortgeber Verpackungen zur\u00fcck und zahlt das Pfand aus, erstattet ihm der Betreiber die ausgezahlten Pfandbetr\u00e4ge gegen \u00dcbergabe der Verpackungen.'));
      b.push(absatz('Am Automaten weist ein Hinweis auf die R\u00fcckgabestelle hin.'));
      b.push(hinweis('Was eine zumutbare Entfernung ist, legt das Verpackungsrecht nicht n\u00e4her fest; die R\u00fcckgabe direkt am Standort ist der sichere Weg \u2013 anwaltlich pr\u00fcfen lassen.'));
      return b;
    },
    zahlung: function (c) {
      var z = c.d.zahlung;
      var b = [];
      if (z.karte) b.push(absatz('Die Automaten nehmen Bargeld und bargeldlose Zahlungen an. F\u00fcr die Zahlung mit Karte erhebt der Betreiber gegen\u00fcber Verbrauchern keinen Aufschlag (\u00a7 270a BGB); es gilt ein Preis f\u00fcr alle Zahlarten.'));
      else b.push(absatz('Die Automaten nehmen Bargeld an. Bargeldlose Zahlungsarten kann der Betreiber jederzeit erg\u00e4nzen; einen Aufschlag f\u00fcr die Zahlung mit Karte erhebt er gegen\u00fcber Verbrauchern nicht (\u00a7 270a BGB).'));
      if (z.telemetrie) b.push(absatz('Die Automaten \u00fcbertragen Verkaufs- und St\u00f6rungsdaten \u00fcber eine eigene Mobilfunkverbindung des Betreibers. Eine Verbindung mit dem Netzwerk des Standortgebers ist nicht erforderlich.'));
      b.push(absatz('Die Verkaufsdaten enthalten keine personenbezogenen Daten. Personenbezogene Daten, etwa bei der Kartenzahlung, verarbeiten der Betreiber und sein Zahlungsdienstleister nach den geltenden Datenschutzvorschriften; am Automaten steht ein Datenschutzhinweis.'));
      if (z.kamera) {
        b.push(absatz('Der Betreiber darf den Automaten und seinen Ausgabebereich mit einer Kamera \u00fcberwachen. Er erfasst keine Arbeitspl\u00e4tze und keine Fl\u00e4chen \u00fcber den Ausgabebereich hinaus, weist vor dem Erfassungsbereich mit einem Hinweisschild auf die \u00dcberwachung hin (Art. 13 DSGVO) und speichert Aufnahmen nicht l\u00e4nger als ' + oder(z.speicherdauer) + '. Verantwortlich im Sinne des Datenschutzrechts ist der Betreiber.'));
        if (z.betriebsrat) b.push(absatz('Erfasst die Kamera Besch\u00e4ftigte des Standortgebers, bindet der Standortgeber vor der Inbetriebnahme seinen Betriebsrat ein.'));
        b.push(hinweis('Video\u00fcberwachung durch Private ist nur nach einer Abw\u00e4gung der Interessen zul\u00e4ssig (Art. 6 Abs. 1 lit. f DSGVO); sind Besch\u00e4ftigte erfasst, kommt die Mitbestimmung des Betriebsrats hinzu \u2013 anwaltlich pr\u00fcfen lassen.'));
      }
      b.push(hinweis('Wer im Einzelfall datenschutzrechtlich verantwortlich ist und ob ein Vertrag zur Auftragsverarbeitung n\u00f6tig ist, h\u00e4ngt von Zahlungssystem und Telemetrie ab \u2013 anwaltlich pr\u00fcfen lassen.'));
      return b;
    },
    jugendschutz: function (c) {
      var j = c.d.jugend;
      var b = [];
      if (j.tabak) b.push(absatz('Tabakwaren und andere nikotinhaltige Erzeugnisse einschlie\u00dflich E-Zigaretten bietet der Betreiber nur an, wenn eine technische Vorrichtung sicherstellt, dass Kinder und Jugendliche sie nicht entnehmen k\u00f6nnen (\u00a7 10 Abs. 2 und 4 JuSchG).'));
      if (j.alkohol) b.push(absatz('Bier, Wein, Sekt und Mischungen daraus bietet der Betreiber nur an, wenn der Automat an einem f\u00fcr Kinder und Jugendliche unzug\u00e4nglichen Ort steht oder in einem gewerblich genutzten Raum aufgestellt ist und eine technische Vorrichtung oder st\u00e4ndige Aufsicht sicherstellt, dass Kinder und Jugendliche sie nicht entnehmen k\u00f6nnen (\u00a7 9 Abs. 3 JuSchG). Spirituosen und \u00fcberwiegend alkoholhaltige Lebensmittel werden nicht angeboten (\u00a7 20 Nr. 1 GastG).'));
      b.push(absatz('Der Standortgeber stimmt dem Angebot dieser Waren zu. Der Betreiber stellt den Standortgeber von Anspr\u00fcchen Dritter frei, die auf einem Versto\u00df des Betreibers gegen den Jugendschutz beruhen.'));
      b.push(hinweis('Auch der Standortgeber kann wegen seiner Mitwirkung in die Verantwortung f\u00fcr den Jugendschutz einbezogen werden. Welche Absprachen ihn sch\u00fctzen, anwaltlich pr\u00fcfen lassen.'));
      return b;
    },
    haftung: function (c) {
      var h = c.d.haftung;
      var b = [absatz('Der Betreiber haftet f\u00fcr Sch\u00e4den, die durch die Automaten oder ihren Betrieb entstehen, und stellt den Standortgeber insoweit von Anspr\u00fcchen Dritter frei.')];
      if (h.nachweis) b.push(absatz('Der Betreiber unterh\u00e4lt f\u00fcr die Dauer des Vertrags eine Betriebshaftpflichtversicherung, die auch Sch\u00e4den durch die verkauften Waren umfasst. Den Nachweis legt er als ' + c.an('versicherung') + ' bei und auf Verlangen erneut vor.'));
      if (h.grob) b.push(absatz('Der Standortgeber haftet f\u00fcr Sch\u00e4den an den Automaten nur bei Vorsatz oder grober Fahrl\u00e4ssigkeit. Sch\u00e4den durch Vandalismus oder Diebstahl tr\u00e4gt der Betreiber.'));
      else b.push(absatz('Sch\u00e4den durch Vandalismus oder Diebstahl tr\u00e4gt der Betreiber, soweit der Standortgeber sie nicht zu vertreten hat.'));
      b.push(hinweis('Haftungsregeln in vorformulierten Vertr\u00e4gen unterliegen der Inhaltskontrolle (\u00a7 307 BGB) \u2013 anwaltlich pr\u00fcfen lassen.'));
      return b;
    },
    eigentum: function (c) {
      var d = c.d;
      var arten = [];
      d.geraete.forEach(function (g) {
        var n = EIGENTUEMER[g.eigentuemer];
        if (g.eigentuemer !== 'betreiber' && arten.indexOf(n) === -1) arten.push(n);
      });
      var wem = arten.length ? 'des Betreibers bzw. des in ' + c.an('geraete') + ' genannten Eigent\u00fcmers (' + arten.join(' oder ') + ')' : 'des Betreibers';
      var b = [absatz('Die Automaten bleiben Eigentum ' + wem + '. Sie werden nur zu einem vor\u00fcbergehenden Zweck aufgestellt.')];
      if (d.haftung.plakette) b.push(absatz('Der Betreiber kennzeichnet jeden Automaten mit einer Eigentumsplakette.'));
      b.push(absatz('Pf\u00e4ndet ein Gl\u00e4ubiger des Standortgebers einen Automaten oder wird \u00fcber das Verm\u00f6gen des Standortgebers ein Insolvenzverfahren er\u00f6ffnet, weist der Standortgeber den Gerichtsvollzieher oder den Insolvenzverwalter auf das fremde Eigentum hin und informiert den Betreiber unverz\u00fcglich.'));
      if (d.haftung.pfandrecht) {
        b.push(absatz('Der Standortgeber verzichtet auf ein etwaiges Vermieterpfandrecht an den Automaten, den Waren und den Geldbest\u00e4nden darin.'));
        b.push(hinweis('Ob dem Standortgeber bei einem Aufstellungsvertrag ein Vermieterpfandrecht nach \u00a7 562 BGB zusteht, ist nicht abschlie\u00dfend gekl\u00e4rt; der Verzicht schafft Klarheit \u2013 anwaltlich pr\u00fcfen lassen.'));
      }
      return b;
    },
    exklusiv: function (c) {
      var e = c.d.exklusiv;
      var b = [absatz('W\u00e4hrend der Vertragslaufzeit stellt der Standortgeber am Standort keine weiteren Automaten f\u00fcr ' + oder(e.warengruppen) + ' auf und gestattet dies auch Dritten nicht.')];
      if (txt(e.ausnahmen)) b.push(absatz('Ausgenommen sind ' + txt(e.ausnahmen) + '.'));
      b.push(absatz('Die Exklusivit\u00e4t endet mit dem Vertrag.'));
      b.push(hinweis('Exklusivit\u00e4tsklauseln in vorformulierten Vertr\u00e4gen unterliegen der Inhaltskontrolle (\u00a7 307 BGB); Warengruppen und Bereich eng fassen \u2013 anwaltlich pr\u00fcfen lassen.'));
      return b;
    },
    werbung: function (c) {
      var w = c.d.werbung;
      var b = [];
      if (txt(w.text)) b.push(absatz('Gestaltung der Automaten: ' + txt(w.text) + '.'));
      b.push(absatz('Werbefl\u00e4chen an den Automaten nutzt der Betreiber f\u00fcr sein Sortiment; Werbung Dritter bringt er nur mit Zustimmung des Standortgebers an. Erforderliche Genehmigungen f\u00fcr Werbeanlagen holt der Betreiber ein.'));
      return b;
    },
    laufzeit: function (c) {
      var l = c.d.laufzeit;
      var mod = c.d.verguetung.modell;
      var beginn = datumText(l.beginn) || LUECKE;
      var b = [];
      if (l.art === 'befristet') {
        b.push(absatz('Der Vertrag beginnt am ' + beginn + ' und l\u00e4uft zun\u00e4chst ' + monateAkk(l.mindest) + '. Er verl\u00e4ngert sich jeweils um ' + monateAkk(l.verlaengerung) + ', wenn ihn keine Partei mit einer Frist von ' + monateDat(l.frist) + ' zum Ende der Laufzeit k\u00fcndigt.'));
        b.push(hinweis('Lange Mindestlaufzeiten mit automatischer Verl\u00e4ngerung hat der Bundesgerichtshof in einem vorformulierten Automatenaufstellvertrag ohne ausgleichende Vorteile f\u00fcr unwirksam gehalten (Urteil vom 07.10.2020, XII ZR 145/19). Laufzeit ma\u00dfvoll w\u00e4hlen und anwaltlich pr\u00fcfen lassen.'));
      } else {
        b.push(absatz('Der Vertrag beginnt am ' + beginn + ' und l\u00e4uft auf unbestimmte Zeit. Er kann von jeder Partei mit einer Frist von ' + monateDat(l.frist) + ' zum Monatsende gek\u00fcndigt werden.'));
      }
      if (l.umsatzAusstieg) b.push(absatz('Der Betreiber kann mit einer Frist von einem Monat zum Monatsende k\u00fcndigen, wenn der Netto-Umsatz der Automaten am Standort in ' + anzahl(l.umsatzMonate) + ' aufeinanderfolgenden Monaten unter ' + betrag(l.umsatzSchwelle) + ' netto je Monat liegt.'));
      if (l.standortAusstieg) b.push(absatz('Der Standortgeber kann mit einer Frist von einem Monat zum Monatsende k\u00fcndigen, wenn er seinen Betrieb am Standort aufgibt oder verlegt.'));
      b.push(absatz('Das Recht zur fristlosen K\u00fcndigung aus wichtigem Grund bleibt unber\u00fchrt. Ein wichtiger Grund liegt insbesondere vor, wenn eine Partei trotz Abmahnung wiederholt gegen wesentliche Pflichten verst\u00f6\u00dft' +
        (mod === 'fix' || mod === 'misch' ? ' oder der Betreiber mit zwei Monatsbetr\u00e4gen der Standortverg\u00fctung in Verzug ist.' : '.')));
      b.push(absatz('K\u00fcndigungen bed\u00fcrfen der Textform.'));
      return b;
    },
    ende: function (c) {
      return [
        absatz('Nach Vertragsende baut der Betreiber die Automaten ' + ABBAU[c.d.laufzeit.abbau] + ' ab und holt sie auf eigene Kosten ab.'),
        absatz('Er \u00fcbergibt die Stellfl\u00e4che besenrein und beseitigt Befestigungen und Bohrl\u00f6cher auf eigene Kosten, sodass der urspr\u00fcngliche Zustand wiederhergestellt ist.'),
        absatz('Die Parteien rechnen offene Betr\u00e4ge innerhalb eines Monats nach Vertragsende ab. \u00dcberlassene Schl\u00fcssel und Zugangsmittel werden zur\u00fcckgegeben.')
      ];
    },
    nachfolge: function () {
      return [
        absatz('Der Betreiber darf den Vertrag nur mit Zustimmung des Standortgebers auf einen anderen Betreiber \u00fcbertragen; der Standortgeber verweigert die Zustimmung nur aus wichtigem Grund.'),
        absatz('Ver\u00e4u\u00dfert der Standortgeber seinen Betrieb oder gibt er den Standort auf, informiert er den Betreiber unverz\u00fcglich und wirkt darauf hin, dass ein Nachfolger in den Vertrag eintritt.'),
        hinweis('Regeln zur Rechtsnachfolge wirken gegen\u00fcber einem Erwerber nicht ohne Weiteres \u2013 anwaltlich pr\u00fcfen lassen.')
      ];
    },
    sonder: function (c) {
      return [absatz(txt(c.d.schluss.sonder))];
    },
    schluss: function (c) {
      var d = c.d;
      var b = [
        absatz('\u00c4nderungen und Erg\u00e4nzungen dieses Vertrags bed\u00fcrfen der Textform. M\u00fcndliche Nebenabreden bestehen nicht.'),
        absatz('Sollte eine Bestimmung unwirksam sein oder werden, bleibt der Vertrag im \u00dcbrigen wirksam.'),
        absatz('Es gilt das Recht der Bundesrepublik Deutschland.')
      ];
      var g = d.schluss.gerichtsstand;
      if (g !== 'keiner') {
        if (d.betreiber.kaufmann && d.standortgeber.kaufmann) b.push(absatz('Gerichtsstand f\u00fcr alle Streitigkeiten aus diesem Vertrag ist der Sitz des ' + (g === 'betreiber' ? 'Betreibers' : 'Standortgebers') + '.'));
        else b.push(hinweis('Ein Gerichtsstand wurde nicht vereinbart: Gerichtsstandsvereinbarungen sind nur unter Kaufleuten wirksam (\u00a7 38 ZPO). Ob beide Parteien Kaufleute sind, pr\u00fcfen lassen.'));
      }
      return b;
    }
  };

  function partei(rolle, p) {
    var z = [oder(p.firma), oder(p.anschrift)];
    if (txt(p.vertreter)) z.push('vertreten durch ' + txt(p.vertreter));
    /* Laenderkennung vorn (DE123...) = Umsatzsteuer-Identifikationsnummer, sonst Steuernummer */
    var st = txt(p.steuer);
    if (st) z.push((/^[A-Za-z]{2}\s?[0-9A-Za-z]/.test(st) ? 'USt-IdNr. ' : 'Steuernummer ') + st);
    return { art: 'partei', rolle: rolle, zeilen: z };
  }

  function vertrag(werte, kontext) {
    var d = vertragDaten(werte);
    var k = kontextTexte(kontext, 'vertrag');
    var ids = vertragKlauseln(werte);
    var anlagen = vertragAnlagen(d);
    var nrs = {};
    var an = {};
    ids.forEach(function (id, i) { nrs[id] = '\u00a7 ' + (i + 1); });
    anlagen.forEach(function (a, i) { an[a.id] = 'Anlage ' + (i + 1); });
    var c = { d: d, nr: function (id) { return nrs[id]; }, an: function (id) { return an[id]; } };
    var anlageBloecke = {
      geraete: function () {
        return [tabelle('', ['Nr.', 'Ger\u00e4t', 'Seriennummer', 'Eigent\u00fcmer'], d.geraete.map(function (g, i) {
          return [String(i + 1), oder(g.titel), oder(g.seriennummer), EIGENTUEMER[g.eigentuemer]];
        }), [0])];
      },
      lageplan: function () { return [absatz('Lageplan oder Foto mit Lage und Ma\u00dfen der Stellfl\u00e4che, von beiden Parteien abgezeichnet.')]; },
      preisliste: function () { return [absatz('Sortiment und Verkaufspreise zu Vertragsbeginn, Stand bei Unterzeichnung.')]; },
      versicherung: function () { return [absatz('Kopie der Versicherungsbest\u00e4tigung des Betreibers.')]; },
      pruefprotokoll: function () { return [absatz('Protokoll der elektrischen Pr\u00fcfung vor der ersten Inbetriebnahme (DGUV Vorschrift 3).')]; },
      registrierung: function () { return [absatz('Best\u00e4tigung der f\u00fcr den Standort zust\u00e4ndigen Lebensmittel\u00fcberwachung.')]; }
    };
    return {
      werkzeug: 'vertrag',
      titel: TEXTE.titel.vertrag,
      untertitel: k.kurz,
      kopf: [{ art: 'zeile', text: 'zwischen' }, partei('Standortgeber', d.standortgeber), { art: 'zeile', text: 'und' }, partei('Betreiber', d.betreiber)],
      abschnitte: ids.map(function (id) { return { id: id, nr: nrs[id], titel: KLAUSEL_TITEL[id], bloecke: nummeriere(KLAUSELN[id](c)) }; }),
      anlagen: anlagen.map(function (a) { return { id: a.id, nr: an[a.id], titel: a.titel, bloecke: anlageBloecke[a.id]() }; }),
      unterschriften: [
        { rolle: 'Standortgeber', name: oder(d.standortgeber.firma), ort: txt(d.schluss.ort) },
        { rolle: 'Betreiber', name: oder(d.betreiber.firma), ort: txt(d.schluss.ort) }
      ],
      rechtshinweis: k.rechtshinweis,
      stand: k.stand
    };
  }

  /* Jahresverbrauch aus einer Energieangabe wie "C \u00b7 869 kWh/Jahr (Kategorie 3)" oder "1.330 kWh/Jahr" */
  function kwhAus(text) {
    var m = /(\d{1,3}(?:\.\d{3})+|\d+)(?:,\d+)?\s*kWh/i.exec(String(text || ''));
    if (!m) return null;
    var n = zahl(m[0].replace(/\s*kWh/i, ''));
    return isFinite(n) && n > 0 ? n : null;
  }

  /* Strompauschale pro Monat = kWh im Jahr x Preis je kWh / 12, auf Cent gerundet */
  function stromPauschale(kwh, preis) {
    var k = zahl(kwh);
    var p = zahl(preis);
    if (!(isFinite(k) && k > 0 && isFinite(p) && p > 0)) return null;
    return Math.round(k * p / 12 * 100) / 100;
  }

  /* ------------------------------------------------------------------ Businessplan */

  var SCHWERPUNKT = { snack: 'Snacks', getraenke: 'Getr\u00e4nke', kombi: 'Snacks und Getr\u00e4nke', kaffee: 'Kaffee und Hei\u00dfgetr\u00e4nke', tiefkuehl: 'Tiefk\u00fchlware oder Eis' };
  var RECHTSFORM = { einzel: 'Einzelunternehmen', gbr: 'Gesellschaft b\u00fcrgerlichen Rechts (GbR)', ug: 'Unternehmergesellschaft (haftungsbeschr\u00e4nkt)', gmbh: 'GmbH' };
  var FINANZIERUNG_NAME = { kauf: 'Kauf', leasing: 'Leasing', miete: 'Miete' };
  var RISIKEN = [
    { id: 'standort', text: 'Verlust oder K\u00fcndigung eines Standorts', mittel: 'mehrere Standorte, ma\u00dfvolle Laufzeiten, Sonderk\u00fcndigungsrecht bei geringem Umsatz im Aufstellungsvertrag' },
    { id: 'vandalismus', text: 'Vandalismus und Aufbruch', mittel: 'gesch\u00fctzter Stellplatz, Befestigung, wenig Bargeld im Ger\u00e4t, Automatenversicherung' },
    { id: 'energie', text: 'Steigende Energiepreise', mittel: 'Strompauschale oder Z\u00e4hler im Aufstellungsvertrag, Temperatur an die Ware anpassen' },
    { id: 'regulierung', text: 'Neue Regeln, etwa im Verpackungsrecht, eine geplante Pflicht zur digitalen Zahlung oder eine Altersgrenze f\u00fcr Energydrinks', mittel: 'Kartenzahlung von Anfang an, Sortiment flexibel halten' },
    { id: 'technik', text: 'Ausfall von K\u00fchlung oder Zahlungssystem', mittel: 'Telemetrie mit Alarm, R\u00fccklage f\u00fcr Wartung, Ersatzteile und Service' },
    { id: 'wettbewerb', text: 'Kantine, Kiosk oder Supermarkt in der N\u00e4he', mittel: 'Sortiment und Zugangszeiten auf die Versorgungsl\u00fccken abstimmen' }
  ];

  function annahmenAus(daten) {
    var a = kopie(ANNAHMEN_STANDARD);
    var q = (daten && daten.annahmen) || {};
    Object.keys(a).forEach(function (k) {
      if (k === 'miete') { if (q.miete === 'fix' || q.miete === 'prozent') a.miete = q.miete; }
      else if (typeof q[k] === 'number' && isFinite(q[k])) a[k] = q[k];
    });
    return a;
  }

  function reiterAus(daten) {
    var r = {};
    var q = (daten && daten.reiter) || {};
    Object.keys(REITER_STANDARD).forEach(function (id) {
      var s = REITER_STANDARD[id];
      var d = q[id] || {};
      r[id] = {
        verkaeufe: typeof d.verkaeufe === 'number' ? d.verkaeufe : s.verkaeufe,
        preis: typeof d.preis === 'number' ? d.preis : s.preis,
        tage: typeof d.tage === 'number' ? d.tage : s.tage
      };
    });
    return r;
  }

  function geraetAus(daten) {
    var g = (daten && daten.geraet) || {};
    return { name: txt(g.name) || GERAET_STANDARD.name, preis: typeof g.preis === 'number' && g.preis > 0 ? g.preis : GERAET_STANDARD.preis };
  }

  function standortZeile(i, typ, daten, extra) {
    var r = reiterAus(daten)[typ];
    var p = 'standorte.' + i + '.';
    var z = {};
    z[p + 'name'] = '';
    z[p + 'typ'] = typ;
    z[p + 'verkaeufe'] = feldZahl(r.verkaeufe);
    z[p + 'preis'] = feldZahl(r.preis);
    z[p + 'tage'] = feldZahl(r.tage);
    z[p + 'start'] = '1';
    z[p + 'geraet'] = 'standard';
    z[p + 'geraetPreis'] = feldZahl(geraetAus(daten).preis);
    z[p + 'finanzierung'] = 'kauf';
    z[p + 'rate'] = '';
    z[p + 'laufzeit'] = '';
    return mischeFlach(z, extra);
  }

  /* Jahre der Abschreibung aus dem Datenblock (Settings afa_jahre, afa_jahre_getraenke), sonst die Konstanten */
  function afaJahreAus(daten) {
    var gueltig = function (x, ersatz) { return typeof x === 'number' && x >= 1 ? x : ersatz; };
    return { waren: gueltig(daten && daten.afaJahre, AFA_JAHRE), getraenke: gueltig(daten && daten.afaJahreGetraenke, AFA_JAHRE_GETRAENKE) };
  }

  /* Typ des gewaehlten Geraets ('handle:variantId') aus dem Datenblock; Standardgeraet und eigener Preis ohne Typ */
  function geraetTypVon(wahl, daten) {
    var t = String(wahl || '').split(':');
    if (t.length < 2) return '';
    var liste = (daten && daten.geraete) || [];
    for (var i = 0; i < liste.length; i++) if (liste[i] && liste[i].handle === t[0]) return String(liste[i].typ || '');
    return '';
  }

  /* Getraenkeautomat im Sinne der AfA-Tabelle AV 7.4.1 (Paket H, 13.10.2026, _docs/h-vorlagen-recht.md; Rechtspruefung
     vom 12.10.2026, Abschnitt 6, Antwort 58 = 123): Geraetetyp getraenke, Kaffee- und Heissgetraenkeautomaten (Typ
     kaffee; Lesart: Heissgetraenke sind Getraenke, die Tabelle nennt sie nicht eigens) und die UnoCool-Baureihe
     (Handles sandenvendo-unocool*, Typ tisch). Nur Geraete aus dem Datenblock: Standardgeraet und eigener Preis bleiben
     Warenautomaten (AV 7.4.2). */
  function afaGetraenkeGeraet(wahl, daten) {
    var typ = geraetTypVon(wahl, daten);
    if (typ === 'getraenke' || typ === 'kaffee') return true;
    return typ !== '' && /^sandenvendo-unocool/.test(String(wahl || '').split(':')[0]);
  }

  /* AfA-Vorschlag je Geraetetyp (Paket K-2, Recherche 2.3 mit Q7; offen ist laut Abschnitt 6 Nr. 5 nur der Kombi-Automat):
     sieben Jahre, wenn alle gekauften Geraete reine Getraenkeautomaten sind (AV 7.4.1), sonst fuenf (AV 7.4.2
     Warenautomaten: Snack, Kombi, Standardgeraet, eigener Preis; gemischte Plaene vorsichtig einheitlich). Geleaste und
     gemietete Geraete schreibt der Plan nicht ab. Vorbelegung des Felds investition.afaJahre, vom Nutzer aenderbar.
     Seit Paket H zaehlen auch Kaffee- und Heissgetraenkeautomaten und die UnoCool-Baureihe als Getraenkeautomaten
     (afaGetraenkeGeraet). */
  function afaVorschlag(werte, daten) {
    var j = afaJahreAus(daten);
    var d = ausFlach(werte || {});
    var gekauft = (d.standorte || []).filter(function (x) { return x && x.finanzierung !== 'leasing' && x.finanzierung !== 'miete'; });
    if (!gekauft.length) return j.waren;
    for (var i = 0; i < gekauft.length; i++) if (!afaGetraenkeGeraet(gekauft[i].geraet, daten)) return j.waren;
    return j.getraenke;
  }

  function planStandard(daten) {
    var a = annahmenAus(daten);
    var afa = afaJahreAus(daten).waren;
    var w = mischeFlach({
      'vorhaben.name': '', 'vorhaben.beschreibung': '', 'vorhaben.ziel': '', 'vorhaben.start': '',
      'gruender.name': '', 'gruender.qualifikation': '', 'gruender.erwerb': 'haupt', 'gruender.rechtsform': 'einzel', 'gruender.steuer': 'regel',
      'sortiment.schwerpunkt': 'kombi', 'sortiment.beschreibung': '', 'sortiment.preise': '', 'annahmen.mwst': feldZahl(a.mwst),
      'annahmen.wareneinsatz': feldZahl(a.wareneinsatz), 'annahmen.grundkosten': feldZahl(a.grundkosten), 'annahmen.karteFix': feldZahl(a.karteFix),
      'annahmen.karteProzent': feldZahl(a.karteProzent), 'annahmen.kartenanteil': feldZahl(a.kartenanteil), 'annahmen.miete': a.miete,
      'annahmen.mieteProzent': feldZahl(a.mieteProzent), 'annahmen.mieteFix': feldZahl(a.mieteFix), 'kosten.weitere': '0', 'kosten.weitereText': '',
      'investition.zubehoer': '0', 'investition.zubehoerText': '', 'investition.gruendung': '0', 'investition.reserve': '0', 'investition.afaJahre': feldZahl(afa),
      'finanzierung.eigenkapital': '0', 'finanzierung.kredit': '0', 'finanzierung.zins': '', 'finanzierung.laufzeit': '60', 'finanzierung.tilgungsfrei': '0',
      'finanzierung.geber': '',
      'risiken.standort': true, 'risiken.vandalismus': true, 'risiken.energie': true, 'risiken.regulierung': true, 'risiken.technik': true,
      'risiken.wettbewerb': true, 'risiken.massnahmen': ''
    }, standortZeile(0, 'produktion', daten));
    w['investition.afaJahre'] = feldZahl(afaVorschlag(w, daten));
    return w;
  }

  function planBeispiel(daten) {
    var w = mischeFlach(planStandard(daten), {
      'vorhaben.name': 'Automatenversorgung f\u00fcr Betriebe in Musterstadt',
      'vorhaben.beschreibung': 'Snack- und Getr\u00e4nkeautomaten mit Kartenzahlung f\u00fcr Betriebe mit Schichtbetrieb und B\u00fcros, betreut im Nebenerwerb.',
      'vorhaben.ziel': 'Zwei Standorte im ersten Jahr, danach weitere Betriebe in der Region; Bef\u00fcllung zweimal pro Woche.',
      'vorhaben.start': 'Januar des kommenden Jahres',
      'gruender.name': 'Erika Mustermann', 'gruender.qualifikation': 'Kauffrau im Einzelhandel, Erfahrung mit Warenwirtschaft und Kassenabrechnung; Hygieneschulung geplant.',
      'gruender.erwerb': 'neben',
      'sortiment.beschreibung': 'Riegel, Chips, N\u00fcsse und Kaltgetr\u00e4nke in Einwegflaschen mit Pfand; keine Alterswaren.',
      'sortiment.preise': 'Preise leicht \u00fcber dem Supermarkt, ein Preis f\u00fcr Bargeld und Karte.',
      'kosten.weitere': '50', 'kosten.weitereText': 'Fahrtkosten f\u00fcr Bef\u00fcllung und Service',
      'investition.gruendung': '50', 'investition.reserve': '1000', 'finanzierung.eigenkapital': '13000',
      'risiken.massnahmen': 'Zweiten Standort erst nach drei Monaten, Kartenzahlung von Anfang an, Versicherung gegen Aufbruch.'
    });
    w = mischeFlach(w, standortZeile(0, 'produktion', daten, { 'standorte.0.name': 'Produktionsbetrieb im Gewerbegebiet' }));
    return mischeFlach(w, standortZeile(1, 'buero', daten, { 'standorte.1.name': 'B\u00fcrogeb\u00e4ude am Bahnhof', 'standorte.1.start': '4' }));
  }

  function geraeteName(wahlWert, daten) {
    if (wahlWert === 'standard' || !wahlWert) return geraetAus(daten).name;
    if (wahlWert === 'eigen') return TEXTE.ui.eigenesGeraetName;
    var t = String(wahlWert).split(':');
    var liste = (daten && daten.geraete) || [];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].handle !== t[0]) continue;
      for (var j = 0; j < (liste[i].varianten || []).length; j++) {
        var v = liste[i].varianten[j];
        if (String(v.id) === t[1]) return liste[i].title + (v.titel ? ' \u2013 ' + v.titel : '');
      }
    }
    return TEXTE.ui.eigenesGeraetName;
  }

  function globaleRechne() {
    if (typeof window !== 'undefined' && window.__mvSortiment && window.__mvSortiment.rechner && typeof window.__mvSortiment.rechner.rechne === 'function') return window.__mvSortiment.rechner.rechne;
    return null;
  }

  var PLAN_FELDER = ['umsatzBrutto', 'umsatzNetto', 'ware', 'karte', 'miete', 'grundkosten', 'leasing', 'weitere', 'gruendung', 'afa', 'zinsen', 'ergebnis',
    'investition', 'tilgung', 'einzahlungFinanzierung', 'saldo'];

  /* 36 Monate: je Standort rechne() aus rechner.js (Umsatz brutto, Nettoumsatz, Ware, Karte, Miete, Grundkosten),
     dazu Leasing- und Mietraten, weitere Kosten, Gruendungskosten, Abschreibung (linear), Kredit (Zinsen auf die
     Restschuld, lineare Tilgung nach tilgungsfreien Monaten); Liquiditaet ohne Abschreibung, mit Investitionen. */
  function rechnePlan(werte, kontext) {
    var k = kontext || {};
    var rechne = k.rechne || globaleRechne();
    if (typeof rechne !== 'function') throw new Error('rechne() aus assets/mv-sortiment.rechner.js fehlt');
    var daten = k.daten || null;
    var w = mischeFlach(planStandard(daten), werte);
    var d = ausFlach(w);
    var hinweise = [];
    var ust = d.gruender.steuer !== 'klein';
    var a = {
      wareneinsatz: zahl(d.annahmen.wareneinsatz), grundkosten: zahl(d.annahmen.grundkosten), karteFix: zahl(d.annahmen.karteFix),
      karteProzent: zahl(d.annahmen.karteProzent), kartenanteil: zahl(d.annahmen.kartenanteil), miete: d.annahmen.miete === 'fix' ? 'fix' : 'prozent',
      mieteProzent: zahl(d.annahmen.mieteProzent), mieteFix: zahl(d.annahmen.mieteFix), mwst: zahl(d.annahmen.mwst), ustAbziehen: ust
    };
    var afaJahre = zahl(d.investition.afaJahre);
    if (!(afaJahre >= 1)) {
      afaJahre = afaVorschlag(w, daten);
      hinweise.push('Abschreibung: Jahre fehlen \u2013 gerechnet mit ' + afaJahre + ' Jahren (Vorschlag je Ger\u00e4tetyp).');
    }
    var afaMonate = Math.round(afaJahre * 12);
    var faktor = ust ? 1 : 1 + UST_GERAET / 100;
    var standorte = (d.standorte || []).map(function (s, i) {
      var nr = i + 1;
      var start = Math.round(zahl(s.start));
      if (!(start >= 1)) start = 1;
      var r = rechne({ verkaeufe: zahl(s.verkaeufe), preis: zahl(s.preis), tage: zahl(s.tage), geraetPreis: 0 }, a);
      if (!r) hinweise.push('Standort ' + nr + ': Verk\u00e4ufe, Preis, Verkaufstage oder Annahmen sind unvollst\u00e4ndig \u2013 der Standort z\u00e4hlt nicht.');
      var fin = s.finanzierung === 'leasing' || s.finanzierung === 'miete' ? s.finanzierung : 'kauf';
      var preis = zahl(s.geraetPreis);
      if (!(preis >= 0)) {
        preis = 0;
        if (fin === 'kauf' && r) hinweise.push('Standort ' + nr + ': Der Ger\u00e4tepreis fehlt.');
      }
      var rate = fin !== 'kauf' ? positiv(s.rate) : 0;
      var laufzeit = fin !== 'kauf' ? Math.round(zahl(s.laufzeit)) : 0;
      if (fin !== 'kauf' && !(laufzeit >= 1)) laufzeit = MONATE;
      if (fin !== 'kauf' && r && rate === 0) hinweise.push('Standort ' + nr + ': Die Rate f\u00fcr ' + FINANZIERUNG_NAME[fin] + ' fehlt.');
      var kosten = fin === 'kauf' ? preis * faktor : 0;
      var schwelle = null;
      if (r) {
        var r0 = rechne({ verkaeufe: 0, preis: zahl(s.preis), tage: zahl(s.tage), geraetPreis: 0 }, a);
        var r1 = rechne({ verkaeufe: 1, preis: zahl(s.preis), tage: zahl(s.tage), geraetPreis: 0 }, a);
        var db = r1.ueberschuss - r0.ueberschuss;
        var fixKosten = -r0.ueberschuss + (fin === 'kauf' ? kosten / afaMonate : rate);
        if (db > 0) schwelle = fixKosten / db;
      }
      return {
        nr: nr, name: txt(s.name) || TEXTE.ui.standortTitel + ' ' + nr, typ: TYP_NAME[s.typ] ? s.typ : 'produktion', verkaeufe: zahl(s.verkaeufe), preis: zahl(s.preis),
        tage: zahl(s.tage), start: start, aktiv: !!r && start <= MONATE, r: r, finanzierung: fin, rate: rate, laufzeit: laufzeit, kosten: kosten,
        geraet: geraeteName(s.geraet, daten), schwelle: schwelle
      };
    });
    var zub = positiv(d.investition.zubehoer) * faktor;
    var gruendung = positiv(d.investition.gruendung);
    var reserve = positiv(d.investition.reserve);
    var weitere = positiv(d.kosten.weitere);
    var ek = positiv(d.finanzierung.eigenkapital);
    var kredit = positiv(d.finanzierung.kredit);
    var zinsSatz = zahl(d.finanzierung.zins);
    var zinsOk = isFinite(zinsSatz) && zinsSatz >= 0;
    if (kredit > 0 && !zinsOk) hinweise.push('Kredit ohne Zinssatz: Zinsen sind nicht ber\u00fccksichtigt \u2013 tragen Sie den Zinssatz Ihrer Hausbank ein.');
    var i = zinsOk ? zinsSatz / 100 / 12 : 0;
    var lz = Math.round(zahl(d.finanzierung.laufzeit));
    if (!(lz >= 1)) lz = 60;
    var tf = Math.round(zahl(d.finanzierung.tilgungsfrei));
    if (!(tf >= 0)) tf = 0;
    if (tf > lz - 1) tf = lz - 1;
    var tilgungRate = kredit / (lz - tf);
    var rest = kredit;
    var konto = 0;
    var monate = [];
    for (var m = 1; m <= MONATE; m++) {
      var z = { monat: m, umsatzBrutto: 0, umsatzNetto: 0, ware: 0, karte: 0, miete: 0, grundkosten: 0, leasing: 0, weitere: weitere, gruendung: m === 1 ? gruendung : 0,
        afa: 0, zinsen: 0, ergebnis: 0, investition: 0, tilgung: 0, einzahlungFinanzierung: m === 1 ? ek + kredit : 0, saldo: 0, kontostand: 0, standorte: 0 };
      standorte.forEach(function (s) {
        if (!s.aktiv || m < s.start) return;
        z.standorte += 1;
        z.umsatzBrutto += s.r.umsatz;
        z.umsatzNetto += s.r.netto;
        z.ware += s.r.ware;
        z.karte += s.r.karte;
        z.miete += s.r.miete;
        z.grundkosten += s.r.grundkosten;
        if (s.finanzierung !== 'kauf') {
          if (m < s.start + s.laufzeit) z.leasing += s.rate;
        } else {
          if (m === s.start) z.investition += s.kosten;
          if (m < s.start + afaMonate) z.afa += s.kosten / afaMonate;
        }
      });
      if (zub > 0) {
        if (m === 1) z.investition += zub;
        if (m <= afaMonate) z.afa += zub / afaMonate;
      }
      z.zinsen = rest * i;
      if (m > tf && rest > 1e-9) {
        z.tilgung = Math.min(tilgungRate, rest);
        rest -= z.tilgung;
      }
      var laufend = z.umsatzNetto - z.ware - z.karte - z.miete - z.grundkosten - z.leasing - z.weitere - z.gruendung - z.zinsen;
      z.ergebnis = laufend - z.afa;
      z.saldo = z.einzahlungFinanzierung + laufend - z.investition - z.tilgung;
      konto += z.saldo;
      z.kontostand = konto;
      monate.push(z);
    }
    var jahre = [0, 1, 2].map(function (j) {
      var y = { jahr: j + 1 };
      PLAN_FELDER.forEach(function (f) { y[f] = 0; });
      for (var n = j * 12; n < j * 12 + 12; n++) PLAN_FELDER.forEach(function (f) { y[f] += monate[n][f]; });
      y.kontostand = monate[j * 12 + 11].kontostand;
      return y;
    });
    var investitionen = 0;
    var tief = { wert: Infinity, monat: 1 };
    var positivAb = null;
    var gedecktAb = null;
    var lauf = 0;
    var inv = 0;
    monate.forEach(function (x) {
      investitionen += x.investition;
      if (x.kontostand < tief.wert) tief = { wert: x.kontostand, monat: x.monat };
      if (positivAb === null && x.ergebnis > 0) positivAb = x.monat;
      lauf += x.ergebnis + x.afa;
      inv += x.investition;
      if (gedecktAb === null && inv > 0 && lauf >= inv) gedecktAb = x.monat;
    });
    var kapitalbedarf = investitionen + gruendung + reserve;
    return {
      monate: monate, jahre: jahre, standorte: standorte, hinweise: hinweise, daten: d, annahmen: a, ust: ust, afaJahre: afaJahre, afaMonate: afaMonate,
      zubehoer: zub, gruendung: gruendung, reserve: reserve, weitere: weitere,
      kredit: { betrag: kredit, zins: zinsOk ? zinsSatz : null, laufzeit: lz, tilgungsfrei: tf, rest: rest },
      eigenkapital: ek,
      kennzahlen: { investitionen: investitionen, kapitalbedarf: kapitalbedarf, finanzierung: ek + kredit, deckung: ek + kredit - kapitalbedarf, tiefpunkt: tief, positivAb: positivAb, gedecktAb: gedecktAb }
    };
  }

  function csvZahl(n) {
    return (Math.abs(n) < 0.005 ? 0 : n).toFixed(2).replace('.', ',');
  }

  function planCsv(plan) {
    var kopf = ['Monat', 'Umsatz brutto', 'Umsatz netto', 'Wareneinsatz', 'Kartengeb\u00fchren', 'Standortmiete', 'Grundkosten', 'Leasing und Miete', 'Weitere Kosten',
      'Gr\u00fcndungskosten', 'Abschreibung', 'Zinsen', 'Ergebnis vor Steuern', 'Investitionen', 'Tilgung', 'Einzahlungen Finanzierung', 'Saldo', 'Kontostand'];
    var felder = PLAN_FELDER.concat(['kontostand']);
    var zeilen = [kopf.join(';')];
    plan.monate.forEach(function (z) { zeilen.push([String(z.monat)].concat(felder.map(function (f) { return csvZahl(z[f]); })).join(';')); });
    return '\ufeff' + zeilen.join('\r\n') + '\r\n';
  }

  function monatText(m) {
    return m ? 'Monat ' + m : 'nach mehr als drei Jahren';
  }

  function businessplan(werte, kontext) {
    /* D-B: im Browser mit Modul der Plan v2 (Generator und Downloads-Hub gleich), unter Node und ohne Modul wie bisher */
    var modul = erweiterungImBrowser();
    if (modul) return modul.dokument(werte, kontext);
    var k = kontext || {};
    var plan = k.plan || rechnePlan(werte, k);
    var d = plan.daten;
    var t = kontextTexte(k, 'businessplan');
    var kz = plan.kennzahlen;
    var j = plan.jahre;
    var name = txt(d.vorhaben.name);
    var aktiv = plan.standorte.filter(function (s) { return s.aktiv; });
    var offen = function (x) { return txt(x) || TEXTE.offen; };
    var zahlWort = function (n, eins, mehr) { return n === 1 ? '1 ' + eins : zahlText(n) + ' ' + mehr; };
    var hinweisBloecke = plan.hinweise.map(function (h) { return hinweis(h, TEXTE.hinweis); });

    var zusammenfassung = [absatz((name || 'Das Vorhaben') + ': ' + zahlWort(aktiv.length, 'Automat', 'Automaten') + ' an ' + zahlWort(aktiv.length, 'Standort', 'Standorten') +
      (txt(d.vorhaben.start) ? ', Start ' + txt(d.vorhaben.start) : '') + '. Kapitalbedarf ' + euro(kz.kapitalbedarf) + ', Finanzierung ' + euro(kz.finanzierung) +
      '. Nach den Annahmen liegt das Ergebnis vor Steuern im ersten Jahr bei ' + euro(j[0].ergebnis) + ' und im dritten Jahr bei ' + euro(j[2].ergebnis) + '.'),
    { art: 'kennzahlen', werte: [
      { label: 'Kapitalbedarf', wert: euro(kz.kapitalbedarf), text: 'Ger\u00e4te, Gr\u00fcndung und Reserve' },
      { label: 'Finanzierung', wert: euro(kz.finanzierung), text: kz.deckung >= 0 ? 'Puffer ' + euro(kz.deckung) : 'L\u00fccke ' + euro(-kz.deckung) },
      { label: 'Ergebnis Jahr 1', wert: euro(j[0].ergebnis), text: 'vor Steuern, nach Abschreibung' },
      { label: 'Ergebnis Jahr 3', wert: euro(j[2].ergebnis), text: 'vor Steuern, nach Abschreibung' },
      { label: 'Liquidit\u00e4t', wert: euro(kz.tiefpunkt.wert), text: 'Tiefpunkt in Monat ' + kz.tiefpunkt.monat },
      { label: 'Investition gedeckt', wert: monatText(kz.gedecktAb), text: 'aus dem laufenden \u00dcberschuss' }
    ] }].concat(hinweisBloecke);

    var standortZeilen = plan.standorte.map(function (s) {
      return [s.name, TYP_NAME[s.typ], isFinite(s.verkaeufe) ? zahlText(s.verkaeufe) : '\u2013', isFinite(s.preis) ? euro(s.preis, 2) : '\u2013',
        isFinite(s.tage) ? zahlText(s.tage) : '\u2013', 'Monat ' + s.start,
        s.geraet + ', ' + FINANZIERUNG_NAME[s.finanzierung] + (s.finanzierung === 'kauf' ? ' (' + euro(s.kosten) + ')' : ' (' + euro(s.rate) + ' pro Monat)'),
        s.schwelle ? 'ab ca. ' + zahlText(Math.ceil(s.schwelle)) + ' Verk\u00e4ufen pro Tag' : '\u2013'];
    });

    var invZeilen = plan.standorte.filter(function (s) { return s.finanzierung === 'kauf' && s.aktiv; }).map(function (s) { return [s.geraet + ' f\u00fcr ' + s.name + ', Monat ' + s.start, euro(s.kosten)]; });
    if (plan.zubehoer > 0) invZeilen.push([txt(d.investition.zubehoerText) || 'Zubeh\u00f6r und Zahlungssysteme', euro(plan.zubehoer)]);
    invZeilen.push(['Gr\u00fcndungskosten', euro(plan.gruendung)], ['Liquidit\u00e4tsreserve', euro(plan.reserve)], ['Kapitalbedarf', euro(kz.kapitalbedarf)]);

    var finZeilen = [['Eigenkapital', euro(plan.eigenkapital)], ['Kredit', euro(plan.kredit.betrag)], ['Summe', euro(kz.finanzierung)], ['Kapitalbedarf', euro(kz.kapitalbedarf)],
      [kz.deckung >= 0 ? 'Puffer' : 'Finanzierungsl\u00fccke', euro(Math.abs(kz.deckung))]];
    var finanzierung = [tabelle('Finanzierungsplan', ['Quelle', 'Betrag'], finZeilen, [1])];
    if (plan.kredit.betrag > 0) {
      finanzierung.push(absatz('Kredit ' + (txt(d.finanzierung.geber) ? 'von ' + txt(d.finanzierung.geber) + ' ' : '') + '\u00fcber ' + euro(plan.kredit.betrag) + ', Laufzeit ' + plan.kredit.laufzeit + ' Monate, davon ' +
        plan.kredit.tilgungsfrei + ' tilgungsfrei, ' + (plan.kredit.zins !== null ? 'Zinssatz ' + prozent(plan.kredit.zins) + ' pro Jahr (Ihre Angabe)' : 'Zinssatz noch nicht angegeben') +
        '. Restschuld nach drei Jahren ' + euro(plan.kredit.rest) + '.'));
    }
    var miet = plan.standorte.filter(function (s) { return s.finanzierung !== 'kauf' && s.aktiv; });
    if (miet.length) finanzierung.push(liste(miet.map(function (s) { return s.name + ': ' + FINANZIERUNG_NAME[s.finanzierung] + ' \u00fcber ' + s.laufzeit + ' Monate zu ' + euro(s.rate) + ' pro Monat laut Angebot.'; })));
    finanzierung.push(absatz('F\u00f6rderung: F\u00fcr Gr\u00fcndungen gibt es den ERP-Gr\u00fcnderkredit StartGeld der KfW \u00fcber die Hausbank, beantragt vor Beginn des Vorhabens und auch im Nebenerwerb m\u00f6glich (Merkblatt 067, Stand 18.06.2026). Wer aus der Arbeitslosigkeit gr\u00fcndet, kann bei der Agentur f\u00fcr Arbeit einen Gr\u00fcndungszuschuss beantragen (\u00a7\u00a7 93, 94 SGB III; Ermessensleistung).'));

    var jahrZeile = function (label, f) { return [label].concat(j.map(function (y) { return euro(y[f]); })); };
    var planBloecke = [
      absatz('Die erste Tabelle zeigt das erste Jahr Monat f\u00fcr Monat, die zweite fasst drei Jahre zusammen. Betriebskosten umfassen Kartengeb\u00fchren, Standortmiete, Grundkosten, Leasing- und Mietraten, weitere Kosten und Gr\u00fcndungskosten.'),
      tabelle('Umsatz- und Kostenplan, Jahr 1', ['Monat', 'Umsatz netto', 'Wareneinsatz', 'Betriebskosten', 'Abschreibung', 'Zinsen', 'Ergebnis'], plan.monate.slice(0, 12).map(function (z) {
        return ['Monat ' + z.monat, euro(z.umsatzNetto), euro(z.ware), euro(z.karte + z.miete + z.grundkosten + z.leasing + z.weitere + z.gruendung), euro(z.afa), euro(z.zinsen), euro(z.ergebnis)];
      }), [1, 2, 3, 4, 5, 6]),
      tabelle('Rentabilit\u00e4tsvorschau, drei Jahre', ['Position', 'Jahr 1', 'Jahr 2', 'Jahr 3'], [
        jahrZeile('Umsatz brutto', 'umsatzBrutto'), jahrZeile('Umsatz netto', 'umsatzNetto'), jahrZeile('Wareneinsatz', 'ware'), jahrZeile('Kartengeb\u00fchren', 'karte'),
        jahrZeile('Standortmiete', 'miete'), jahrZeile('Grundkosten', 'grundkosten'), jahrZeile('Leasing und Miete', 'leasing'), jahrZeile('Weitere Kosten', 'weitere'),
        jahrZeile('Gr\u00fcndungskosten', 'gruendung'), jahrZeile('Abschreibung', 'afa'), jahrZeile('Zinsen', 'zinsen'), jahrZeile('Ergebnis vor Steuern', 'ergebnis')
      ], [1, 2, 3]),
      { art: 'grafik', titel: 'Monatsergebnis vor Steuern', beschreibung: 'Balken je Monat \u00fcber drei Jahre, oberhalb der Linie positiv, unterhalb negativ; erstmals positiv ' + (kz.positivAb ? 'in Monat ' + kz.positivAb : 'nicht innerhalb von drei Jahren') + '.',
        werte: plan.monate.map(function (z) { return z.ergebnis; }) }
    ];

    var liq = [
      absatz('Einzahlungen sind Nettoumsatz und Finanzierung, Auszahlungen laufende Kosten, Investitionen, Zinsen und Tilgung; die Abschreibung kostet kein Geld. Der Kontostand ist in Monat ' + kz.tiefpunkt.monat + ' am niedrigsten (' + euro(kz.tiefpunkt.wert) + ').'),
      tabelle('Liquidit\u00e4tsplan, Jahr 1', ['Monat', 'Einzahlungen', 'Auszahlungen', 'Saldo', 'Kontostand'], plan.monate.slice(0, 12).map(function (z) {
        var ein = z.einzahlungFinanzierung + z.umsatzNetto;
        return ['Monat ' + z.monat, euro(ein), euro(ein - z.saldo), euro(z.saldo), euro(z.kontostand)];
      }), [1, 2, 3, 4]),
      absatz('Kontostand am Ende von Jahr 1: ' + euro(j[0].kontostand) + ', Jahr 2: ' + euro(j[1].kontostand) + ', Jahr 3: ' + euro(j[2].kontostand) + '.')
    ];
    if (kz.tiefpunkt.wert < 0) liq.push(hinweis('Der Kontostand wird negativ. Erh\u00f6hen Sie Eigenkapital, Kredit oder Reserve oder verschieben Sie Investitionen.', TEXTE.hinweis));

    var risiken = [absatz('Chancen: Versorgung rund um die Uhr, auch in Schicht- und Wochenendbetrieben; bargeldlose Zahlung ist l\u00e4ngst \u00fcblich (laut BDV 55 % der Transaktionen); weitere Standorte lassen sich mit demselben Ablauf erschlie\u00dfen.')];
    var gewaehlt = RISIKEN.filter(function (r) { return istJa(w2(d, 'risiken', r.id)); });
    if (gewaehlt.length) risiken.push(liste(gewaehlt.map(function (r) { return r.text + ' \u2013 Gegenma\u00dfnahme: ' + r.mittel + '.'; })));
    if (txt(d.risiken.massnahmen)) risiken.push(absatz('Weitere Ma\u00dfnahmen: ' + txt(d.risiken.massnahmen)));

    var ms = [{ monat: 0, text: 'Vor dem Start: Gewerbe anmelden, steuerliche Erfassung beim Finanzamt, Registrierung bei der Lebensmittel\u00fcberwachung, Aufstellungsvertr\u00e4ge mit den Standortgebern.' }];
    aktiv.forEach(function (s) { ms.push({ monat: s.start, text: 'Monat ' + s.start + ': ' + s.name + ' geht in Betrieb (' + s.geraet + ').' }); });
    if (kz.positivAb) ms.push({ monat: kz.positivAb, text: 'Monat ' + kz.positivAb + ': Monatsergebnis erstmals positiv.' });
    if (kz.gedecktAb) ms.push({ monat: kz.gedecktAb, text: 'Monat ' + kz.gedecktAb + ': Investitionen aus dem laufenden \u00dcberschuss gedeckt.' });
    (d.meilensteine || []).forEach(function (x) {
      var m = Math.round(zahl(x.monat));
      if (txt(x.titel)) ms.push({ monat: m >= 1 ? m : 0, text: (m >= 1 ? 'Monat ' + m + ': ' : '') + txt(x.titel) });
    });
    ms.sort(function (x, y) { return x.monat - y.monat; });

    var a = plan.annahmen;
    var afaJ = afaJahreAus(k.daten || null);
    var annahmen = [liste([
      'Wareneinsatz: ' + prozent(a.wareneinsatz) + ' des Nettoumsatzes; Branchenangaben nennen 40 bis 60 %.',
      'Mehrwertsteuer im Sortiment: im Mittel ' + prozent(a.mwst) + ' aus 7 % f\u00fcr Snacks und 19 % f\u00fcr Getr\u00e4nke' + (plan.ust ? '.' : '; als Kleinunternehmer ohne Abzug.'),
      'Grundkosten: ' + euro(a.grundkosten) + ' je Automat und Monat f\u00fcr Strom, Versicherung und R\u00fccklage f\u00fcr Wartung.',
      'Kartenzahlung: ' + euro(a.karteFix) + ' pro Monat und ' + prozent(a.karteProzent) + ' auf den Kartenumsatz bei ' + prozent(a.kartenanteil) + ' Kartenanteil (laut BDV 55 % bargeldlose Transaktionen); Beispielwerte, nicht die Konditionen Ihres Zahlungsanbieters.',
      'Standortmiete: ' + (a.miete === 'fix' ? 'Festbetrag ' + euro(a.mieteFix) + ' je Standort und Monat.' : prozent(a.mieteProzent) + ' des Nettoumsatzes.'),
      'Verk\u00e4ufe pro Tag, \u00d8-Preis und Verkaufstage im Monat: Voreinstellungen je Standorttyp wie im Rechenbeispiel \u201eWie rechnet sich das?\u201c, von Ihnen angepasst.',
      'Abschreibung: linear \u00fcber ' + zahlText(plan.afaJahre) + ' Jahre \u2013 Vorschlag laut AfA-Tabelle je Ger\u00e4tetyp: Warenautomaten wie Snack- und Kombiautomaten ' + zahlText(afaJ.waren) + ' Jahre, reine Getr\u00e4nkeautomaten ' + zahlText(afaJ.getraenke) + ' Jahre, von Ihnen \u00e4nderbar; ob ein Kombiautomat als Waren- oder Getr\u00e4nkeautomat gilt, kl\u00e4rt Ihr Steuerberater. Kaffee- und Hei\u00dfgetr\u00e4nkeautomaten rechnen wir wie Getr\u00e4nkeautomaten mit ' + zahlText(afaJ.getraenke) + ' Jahren; die Tabelle nennt sie nicht eigens. Eine degressive Abschreibung ist nicht gerechnet.',
      'Umsatzsteuer: ' + (plan.ust ? 'Betr\u00e4ge netto, die Vorsteuer aus Anschaffungen wird erstattet (Regelbesteuerung).' : 'Kleinunternehmer \u2013 Umsatz ohne Abzug, Anschaffungen brutto ohne Vorsteuerabzug (\u00a7 19 UStG).'),
      'Nicht enthalten: Einkommen- und Gewerbesteuer, Privatentnahmen, Ihre Arbeitszeit, Saisonschwankungen und eine Anlaufphase.'
    ])];

    return {
      werkzeug: 'businessplan',
      titel: TEXTE.titel.businessplan + (name ? ': ' + name : ''),
      untertitel: t.kurz,
      kopf: [],
      abschnitte: [
        ['zusammenfassung', 'Zusammenfassung', zusammenfassung],
        ['vorhaben', 'Vorhaben', [absatz('Vorhaben: ' + offen(d.vorhaben.name)), absatz(offen(d.vorhaben.beschreibung)), absatz('Ziele: ' + offen(d.vorhaben.ziel)), absatz('Geplanter Start: ' + offen(d.vorhaben.start))]],
        ['gruender', 'Gr\u00fcnderin oder Gr\u00fcnder', [absatz('Name: ' + offen(d.gruender.name)), absatz('Erfahrung und Kenntnisse: ' + offen(d.gruender.qualifikation)),
          absatz('Zeitrahmen: ' + (d.gruender.erwerb === 'neben' ? 'im Nebenerwerb (beim ERP-Gr\u00fcnderkredit StartGeld ebenfalls f\u00f6rderf\u00e4hig)' : 'im Haupterwerb') + '.'),
          absatz('Rechtsform: ' + (RECHTSFORM[d.gruender.rechtsform] || RECHTSFORM.einzel) + '; ' + (plan.ust ? 'Regelbesteuerung mit Vorsteuerabzug.' : 'Kleinunternehmer nach \u00a7 19 UStG ohne Vorsteuerabzug.'))]],
        ['standorte', 'Standorte und Markt', [tabelle('Standorte', ['Standort', 'Typ', 'Verk\u00e4ufe pro Tag', '\u00d8-Preis brutto', 'Verkaufstage', 'Start', 'Ger\u00e4t und Finanzierung', 'Kostendeckend'], standortZeilen, [2, 3, 4]),
          absatz('Marktumfeld: In Deutschland stehen nach Angaben des Branchenverbands BDV rund 621.000 Getr\u00e4nke- und Verpflegungsautomaten; 55 % der Transaktionen sind bargeldlos. Die meisten Automaten stehen in der Produktion (51 %) und in B\u00fcros (25 %) (BDV, Markt\u00fcberblick 03/2025, Daten 2024).')]],
        ['sortiment', 'Sortiment und Preise', [absatz('Schwerpunkt: ' + (SCHWERPUNKT[d.sortiment.schwerpunkt] || SCHWERPUNKT.kombi) + '.'), absatz('Sortiment: ' + offen(d.sortiment.beschreibung)),
          absatz('Preise: ' + offen(d.sortiment.preise)), absatz(plan.ust ? 'Im Mittel ' + prozent(a.mwst) + ' Mehrwertsteuer im Sortiment; Preise am Automaten sind Endpreise einschlie\u00dflich Umsatzsteuer, Pfand steht getrennt daneben.' : 'Als Kleinunternehmer weisen Sie keine Umsatzsteuer aus; Pfand steht getrennt neben dem Preis.')]],
        ['investition', 'Investition und Kapitalbedarf', [tabelle('Kapitalbedarf', ['Position', 'Betrag'], invZeilen, [1]),
          absatz('Abschreibung linear \u00fcber ' + zahlText(plan.afaJahre) + ' Jahre, im ersten vollen Monat ' + euro(plan.monate[MONATE - 1].afa) + ' f\u00fcr alle gekauften Ger\u00e4te.' + (plan.ust ? '' : ' Als Kleinunternehmer rechnen Sie die Ger\u00e4te brutto mit 19 % Umsatzsteuer, weil Sie keine Vorsteuer erstattet bekommen.'))]],
        ['finanzierung', 'Finanzierung', finanzierung],
        ['plan', 'Umsatz- und Kostenplan', planBloecke],
        ['liquiditaet', 'Liquidit\u00e4tsplan', liq],
        ['risiken', 'Chancen und Risiken', risiken],
        ['meilensteine', 'Meilensteine', [liste(ms.map(function (x) { return x.text; }))]],
        ['annahmen', 'Annahmen und Quellen', annahmen],
        ['unterlagen', 'Unterlagen f\u00fcr Bank und F\u00f6rderstelle', [liste(['Lebenslauf und Nachweise Ihrer Kenntnisse', 'Zusagen oder Aufstellungsvertr\u00e4ge der Standortgeber', 'Angebote f\u00fcr Automaten und Zahlungssysteme',
          'Angebote f\u00fcr Versicherungen', 'Gewerbeanmeldung und steuerliche Erfassung', 'Registrierung bei der Lebensmittel\u00fcberwachung', 'Nachweis \u00fcber Ihr Eigenkapital'])]]
      ].map(function (x, i) { return { id: x[0], nr: String(i + 1), titel: x[1], bloecke: x[2] }; }),
      anlagen: [],
      unterschriften: [],
      rechtshinweis: t.rechtshinweis,
      stand: t.stand
    };
  }

  function w2(d, gruppe, id) {
    return d[gruppe] ? d[gruppe][id] : undefined;
  }

  /* ------------------------------------------------------------------ Pflichten-Check */

  var PFLICHT_FRAGEN = [
    { id: 'gewerbe', schritt: 'gewerbe', art: 'eins', kurz: 'Gewerbe', optionen: ['neu', 'vorhanden'], texte: { neu: 'Neugr\u00fcndung', vorhanden: 'Gewerbe besteht' } },
    { id: 'steuer', schritt: 'gewerbe', art: 'eins', kurz: 'Umsatzsteuer', optionen: ['regel', 'klein', 'unklar'], texte: { regel: 'Regelbesteuerung', klein: 'Kleinunternehmer', unklar: 'noch unklar' } },
    { id: 'mitarbeiter', schritt: 'gewerbe', art: 'eins', kurz: 'Besch\u00e4ftigte', optionen: ['nein', 'ja'], texte: { nein: 'keine', ja: 'ja' } },
    { id: 'standort', schritt: 'standort', art: 'eins', kurz: 'Standort', optionen: ['betrieb', 'oeffentlich', 'aussen', 'strasse'],
      texte: { betrieb: 'im Betrieb', oeffentlich: '\u00f6ffentlich zug\u00e4nglich, innen', aussen: 'au\u00dfen auf privatem Grund', strasse: '\u00f6ffentlicher Stra\u00dfenraum' } },
    { id: 'flaeche', schritt: 'standort', art: 'eins', kurz: 'Fl\u00e4che', optionen: ['fremd', 'eigen'], texte: { fremd: 'Standortgeber', eigen: 'eigene Fl\u00e4che' } },
    { id: 'sortiment', schritt: 'sortiment', art: 'mehr', kurz: 'Sortiment', optionen: ['snacks', 'pfand', 'heiss', 'frisch', 'tk', 'alkohol', 'spirituosen', 'tabak', 'energy', 'nonfood'],
      texte: { snacks: 'Snacks', pfand: 'Getr\u00e4nke mit Pfand', heiss: 'Hei\u00dfgetr\u00e4nke', frisch: 'Frischware', tk: 'Tiefk\u00fchlware', alkohol: 'Bier, Wein oder Sekt', spirituosen: 'Spirituosen',
        tabak: 'Tabak', energy: 'Energydrinks', nonfood: 'Waren ohne Lebensmittel' } },
    { id: 'kuehlung', schritt: 'sortiment', art: 'eins', kurz: 'K\u00fchlung', optionen: ['ja', 'nein'], texte: { ja: 'ja', nein: 'nein' } },
    { id: 'unverpackt', schritt: 'sortiment', art: 'eins', kurz: 'Offene Lebensmittel', optionen: ['nein', 'ja'], texte: { nein: 'nein', ja: 'ja' } },
    { id: 'zahlung', schritt: 'betrieb', art: 'eins', kurz: 'Zahlung', optionen: ['beides', 'karte', 'bar'], texte: { beides: 'Bargeld und Karte', karte: 'nur Karte', bar: 'nur Bargeld' } },
    { id: 'kamera', schritt: 'betrieb', art: 'eins', kurz: 'Kamera', optionen: ['nein', 'ja'], texte: { nein: 'keine', ja: 'ja' } }
  ];

  /* Linkkarte der Pflichten. Nachtrag K-2 aus I-1 (i1-inhalte.md Abschnitt 12, Zuordnung rw-recht.md Abschnitt 9): je
     Thema der vertiefende R-W-Beitrag statt der alten Recht-Beitraege; Linktext = Seitentitel (_build/wissen-seiten.json) */
  var L = {
    gewerbe: { text: 'Gewerbeanmeldung und Rechtsform', href: '/pages/wissen-gewerbeanmeldung-und-rechtsform' },
    steuern: { text: 'Steuern beim Automatenbetrieb', href: '/pages/wissen-steuern-beim-automatenbetrieb' },
    aufstellen: { text: 'Anleitung: Automat aufstellen und in Betrieb nehmen', href: '/pages/hilfe-automat-aufstellen-inbetriebnahme' },
    businessplan: { text: 'Businessplan mit Steuerform und Finanzplan', href: '/pages/businessplan' },
    kasse: { text: 'Kassenf\u00fchrung und Belege am Automaten', href: '/pages/wissen-kassenfuehrung-und-belege' },
    kassenschnitt: { text: 'Anleitung: Kassenschnitt und Berichte mit Nayax', href: '/pages/hilfe-nayax-betrieb-kassenschnitt-berichte' },
    dex: { text: 'Anleitung: Telemetrie und DEX bei SandenVendo', href: '/pages/hilfe-telemetrie-dex-sandenvendo' },
    preise: { text: 'Preise am Automaten festlegen', href: '/pages/wissen-preise-am-automaten-festlegen' },
    hygiene: { text: 'Lebensmittelrecht und Kennzeichnung', href: '/pages/wissen-lebensmittelrecht-und-kennzeichnung' },
    reinigung: { text: 'Reinigung und Hygiene', href: '/pages/wissen-reinigung-hygiene' },
    kuehlung: { text: 'K\u00fchlung und Temperatur', href: '/pages/wissen-kuehlung-und-temperatur' },
    kaffee: { text: 'Kaffeeautomaten: Grundlagen', href: '/pages/wissen-kaffeeautomat-grundlagen' },
    preisangaben: { text: 'Preisangaben am Automaten', href: '/pages/wissen-preisauszeichnung-am-automaten' },
    pfand: { text: 'Pfand, R\u00fccknahme und Mehrweg am Automaten', href: '/pages/wissen-pfand-ruecknahme-mehrweg' },
    dcm5: { text: 'Anleitung: Altersverifikation DCM5 einrichten', href: '/pages/hilfe-altersverifikation-dcm5-einrichten' },
    jugendschutz: { text: 'Jugendschutz am Automaten: Gesetz und Praxis', href: '/pages/wissen-jugendschutz-gesetz-und-praxis' },
    alter: { text: 'Altersverifikation am Automaten', href: '/pages/wissen-altersverifikation' },
    zahlungssysteme: { text: 'Zahlungssysteme und Altersverifikation', href: '/collections/zahlungssysteme' },
    aufstellungsvertrag: { text: 'Aufstellungsvertrag erstellen', href: '/pages/aufstellungsvertrag' },
    pfandvertrag: { text: 'R\u00fccknahme im Aufstellungsvertrag regeln', href: '/pages/aufstellungsvertrag' },
    vertragspraxis: { text: 'Der Aufstellungsvertrag in der Praxis', href: '/pages/wissen-aufstellungsvertrag-in-der-praxis' },
    ersatzteile: { text: 'Befestigung und Ersatzteile', href: '/collections/ersatzteile' },
    betriebssicherheit: { text: 'Betriebssicherheit und Elektropr\u00fcfung', href: '/pages/wissen-betriebssicherheit-und-elektropruefung' },
    standortwahl: { text: 'Den passenden Standort w\u00e4hlen', href: '/pages/wissen-standort-waehlen' },
    standortcheck: { text: 'Standort-Check', href: '/pages/standort-check' },
    outdoor: { text: 'Outdoor-Standort vorbereiten', href: '/pages/wissen-outdoor-standort-vorbereiten' },
    kartengebuehren: { text: 'Kartenzahlung: Geb\u00fchren und Vertrag', href: '/pages/wissen-kartenzahlung-gebuehren-und-vertrag' },
    kartensteuerung: { text: 'Anleitung: Kartenzahlung an SandenVendo-Steuerungen', href: '/pages/hilfe-sandenvendo-steuerung-kartenzahlung' },
    telemetrie: { text: 'Telemetrie und Fern\u00fcberwachung', href: '/pages/wissen-telemetrie-fernueberwachung' },
    onyx: { text: 'Anleitung: Nayax Onyx einbauen', href: '/pages/hilfe-nayax-onyx-einbauen' },
    nachruesten: { text: 'Zahlungssysteme nachr\u00fcsten', href: '/collections/zahlungssysteme' },
    sicherheit: { text: 'Vandalismus, Diebstahl und Sicherheit', href: '/pages/wissen-vandalismus-und-sicherheit' },
    datenschutz: { text: 'Datenschutz bei Kartenzahlung und Telemetrie', href: '/pages/wissen-datenschutz-kartenzahlung-telemetrie' },
    versicherung: { text: 'Versicherungen f\u00fcr Automatenaufsteller', href: '/pages/wissen-versicherungen-fuer-aufsteller' }
  };

  function hat(c, s) { return !!c.s[s]; }
  function lm(c) { return hat(c, 'snacks') || hat(c, 'pfand') || hat(c, 'heiss') || hat(c, 'frisch') || hat(c, 'tk') || hat(c, 'alkohol') || hat(c, 'energy'); }

  function p(id, gruppe, status, titel, text, norm, fuer, links, wenn) {
    return { id: id, gruppe: gruppe, status: status, titel: titel, text: text, norm: norm, fuer: fuer, links: links, wenn: wenn };
  }

  /* Paket H (13.10.2026, _docs/h-vorlagen-recht.md, N-4 Nr. 4): Text eines Eintrags, der von den Antworten abhaengt.
     Im persoenlichen Check waehlt textWenn.wenn(c) den Text textWenn.text statt text; die statische Checkliste mit allen
     Eintraegen zeigt immer textWenn.text. */
  function mitText(q, wenn, text) {
    q.textWenn = { wenn: wenn, text: text };
    return q;
  }

  var PFLICHTEN = [
    p('gewerbeanzeige', 'anmeldung', 'pflicht', 'Gewerbe anmelden', 'Wer Automaten selbst\u00e4ndig aufstellt, zeigt das Gewerbe einmal bei der Gewerbebeh\u00f6rde der Hauptniederlassung an \u2013 nicht je Automat. Eine Erlaubnis brauchen Warenautomaten nicht.',
      '\u00a7 14 Abs. 1 und 3 GewO', 'Neugr\u00fcndung', [L.gewerbe], function (c) { return c.a.gewerbe === 'neu'; }),
    p('gewerbe_umfang', 'anmeldung', 'pruefen', 'Bestehende Gewerbeanmeldung pr\u00fcfen', 'Umfasst Ihre Anmeldung die Aufstellung von Automaten nicht, zeigen Sie die Erweiterung bei der Gewerbebeh\u00f6rde an.',
      '\u00a7 14 GewO', 'bestehendes Gewerbe', [L.gewerbe], function (c) { return c.a.gewerbe === 'vorhanden'; }),
    p('kennzeichnung', 'anmeldung', 'pflicht', 'Betreiberangaben am Automaten anbringen', 'Name mit mindestens einem ausgeschriebenen Vornamen, ladungsf\u00e4hige Anschrift und Anschrift der Hauptniederlassung, bei eingetragener Firma auch die Firma \u2013 sichtbar am Ger\u00e4t ab dem Tag der Aufstellung. Fehlen die Angaben, droht ein Bu\u00dfgeld bis 1.000 \u20ac.',
      '\u00a7 14 Abs. 3 Satz 2 bis 4 GewO; \u00a7 146 Abs. 2 Nr. 3 und Abs. 3 GewO', 'alle Betreiber', [L.gewerbe, L.aufstellen], function () { return true; }),
    p('finanzamt', 'anmeldung', 'pflicht', 'Steuerliche Erfassung beim Finanzamt', 'Den Fragebogen zur steuerlichen Erfassung reichen Sie \u00fcber ELSTER innerhalb eines Monats nach Beginn der T\u00e4tigkeit ein.',
      '\u00a7 138 Abs. 1b und 4 AO', 'Neugr\u00fcndung', [L.gewerbe, L.businessplan], function (c) { return c.a.gewerbe === 'neu'; }),
    p('ihk', 'anmeldung', 'hinweis', 'IHK-Beitrag: Befreiung f\u00fcr Gr\u00fcnder', 'Mit dem Gewerbe geh\u00f6ren Sie der IHK an. Gr\u00fcnder ohne Eintrag im Handelsregister sind im Jahr der Er\u00f6ffnung und im Folgejahr beitragsfrei, im dritten und vierten Jahr frei von der Umlage, solange der Gewerbeertrag 25.000 \u20ac nicht \u00fcbersteigt.',
      '\u00a7 3 Abs. 3 IHKG', 'Neugr\u00fcndung als nat\u00fcrliche Person', [L.gewerbe, L.businessplan], function (c) { return c.a.gewerbe === 'neu'; }),
    p('gluecksspiel', 'anmeldung', 'hinweis', 'Keine Gewinnspiele am Automaten', 'Warenautomaten brauchen keine Erlaubnis. Gibt der Automat aber gegen Geld zuf\u00e4llig unterschiedliche Ware oder einen Gewinn aus, etwa als \u00dcberraschungs- oder Gl\u00fccksautomat, kann das ein erlaubnispflichtiges Spielger\u00e4t oder verbotenes Gl\u00fccksspiel sein.',
      '\u00a7 33c GewO; \u00a7 3 Abs. 1 Gl\u00fcStV 2021', 'alle Betreiber', [L.gewerbe], function () { return true; }),

    p('kasse_einordnung', 'steuern', 'hinweis', 'Keine TSE und keine Belegausgabe am Automaten', 'Waren- und Dienstleistungsautomaten gelten nicht als elektronische Kassensysteme: Sie brauchen keine technische Sicherheitseinrichtung, keine Belegausgabe und keine Mitteilung an das Finanzamt.',
      '\u00a7 1 Abs. 1 Satz 2 Nr. 4 KassenSichV; \u00a7 146a AO', 'alle Betreiber', [L.kasse], function () { return true; }),
    p('leerungsprotokoll', 'steuern', 'pflicht', 'Bargeld je Automat z\u00e4hlen und aufzeichnen', 'Der Geldspeicher eines Automaten gilt als Kasse: Z\u00e4hlen Sie den Bestand bei jeder Leerung und halten Sie Datum, Betrag und Z\u00e4hlerstand je Automat fest.',
      'BFH, Urteil vom 20.03.2017, X R 11/16; \u00a7 146 Abs. 1 AO', 'Bargeld am Automaten', [L.kasse, L.kassenschnitt], function (c) { return c.a.zahlung === 'bar' || c.a.zahlung === 'beides'; }),
    p('aufzeichnung', 'steuern', 'pflicht', 'Einnahmen aufzeichnen, Belege aufbewahren', 'Sichern Sie die Verkaufsdaten aus Telemetrie oder Z\u00e4hlwerk und kl\u00e4ren Sie mit der Steuerberatung, welche Daten als Grundaufzeichnung gelten. B\u00fccher und Aufzeichnungen bewahren Sie zehn Jahre auf, Buchungsbelege acht Jahre.',
      '\u00a7 146 Abs. 1 und \u00a7 147 Abs. 3 AO', 'alle Betreiber', [L.kasse, L.dex], function () { return true; }),
    p('umsatzsteuer', 'steuern', 'pflicht', 'Umsatzsteuer je Ware ansetzen', 'Der Verkauf aus Automaten ist immer eine Lieferung: Snacks und S\u00fc\u00dfwaren tragen meist 7 %, Getr\u00e4nke einschlie\u00dflich Kaffee aus dem Automaten 19 %. Pr\u00fcfen Sie die Einordnung im Einzelfall.',
      'Abschnitt 3.6 Abs. 2 UStAE; Anlage 2 UStG', 'Regelbesteuerung', [L.steuern, L.preise], function (c) { return c.a.steuer === 'regel'; }),
    p('kleinunternehmer', 'steuern', 'pflicht', 'Grenzen f\u00fcr Kleinunternehmer einhalten', 'Umsatz im Vorjahr bis 25.000 \u20ac, im laufenden Jahr bis 100.000 \u20ac. Sie weisen keine Umsatzsteuer aus, erhalten aber auch keine Vorsteuer f\u00fcr den Automatenkauf zur\u00fcck.',
      '\u00a7 19 Abs. 1 UStG', 'Kleinunternehmer', [L.steuern, L.businessplan], function (c) { return c.a.steuer === 'klein'; }),
    p('ust_unklar', 'steuern', 'pruefen', 'Steuerform festlegen', 'Ob die Kleinunternehmerregelung oder die Regelbesteuerung besser passt, h\u00e4ngt vom geplanten Umsatz und von den Anschaffungen ab \u2013 mit der Steuerberatung kl\u00e4ren.',
      '\u00a7 19 UStG', 'Steuerform noch offen', [L.steuern, L.businessplan], function (c) { return c.a.steuer === 'unklar'; }),

    p('registrierung', 'lebensmittel', 'pflicht', 'Bei der Lebensmittel\u00fcberwachung registrieren', 'Automatenbetreiber sind Lebensmittelunternehmer. Melden Sie den Betrieb bei der Lebensmittel\u00fcberwachung, die f\u00fcr den Standort des Automaten zust\u00e4ndig ist \u2013 auch als bereits registrierter Betrieb.',
      'Art. 6 Abs. 2 VO (EG) Nr. 852/2004', 'Lebensmittel oder Getr\u00e4nke im Sortiment', [L.hygiene], lm),
    p('hygiene', 'lebensmittel', 'pflicht', 'Automat sauber halten, Eigenkontrollen f\u00fchren', 'Reinigen Sie auch Ausgabefach und Lift, pr\u00fcfen Sie bei jeder Bef\u00fcllung das Mindesthaltbarkeitsdatum und bewahren Sie Lieferscheine auf. F\u00fcr verpackte, nicht k\u00fchlpflichtige Ware ist in der Regel kein eigenes HACCP-System n\u00f6tig.',
      'Art. 5 und Anhang II Kapitel III VO (EG) Nr. 852/2004', 'Lebensmittel oder Getr\u00e4nke im Sortiment', [L.reinigung, L.hygiene], lm),
    p('kuehlkette', 'lebensmittel', 'pflicht', 'K\u00fchlkette sichern, Temperatur \u00fcberwachen', 'Richten Sie die Temperatur nach dem empfindlichsten Produkt aus: belegte Br\u00f6tchen, Feinkost und Desserts h\u00f6chstens +7 \u00b0C, Tiefk\u00fchlware \u221218 \u00b0C. Legen Sie Alarm und Vorgehen bei einem K\u00fchlausfall vorher fest.',
      'Anhang II Kapitel IX Nr. 5 VO (EG) Nr. 852/2004; LAVES-Merkblatt Lagertemperaturen', 'Frischware oder Tiefk\u00fchlware', [L.kuehlung, L.dex], function (c) { return hat(c, 'frisch') || hat(c, 'tk'); }),
    p('kuehlung_kontrolle', 'lebensmittel', 'pruefen', 'K\u00fchltemperatur passend zur Ware kontrollieren', 'Stellen Sie die K\u00fchlung nach Herstellerangabe und Ware ein und kontrollieren Sie die Temperatur bei der Bef\u00fcllung als Teil Ihrer Eigenkontrollen.',
      'Art. 5 VO (EG) Nr. 852/2004', 'gek\u00fchlter Automat ohne Frischware', [L.kuehlung], function (c) { return c.a.kuehlung === 'ja' && lm(c) && !hat(c, 'frisch') && !hat(c, 'tk'); }),
    p('schulung', 'lebensmittel', 'pflicht', 'Hygieneschulung dokumentieren', 'Wer leicht verderbliche Lebensmittel behandelt oder in Verkehr bringt, braucht eine Hygieneschulung. Halten Sie Inhalt und Datum der Schulung schriftlich fest.',
      '\u00a7 4 LMHV', 'Frischware mit Kontakt zu offenen Lebensmitteln', [L.hygiene], function (c) { return hat(c, 'frisch') && c.a.unverpackt === 'ja'; }),
    p('schulung_verpackt', 'lebensmittel', 'pruefen', 'Hygieneschulung bei Frischware kl\u00e4ren', 'F\u00fcr reine T\u00e4tigkeiten mit verpackten Lebensmitteln gilt eine Ausnahme von der Schulungspflicht. Ob sie f\u00fcr Ihre Frischware greift, kl\u00e4ren Sie mit der Lebensmittel\u00fcberwachung.',
      '\u00a7 4 LMHV', 'verpackte Frischware', [L.hygiene], function (c) { return hat(c, 'frisch') && c.a.unverpackt !== 'ja'; }),
    p('ifsg', 'lebensmittel', 'pflicht', 'Belehrung durch das Gesundheitsamt', 'Vor der ersten T\u00e4tigkeit mit offenen Lebensmitteln wie Milch und Milcherzeugnissen, Fleisch, Eiprodukten, Speiseeis oder Backwaren mit nicht durchgebackener F\u00fcllung brauchen Sie eine Bescheinigung, nicht \u00e4lter als drei Monate. Besch\u00e4ftigte belehrt der Arbeitgeber danach alle zwei Jahre erneut.',
      '\u00a7 42 und \u00a7 43 Abs. 1 und 4 IfSG', 'Kontakt mit offenen Lebensmitteln', [L.hygiene, L.kaffee], function (c) { return c.a.unverpackt === 'ja' && lm(c); }),
    p('ifsg_kaffee', 'lebensmittel', 'pruefen', 'Belehrung beim Bef\u00fcllen von Kaffeeautomaten kl\u00e4ren', 'Bef\u00fcllen Sie Milchpulver oder Milchsysteme, ist eine Belehrung wahrscheinlich n\u00f6tig. Fragen Sie beim Gesundheitsamt nach.',
      '\u00a7 42 Abs. 2 und \u00a7 43 IfSG', 'Hei\u00dfgetr\u00e4nke ohne angegebenen Kontakt zu offenen Lebensmitteln', [L.hygiene, L.kaffee], function (c) { return hat(c, 'heiss') && c.a.unverpackt !== 'ja'; }),
    p('allergene', 'lebensmittel', 'pflicht', 'Allergene und Zusatzstoffe am Automaten nennen', 'Bei loser Ware wie Kaffee, Kakao oder Suppe stehen Allergene und Zusatzstoffe gut sichtbar am Automaten, etwa \u201emit S\u00fc\u00dfungsmittel\u201c oder Milch und Soja in Instantgetr\u00e4nken.',
      '\u00a7 4 Abs. 2 und 3 LMIDV; \u00a7 5 LMZDV', 'Hei\u00dfgetr\u00e4nke', [L.hygiene, L.kaffee], function (c) { return hat(c, 'heiss'); }),
    p('trinkwasser', 'lebensmittel', 'pruefen', 'Festwasseranschluss nur vom eingetragenen Installateur', 'Schlie\u00dfen Sie einen Kaffeeautomaten an die Wasserleitung an, darf das nur ein Installationsunternehmen aus dem Verzeichnis des Wasserversorgers. Mit Wassertank entf\u00e4llt dieser Punkt.',
      '\u00a7 12 Abs. 2 AVBWasserV', 'Hei\u00dfgetr\u00e4nke mit Wasseranschluss', [L.kaffee], function (c) { return hat(c, 'heiss'); }),

    p('jugend_tabak', 'jugendschutz', 'pflicht', 'Alterspr\u00fcfung f\u00fcr Tabak und E-Zigaretten', 'In der \u00d6ffentlichkeit nur, wenn eine technische Vorrichtung oder st\u00e4ndige Aufsicht sicherstellt, dass Kinder und Jugendliche nichts entnehmen k\u00f6nnen \u2013 das gilt auch f\u00fcr nikotinfreie E-Zigaretten. Verst\u00f6\u00dfe kosten bis 50.000 \u20ac.',
      '\u00a7 10 Abs. 2 und 4 JuSchG; \u00a7 28 Abs. 5 JuSchG', 'Tabak oder E-Zigaretten', [L.dcm5, L.jugendschutz, L.zahlungssysteme], function (c) { return hat(c, 'tabak'); }),
    p('jugend_alkohol', 'jugendschutz', 'pflicht', 'Alkohol nur am unzug\u00e4nglichen Ort oder im gewerblichen Raum mit Alterspr\u00fcfung', 'Bier, Wein und Sekt nur an einem f\u00fcr Kinder und Jugendliche unzug\u00e4nglichen Ort oder in einem gewerblich genutzten Raum mit technischer Vorrichtung oder st\u00e4ndiger Aufsicht. Die Technik allein gen\u00fcgt nicht.',
      '\u00a7 9 Abs. 1 und 3 JuSchG', 'Bier, Wein oder Sekt', [L.jugendschutz, L.alter], function (c) { return hat(c, 'alkohol'); }),
    p('alkohol_aussen', 'jugendschutz', 'verbot', 'Kein Alkohol im Au\u00dfenautomaten', 'Ein Au\u00dfenautomat steht weder an einem unzug\u00e4nglichen Ort noch in einem gewerblich genutzten Raum \u2013 Alkohol ist dort praktisch ausgeschlossen.',
      '\u00a7 9 Abs. 3 JuSchG', 'Alkohol am Au\u00dfenstandort', [L.jugendschutz], function (c) { return hat(c, 'alkohol') && (c.a.standort === 'aussen' || c.a.standort === 'strasse'); }),
    p('spirituosen', 'jugendschutz', 'verbot', 'Keine Spirituosen im Automaten', 'Spirituosen und \u00fcberwiegend alkoholhaltige Lebensmittel d\u00fcrfen nicht \u00fcber Automaten verkauft werden. In L\u00e4ndern mit eigenem Gastst\u00e4ttengesetz gilt Landesrecht.',
      '\u00a7 20 Nr. 1 GastG', 'Spirituosen', [L.jugendschutz], function (c) { return hat(c, 'spirituosen'); }),
    p('energy', 'jugendschutz', 'pruefen', 'Energydrinks: Entwicklung beobachten', 'Eine gesetzliche Altersgrenze gibt es derzeit nicht; Initiativen f\u00fcr eine Grenze ab 16 Jahren laufen. An Schulen empfiehlt sich der Verzicht.',
      'Stand Oktober 2026: keine Regelung im JuSchG', 'Energydrinks', [L.jugendschutz], function (c) { return hat(c, 'energy'); }),

    mitText(p('preisangabe', 'preise', 'pflicht', 'Endpreise am Automaten angeben', 'Nennen Sie je Fach oder Wahltaste den Gesamtpreis einschlie\u00dflich Umsatzsteuer. Ein Grundpreis je Kilogramm oder Liter ist bei Getr\u00e4nke- und Verpflegungsautomaten nicht n\u00f6tig.',
      '\u00a7\u00a7 3 und 10 PAngV; \u00a7 4 Abs. 3 Nr. 5 PAngV', 'Verkauf an Verbraucher', [L.preisangaben], function () { return true; }),
      function (c) { return hat(c, 'nonfood'); }, 'Nennen Sie je Fach oder Wahltaste den Gesamtpreis einschlie\u00dflich Umsatzsteuer. Ein Grundpreis je Kilogramm oder Liter ist bei Getr\u00e4nke- und Verpflegungsautomaten nicht n\u00f6tig; f\u00fcr Non-Food-Artikel kann er n\u00f6tig sein.'),
    p('pfand_preis', 'preise', 'pflicht', 'Pfand getrennt vom Preis angeben', 'Das Pfand von mindestens 0,25 \u20ac je Einwegflasche oder Dose steht neben dem Preis, zum Beispiel \u201e1,80 \u20ac zzgl. 0,25 \u20ac Pfand\u201c.',
      '\u00a7 7 PAngV; \u00a7 46 Abs. 1 VerpackDG', 'Getr\u00e4nke in Einweg-Pfandverpackungen', [L.pfand], function (c) { return hat(c, 'pfand'); }),
    p('pfand_ruecknahme', 'preise', 'pflicht', 'Leergut-R\u00fccknahme in zumutbarer Entfernung', 'Der Automat muss kein Leergut annehmen. Sie sichern eine R\u00fcckgabem\u00f6glichkeit in zumutbarer Entfernung, etwa beim Standortgeber, und nennen sie am Automaten.',
      '\u00a7 46 Abs. 2 Satz 5 VerpackDG (seit 12.08.2026)', 'Getr\u00e4nke in Einweg-Pfandverpackungen', [L.pfand, L.pfandvertrag], function (c) { return hat(c, 'pfand'); }),
    p('einweg_schild', 'preise', 'hinweis', 'Kein EINWEG-Schild n\u00f6tig', 'Getr\u00e4nke- und Verpflegungsautomaten sind von der Pflicht zum Hinweisschild \u201eEINWEG\u201c/\u201eMEHRWEG\u201c ausgenommen; Pfand und R\u00fcckgabestelle nennen Sie trotzdem.',
      '\u00a7 47 Abs. 5 VerpackDG i. V. m. \u00a7 4 Abs. 3 Nr. 5 PAngV', 'Getr\u00e4nke in Einweg-Pfandverpackungen', [L.pfand], function (c) { return hat(c, 'pfand'); }),
    p('mehrweg', 'preise', 'pflicht', 'Mehrweg f\u00fcr Hei\u00dfgetr\u00e4nke anbieten', 'Bef\u00fcllt der Automat Einwegbecher, bieten Sie die Ware auch in Mehrweg an oder lassen eigene Becher zu und weisen mit einem gut lesbaren Schild darauf hin.',
      '\u00a7 60 Abs. 1 und \u00a7 61 Abs. 2 und 4 VerpackDG', '\u00f6ffentlich zug\u00e4ngliche Hei\u00dfgetr\u00e4nkeautomaten', [L.pfand, L.kaffee], function (c) { return hat(c, 'heiss') && c.a.standort !== 'betrieb'; }),
    p('mehrweg_betrieb', 'preise', 'hinweis', 'Keine Mehrwegpflicht im Betrieb', 'Automaten, die nur f\u00fcr Besch\u00e4ftigte und nicht \u00f6ffentlich zug\u00e4nglich aufgestellt sind, sind von der Mehrwegpflicht ausgenommen.',
      '\u00a7 60 Abs. 1 Satz 4 VerpackDG', 'Hei\u00dfgetr\u00e4nke im Betrieb', [L.pfand, L.kaffee], function (c) { return hat(c, 'heiss') && c.a.standort === 'betrieb'; }),
    p('lucid', 'preise', 'pflicht', 'Im Verpackungsregister LUCID registrieren', 'Wer Einwegbecher im Automaten bef\u00fcllt, registriert sich selbst bei der Zentralen Stelle Verpackungsregister \u2013 auch wenn die Becher vorlizenziert gekauft werden.',
      '\u00a7 6 und \u00a7 7 Abs. 2 VerpackDG', 'Hei\u00dfgetr\u00e4nke in Einwegbechern', [L.pfand, L.kaffee], function (c) { return hat(c, 'heiss'); }),

    p('standsicherheit', 'technik', 'pflicht', 'Automat standsicher aufstellen', 'Stellen Sie den Automaten nach der Anleitung des Herstellers auf und sichern Sie ihn gegen Kippen, etwa mit Wand- oder Bodenbefestigung \u2013 besonders bei Ger\u00e4ten mit Glasfront.',
      'Herstelleranleitung und Datenblatt; Produktnorm EN 60335-2-75', 'alle Betreiber', [L.aufstellen, L.betriebssicherheit, L.ersatzteile], function () { return true; }),
    p('elektro', 'technik', 'pflicht', 'Elektrische Pr\u00fcfung nach DGUV Vorschrift 3', 'Lassen Sie die Automaten vor der ersten Inbetriebnahme und danach in regelm\u00e4\u00dfigen Abst\u00e4nden pr\u00fcfen; das Pr\u00fcfprotokoll zeigen Sie Standortgeber und Versicherer.',
      'DGUV Vorschrift 3, \u00a7 5', 'Betriebe mit Besch\u00e4ftigten', [L.betriebssicherheit], function (c) { return c.a.mitarbeiter === 'ja'; }),
    p('elektro_solo', 'technik', 'pruefen', 'Elektrische Pr\u00fcfung auch ohne Besch\u00e4ftigte', 'Ohne Besch\u00e4ftigte ist die Pflicht nach DGUV Vorschrift 3 nicht eindeutig. Verkehrssicherung und Versicherungsbedingungen sprechen daf\u00fcr, die Pr\u00fcfung trotzdem machen zu lassen.',
      'DGUV Vorschrift 3, \u00a7 5', 'Betreiber ohne Besch\u00e4ftigte', [L.betriebssicherheit], function (c) { return c.a.mitarbeiter !== 'ja'; }),
    p('eichrecht', 'technik', 'hinweis', 'Eichrecht: nur bei Abrechnung nach Z\u00e4hler', 'F\u00fcr Automaten mit verpackter Ware gelten keine eigenen Eichpflichten. Wer Strom nach Zwischenz\u00e4hler abrechnet, braucht einen konformen Z\u00e4hler mit g\u00fcltiger Eichfrist. Hei\u00dfgetr\u00e4nke wie Kaffee, Tee und Kakao brauchen keinen F\u00fcllstrich am Becher.',
      '\u00a7 33 MessEG; \u00a7 5 Abs. 1 Nr. 3 MessEV', 'alle Betreiber', [L.aufstellungsvertrag, L.kaffee], function () { return true; }),
    p('fluchtwege', 'technik', 'pruefen', 'Fluchtwege und Treppenr\u00e4ume freihalten', 'Der Automat darf die Mindestbreite von Fluchtwegen nicht unterschreiten und steht nicht in notwendigen Treppenr\u00e4umen; die Regeln dazu sind teils Landesrecht.',
      'ASR A2.3; zum Beispiel \u00a7 22 Abs. 4 VVB Bayern', 'Innenstandorte', [L.betriebssicherheit, L.standortwahl, L.standortcheck], function (c) { return c.a.standort === 'betrieb' || c.a.standort === 'oeffentlich'; }),
    p('sondernutzung', 'technik', 'pflicht', 'Sondernutzungserlaubnis beantragen', 'F\u00fcr Automaten auf Gehweg, Platz oder Stra\u00dfe brauchen Sie eine Sondernutzungserlaubnis der Gemeinde. Manche St\u00e4dte lassen Warenautomaten dort grunds\u00e4tzlich nicht zu.',
      'Landesstra\u00dfenrecht, zum Beispiel \u00a7 11 BerlStrG', '\u00f6ffentlicher Stra\u00dfenraum', [L.outdoor, L.standortcheck], function (c) { return c.a.standort === 'strasse'; }),
    p('baurecht', 'technik', 'pruefen', 'Baurecht und Werbeanlagen pr\u00fcfen', 'In vielen L\u00e4ndern sind Warenautomaten verfahrensfrei. Ortsrecht, Sanierungsgebiete und Regeln f\u00fcr Werbeanlagen k\u00f6nnen trotzdem Anforderungen stellen.',
      'Landesbauordnung, zum Beispiel Art. 57 Abs. 1 Nr. 12 a BayBO', 'Au\u00dfenstandorte', [L.outdoor], function (c) { return c.a.standort === 'aussen' || c.a.standort === 'strasse'; }),

    p('standortvertrag', 'vertraege', 'pflicht', 'Aufstellung mit dem Standortgeber vereinbaren', 'Ohne Erlaubnis des Eigent\u00fcmers oder Hausrechtsinhabers kein Automat. Regeln Sie Fl\u00e4che, Strom, Verg\u00fctung, Laufzeit und Haftung schriftlich.',
      'Erlaubnis des Hausrechtsinhabers; Gestattungsvertrag (BGH, Urteil vom 07.10.2020, XII ZR 145/19)', 'fremde Stellfl\u00e4che', [L.aufstellungsvertrag, L.vertragspraxis], function (c) { return c.a.flaeche === 'fremd'; }),
    p('kartenaufschlag', 'vertraege', 'pflicht', 'Kein Aufschlag f\u00fcr Kartenzahlung', 'Ein Entgelt f\u00fcr die Zahlung mit Karte ist gegen\u00fcber Verbrauchern unwirksam: Es gilt ein Preis f\u00fcr alle Zahlarten.',
      '\u00a7 270a BGB', 'Kartenzahlung', [L.kartengebuehren, L.kartensteuerung], function (c) { return c.a.zahlung === 'karte' || c.a.zahlung === 'beides'; }),
    p('datenschutz_karte', 'vertraege', 'pruefen', 'Datenschutzhinweis bei Kartenzahlung und Telemetrie', 'Verkaufsdaten ohne Personenbezug sind unkritisch. Kundenkarten, Apps oder Konten verarbeiten personenbezogene Daten \u2013 dann geh\u00f6rt ein Datenschutzhinweis an das Ger\u00e4t, etwa per QR-Code.',
      'DSGVO, Einordnung im Einzelfall', 'Kartenzahlung', [L.datenschutz, L.telemetrie], function (c) { return c.a.zahlung === 'karte' || c.a.zahlung === 'beides'; }),
    p('nur_bar', 'vertraege', 'pruefen', 'Kartenzahlung einplanen', 'Geplant ist ab 2027 eine Pflicht, neben Bargeld mindestens eine digitale Zahlungsart anzubieten. Ob Warenautomaten erfasst sind, ist noch offen.',
      'Eckpunkte des Bundesfinanzministeriums vom 11.09.2026, noch kein Gesetz', 'nur Bargeld', [L.nachruesten, L.onyx], function (c) { return c.a.zahlung === 'bar'; }),
    p('video', 'vertraege', 'pflicht', 'Video\u00fcberwachung transparent und sparsam', 'Erfassen Sie nur Ger\u00e4t und Ausgabebereich, stellen Sie ein Hinweisschild vor den Erfassungsbereich und speichern Sie Aufnahmen nur kurz. Sind Besch\u00e4ftigte im Bild, binden Sie den Betriebsrat ein.',
      'Art. 6 Abs. 1 lit. f und Art. 13 DSGVO; Orientierungshilfe Video\u00fcberwachung der Datenschutzkonferenz', 'Kamera am Automaten', [L.datenschutz, L.sicherheit], function (c) { return c.a.kamera === 'ja'; }),
    p('versicherung', 'vertraege', 'pruefen', 'Versicherungsschutz kl\u00e4ren', 'Gesetzlich vorgeschrieben ist keine Versicherung. Standortgeber verlangen oft eine Betriebshaftpflicht mit Produkt- und Lebensmittelhaftung; gegen Aufbruch und Vandalismus gibt es Automaten- und Inhaltsversicherungen.',
      'keine gesetzliche Pflicht; Nachweis oft im Aufstellungsvertrag vereinbart', 'alle Betreiber', [L.versicherung, L.sicherheit], function () { return true; })
  ];

  function pflichtenStandard() {
    var a = { gewerbe: 'neu', steuer: 'regel', mitarbeiter: 'nein', standort: 'betrieb', flaeche: 'fremd', kuehlung: 'ja', unverpackt: 'nein', zahlung: 'beides', kamera: 'nein' };
    PFLICHT_FRAGEN[5].optionen.forEach(function (o) { a['sortiment.' + o] = o === 'snacks' || o === 'pfand'; });
    return a;
  }

  function pflichtenBeispiel() {
    return mischeFlach(pflichtenStandard(), { mitarbeiter: 'ja', standort: 'oeffentlich', kamera: 'ja', 'sortiment.heiss': true, 'sortiment.frisch': true });
  }

  function pflichtAntworten(antworten) {
    var w = mischeFlach(pflichtenStandard(), antworten);
    var a = {};
    var s = {};
    PFLICHT_FRAGEN.forEach(function (f) {
      if (f.art === 'mehr') f.optionen.forEach(function (o) { s[o] = istJa(w['sortiment.' + o]); });
      else a[f.id] = f.optionen.indexOf(w[f.id]) !== -1 ? w[f.id] : pflichtenStandard()[f.id];
    });
    return { a: a, s: s };
  }

  function gruppenIndex(id) {
    for (var i = 0; i < PFLICHT_GRUPPEN.length; i++) if (PFLICHT_GRUPPEN[i].id === id) return i;
    return PFLICHT_GRUPPEN.length;
  }

  function sortiereNachGruppe(liste) {
    return liste.map(function (x, i) { return { x: x, i: i }; }).sort(function (u, v) {
      return gruppenIndex(u.x.gruppe) - gruppenIndex(v.x.gruppe) || u.i - v.i;
    }).map(function (u) { return u.x; });
  }

  /* c = Antworten (pflichtAntworten) oder null fuer die statische Checkliste (Paket H: Text je Antwort, mitText) */
  function auszug(q, c) {
    var text = q.textWenn && (c === null || q.textWenn.wenn(c)) ? q.textWenn.text : q.text;
    return { id: q.id, gruppe: q.gruppe, status: q.status, titel: q.titel, text: text, norm: q.norm, fuer: q.fuer, links: q.links.map(function (l) { return { text: l.text, href: l.href }; }) };
  }

  function pflichten(antworten) {
    var c = pflichtAntworten(antworten);
    return sortiereNachGruppe(PFLICHTEN.filter(function (q) { return q.wenn(c); })).map(function (q) { return auszug(q, c); });
  }

  function pflichtBlock(q, erledigt, mitFuer) {
    return { art: 'pflicht', id: q.id, status: q.status, statusText: TEXTE.status[q.status], titel: q.titel, text: q.text, norm: q.norm, fuer: mitFuer ? q.fuer : '', links: q.links, erledigt: !!erledigt };
  }

  function gruppiert(liste, block) {
    return PFLICHT_GRUPPEN.map(function (g) {
      var teil = liste.filter(function (q) { return q.gruppe === g.id; });
      return teil.length ? { id: g.id, nr: '', titel: g.titel, bloecke: teil.map(block) } : null;
    }).filter(Boolean);
  }

  function pflichtenDokument(antworten, erledigt, kontext) {
    var c = pflichtAntworten(antworten);
    var t = kontextTexte(kontext, 'pflichten');
    var liste = pflichten(antworten);
    var fertig = {};
    (erledigt || []).forEach(function (id) { fertig[id] = true; });
    var punkte = PFLICHT_FRAGEN.map(function (f) {
      if (f.art === 'mehr') {
        var gew = f.optionen.filter(function (o) { return c.s[o]; }).map(function (o) { return f.texte[o]; });
        return f.kurz + ': ' + (gew.length ? gew.join(', ') : 'keine Angabe');
      }
      return f.kurz + ': ' + f.texte[c.a[f.id]];
    });
    var anzahl = liste.filter(function (q) { return fertig[q.id]; }).length;
    return {
      werkzeug: 'pflichten',
      titel: TEXTE.titel.pflichten,
      untertitel: t.kurz,
      kopf: [{ art: 'angaben', punkte: punkte }, { art: 'fortschritt', erledigt: anzahl, gesamt: liste.length }],
      abschnitte: gruppiert(liste, function (q) { return pflichtBlock(q, fertig[q.id], false); }),
      anlagen: [],
      unterschriften: [],
      rechtshinweis: t.rechtshinweis,
      stand: t.stand
    };
  }

  /* vollstaendiger Katalog mit Geltung (statische Checkliste) */
  function pflichtenKatalog(kontext) {
    var t = kontextTexte(kontext, 'pflichten');
    return {
      werkzeug: 'pflichten',
      titel: TEXTE.titel.katalog,
      untertitel: t.kurz,
      kopf: [absatz('Der Katalog enth\u00e4lt alle Punkte des Pflichten-Checks mit ihrer Geltung. Ihre pers\u00f6nliche Liste mit Fortschritt erstellen Sie im Pflichten-Check von MV Vending.')],
      abschnitte: gruppiert(sortiereNachGruppe(PFLICHTEN.map(function (q) { return auszug(q, null); })), function (q) { return pflichtBlock(q, false, true); }),
      anlagen: [],
      unterschriften: [],
      rechtshinweis: t.rechtshinweis,
      stand: t.stand
    };
  }

  /* ------------------------------------------------------------------ Zustand im Browser */

  function leseZustand(text) {
    if (typeof text !== 'string' || !text) return null;
    var o;
    try {
      o = JSON.parse(text);
    } catch (e) {
      return null;
    }
    if (!o || typeof o !== 'object' || Array.isArray(o) || o.v !== 1 || !o.werte || typeof o.werte !== 'object' || Array.isArray(o.werte)) return null;
    var z = { v: 1, werte: {} };
    Object.keys(o.werte).forEach(function (k) {
      var v = o.werte[k];
      if (!/^[A-Za-z0-9_.]{1,80}$/.test(k)) return;
      if (typeof v === 'boolean') z.werte[k] = v;
      else if (typeof v === 'string') z.werte[k] = v.slice(0, 4000);
    });
    if (typeof o.schritt === 'string') z.schritt = o.schritt;
    if (Array.isArray(o.erledigt)) z.erledigt = o.erledigt.filter(function (x) { return typeof x === 'string'; });
    return z;
  }

  function zustandText(z) {
    return JSON.stringify(z);
  }

  /* ------------------------------------------------------------------ Kundenkonto (Paket A-2b) */

  /* Werkzeug-Schluessel laut Vertrag (Plan Abschnitt 3) */
  var KONTO = { vertrag: 'vertrag-aufstellung', businessplan: 'businessplan', pflichten: 'pflichten-check' };
  /* Aufstellungsvertrag: Angaben zu Personen und Anschriften, die nie in den Stand (Browser-Spiegel und Konto) kommen
     (Plan Abschnitt 2.6: keine Adressdaten im Stand); sie bleiben nur im Browser unter PERSONEN_SPEICHER */
  var PERSONEN_FELDER = {
    vertrag: ['standortgeber.firma', 'standortgeber.anschrift', 'standortgeber.vertreter', 'standortgeber.steuer', 'standortgeber.ansprechpartner',
      'betreiber.firma', 'betreiber.anschrift', 'betreiber.vertreter', 'betreiber.steuer', 'betreiber.telefon', 'standort.anschrift']
  };
  var PERSONEN_SPEICHER = 'mv-vorlagen:vertrag:personen';
  var TITEL_MAX = 80;
  var TITEL_MAX_BUSINESSPLAN = 120;   /* wie die Bruecke von A-2a (assets/mv-sortiment.businessplan.js, kontoTitel) */

  function personenFeld(w, name) {
    return !!PERSONEN_FELDER[w] && PERSONEN_FELDER[w].indexOf(name) !== -1;
  }

  /* Titel fuer "Meine Werkzeuge": Leerraum zusammengefasst; laenger als max -> mit Auslassung (Businessplan: abgeschnitten
     wie A-2a) */
  function kontoTitel(w, werte, erledigt) {
    var v = werte || {};
    if (w === 'businessplan') {
      var n = txt(v['vorhaben.name']);
      return n.length > TITEL_MAX_BUSINESSPLAN ? n.slice(0, TITEL_MAX_BUSINESSPLAN) : n;
    }
    var t = '';
    if (w === 'vertrag') {
      var geraete = Object.keys(v).filter(function (k) { return /^geraete\.\d+\.titel$/.test(k) && txt(v[k]); }).sort(function (a, b) {
        return Number(a.split('.')[1]) - Number(b.split('.')[1]);
      }).map(function (k) { return txt(v[k]); });
      t = [geraete.join(', '), MODELL_NAME[v['verguetung.modell']] || ''].filter(function (x) { return !!x; }).join(' \u00b7 ');
    } else if (w === 'pflichten') {
      var liste = pflichten(v);
      var fertig = liste.filter(function (q) { return (erledigt || []).indexOf(q.id) !== -1; }).length;
      t = liste.length + ' Punkte, davon ' + fertig + ' ' + TEXTE.erledigt;
    }
    t = txt(t);
    return t.length > TITEL_MAX ? t.slice(0, TITEL_MAX - 1).replace(/\s+$/, '') + '\u2026' : t;
  }

  /* Stand fuers Konto: { v: 1, werte (nur Text und Wahrheitswerte, Vertrag ohne PERSONEN_FELDER), schritt, erledigt (nur
     Pflichten-Check), titel }; Businessplan in der Form der Bruecke von A-2a */
  function kontoStand(w, werte, schritt, erledigt) {
    var q = werte && typeof werte === 'object' ? werte : {};
    var o = {};
    Object.keys(q).forEach(function (k) {
      if ((typeof q[k] === 'string' || typeof q[k] === 'boolean') && !personenFeld(w, k)) o[k] = q[k];
    });
    var s = { v: 1, werte: o, schritt: typeof schritt === 'string' ? schritt : '' };
    if (w === 'pflichten') s.erledigt = Array.isArray(erledigt) ? erledigt.filter(function (x) { return typeof x === 'string'; }) : [];
    var t = kontoTitel(w, o, s.erledigt);
    if (t) s.titel = t;
    return s;
  }

  /* Stand aus Konto oder Spiegel -> Zustand wie leseZustand (gleiche Pruefung), sonst null */
  function zustandAusKonto(stand) {
    if (!stand || typeof stand !== 'object' || Array.isArray(stand) || stand.v !== 1) return null;
    return leseZustand(zustandText({ v: 1, werte: stand.werte, schritt: stand.schritt, erledigt: stand.erledigt }));
  }

  /* Angaben zu Personen eines Werkzeugs (nur nicht leere Texte) */
  function personenWerte(w, werte) {
    var o = {};
    var q = werte || {};
    (PERSONEN_FELDER[w] || []).forEach(function (k) {
      if (typeof q[k] === 'string' && q[k] !== '') o[k] = q[k];
    });
    return o;
  }

  var api = {
    KONTO: KONTO, PERSONEN_FELDER: PERSONEN_FELDER, PERSONEN_SPEICHER: PERSONEN_SPEICHER, kontoStand: kontoStand, kontoTitel: kontoTitel,
    zustandAusKonto: zustandAusKonto, personenWerte: personenWerte, personenFeld: personenFeld,
    VERSION: VERSION, WERKZEUGE: WERKZEUGE, SPEICHER: SPEICHER, LUECKE: LUECKE, TEXTE: TEXTE, SCHRITTE: SCHRITTE, BEZUEGE: BEZUEGE, KLAUSEL_TITEL: KLAUSEL_TITEL,
    REITER_STANDARD: REITER_STANDARD, ANNAHMEN_STANDARD: ANNAHMEN_STANDARD, PFLICHT_GRUPPEN: PFLICHT_GRUPPEN, PFLICHT_FRAGEN: PFLICHT_FRAGEN, PFLICHTEN: PFLICHTEN,
    zahl: zahl, zahlText: zahlText, feldZahl: feldZahl, euro: euro, prozent: prozent, datumText: datumText, ausFlach: ausFlach, zuFlach: zuFlach, mischeFlach: mischeFlach,
    vertrag: vertrag, vertragKlauseln: vertragKlauseln, vertragStandard: vertragStandard, vertragBeispiel: vertragBeispiel, kwhAus: kwhAus, stromPauschale: stromPauschale,
    rechnePlan: rechnePlan, businessplan: businessplan, planStandard: planStandard, planBeispiel: planBeispiel, planCsv: planCsv, balken: balken, balkenAus: balkenAus,
    pflichten: pflichten, pflichtenDokument: pflichtenDokument, pflichtenKatalog: pflichtenKatalog, pflichtenStandard: pflichtenStandard, pflichtenBeispiel: pflichtenBeispiel,
    dokumentText: dokumentText, dokumentMarkdown: dokumentMarkdown, dokumentHtml: dokumentHtml, leseZustand: leseZustand, zustandText: zustandText,
    konfigurationText: konfigurationText,
    AFA_JAHRE: AFA_JAHRE, AFA_JAHRE_GETRAENKE: AFA_JAHRE_GETRAENKE, afaVorschlag: afaVorschlag, geraetTypVon: geraetTypVon, afaGetraenkeGeraet: afaGetraenkeGeraet,
    /* D-B: fuer assets/mv-sortiment.businessplan.js */
    erweitere: erweitere, TYP_NAME: TYP_NAME, SCHWERPUNKT: SCHWERPUNKT, RECHTSFORM: RECHTSFORM, FINANZIERUNG_NAME: FINANZIERUNG_NAME, geraetAus: geraetAus,
    geraeteName: geraeteName, afaJahreAus: afaJahreAus, kontextTexte: kontextTexte
  };

  if (typeof module === 'object' && module && module.exports) {
    module.exports = api;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* ------------------------------------------------------------------ DOM */

  /* Waechter (siehe Kopf) */
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.vorlagen) return;
  MV.vorlagen = api;
  /* A-2b: dieses Modul speichert selbst ueber MVKonto; die Bruecke in assets/mv-sortiment.businessplan.js (A-2a) tritt
     zurueck (sie prueft kontoSelbst vor dem Start) */
  api.kontoSelbst = true;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var ZUSTAND = typeof WeakMap === 'function' ? new WeakMap() : null;
  var speicherOk;

  function zustand(root) {
    return ZUSTAND ? ZUSTAND.get(root) : root.__mvVorlagen;
  }

  function merke(root, z) {
    if (ZUSTAND) ZUSTAND.set(root, z);
    else root.__mvVorlagen = z;
  }

  /* localStorage nur, wenn er sich lesen und schreiben laesst (privater Modus, gesperrte Cookies) */
  function speicher() {
    if (speicherOk !== undefined) return speicherOk;
    speicherOk = null;
    try {
      var s = window.localStorage;
      if (s) {
        s.setItem('mv-vorlagen:__probe', '1');
        s.removeItem('mv-vorlagen:__probe');
        speicherOk = s;
      }
    } catch (e) {
      speicherOk = null;
    }
    return speicherOk;
  }

  /* A-2b: mit MVKonto nur ueber MVKonto (Plan, Vertrag Abschnitt 3; SPEICHER sind dann Altschluessel fuer die Migration,
     kontoAnmelden); ohne MVKonto (Rueckfall, etwa beim Rueckweg von A-2a) wie vor A-2b unter SPEICHER */
  function ladeStand(w) {
    var mv = kontoApi();
    if (mv) return kontoLadeStand(mv, w);
    var s = speicher();
    if (!s) return null;
    try {
      return leseZustand(s.getItem(SPEICHER[w]));
    } catch (e) {
      return null;
    }
  }

  function sichere(root) {
    var z = zustand(root);
    if (z && z.konto) {
      kontoSpeichern(root, false);
      return;
    }
    var s = speicher();
    if (!z || !s) return;
    try {
      s.setItem(SPEICHER[z.w], zustandText({ v: 1, werte: z.werte || {}, schritt: z.schritt || '', erledigt: z.erledigt || [] }));
    } catch (e) { /* Speicher voll: Stand gilt nur fuer diese Seite */ }
  }

  function vergiss(w) {
    var mv = kontoApi();
    if (mv) {
      personenEntfernen(w);
      mv.loeschen(KONTO[w]);
      return;
    }
    var s = speicher();
    if (!s) return;
    try {
      s.removeItem(SPEICHER[w]);
    } catch (e) { /* ohne Speicher nichts zu loeschen */ }
  }

  /* ---------------------------------------------------- Kundenkonto (Paket A-2b) */

  /* MVKonto (assets/mv-sortiment.konto.js) steht im Buendel vor dieser Datei; trotzdem erst beim Aufruf aufloesen. Ohne
     MVKonto (oder ohne die Erweiterungen lokal und migration von A-2a) bleibt es bei den Schluesseln SPEICHER. */
  function kontoApi() {
    var k = window.MVKonto;
    return k && typeof k.lokal === 'function' && typeof k.speichern === 'function' && typeof k.lesen === 'function' &&
      typeof k.loeschen === 'function' && typeof k.migration === 'function' ? k : null;
  }

  /* Angaben zu Personen (Aufstellungsvertrag) nur im Browser: { v: 1, werte } unter PERSONEN_SPEICHER */
  function personenLesen(w) {
    var s = speicher();
    if (!PERSONEN_FELDER[w] || !s) return {};
    try {
      var z = leseZustand(s.getItem(PERSONEN_SPEICHER));
      return z ? personenWerte(w, z.werte) : {};
    } catch (e) {
      return {};
    }
  }

  function personenSichern(w, werte) {
    var s = speicher();
    if (!PERSONEN_FELDER[w] || !s) return;
    var p = personenWerte(w, werte);
    try {
      if (Object.keys(p).length) s.setItem(PERSONEN_SPEICHER, zustandText({ v: 1, werte: p }));
      else s.removeItem(PERSONEN_SPEICHER);
    } catch (e) { /* Speicher voll: die Angaben gelten nur fuer diese Seite */ }
  }

  function personenEntfernen(w) {
    var s = speicher();
    if (!PERSONEN_FELDER[w] || !s) return;
    try {
      s.removeItem(PERSONEN_SPEICHER);
    } catch (e) { /* ohne Speicher nichts zu loeschen */ }
  }

  /* Altschluessel einmalig in den Spiegel (verschoben, nicht geteilt; ohne Zeitstempel verliert er gegen jeden
     Konto-Stand). Vertrag: die Angaben zu Personen gehen dabei unter PERSONEN_SPEICHER, nicht in den Stand. */
  function kontoAnmelden(mv) {
    WERKZEUGE.forEach(function (w) {
      mv.migration(new RegExp('^' + KONTO[w] + '$'), {
        geteilt: false,
        alt: function () { return SPEICHER[w]; },
        lesen: function (roh) {
          var z = leseZustand(roh);
          if (!z) return null;
          if (PERSONEN_FELDER[w] && !Object.keys(personenLesen(w)).length) personenSichern(w, z.werte);
          return kontoStand(w, z.werte, z.schritt || '', z.erledigt || []);
        }
      });
    });
  }

  /* Stand aus dem Spiegel (migriert beim ersten Mal); Vertrag: Angaben zu Personen aus dem Browser dazu. Steht der
     Altschluessel neben einem Spiegel noch da (Bruecke von A-2a hielt ihn geteilt), wird er aufgeraeumt. */
  function kontoLadeStand(mv, w) {
    var e = mv.lokal(KONTO[w]);
    var z = e ? zustandAusKonto(e.stand) : null;
    var s = speicher();
    if (e && s) {
      try {
        var alt = s.getItem(SPEICHER[w]);
        if (alt !== null) {
          var a = leseZustand(alt);
          if (a && PERSONEN_FELDER[w] && !Object.keys(personenLesen(w)).length) personenSichern(w, a.werte);
          s.removeItem(SPEICHER[w]);
        }
      } catch (f) { /* ohne Speicher nichts aufzuraeumen */ }
    }
    if (PERSONEN_FELDER[w]) {
      var p = personenLesen(w);
      if (Object.keys(p).length) z = { v: 1, werte: mischeFlach(z ? z.werte : {}, p), schritt: z ? z.schritt : undefined, erledigt: z ? z.erledigt : undefined };
    }
    return z;
  }

  /* Text des Stands und sein Inhalt ohne Schritt (Vergleich: geaendert oder nur geblaettert) */
  function kontoTexte(z) {
    var st = kontoStand(z.w, z.werte, z.schritt || '', z.erledigt || []);
    return { stand: st, text: zustandText(st), inhalt: zustandText([st.werte, st.erledigt || null]) };
  }

  /* Ganzer Stand in Spiegel und Konto, nur wenn er sich geaendert hat; vor der ersten Antwort des Kontos wartet blosses
     Blaettern (nur der Schritt anders), damit ein aelterer Browser-Stand keinen neueren Konto-Stand ueberholt.
     immer = nach dem Abgleich (die Seite gilt). Die Angaben zu Personen gehen nur in den Browser. */
  function kontoSpeichern(root, immer) {
    var z = zustand(root);
    if (!z || !z.konto) return;
    if (PERSONEN_FELDER[z.w]) personenSichern(z.w, z.werte);
    var k = kontoTexte(z);
    if (!immer) {
      if (k.text === z.kontoText) return;
      if (!z.kontoGelesen && k.inhalt === z.kontoInhalt) return;
    }
    if (k.inhalt !== z.kontoInhalt) z.geaendert = true;
    z.kontoText = k.text;
    z.kontoInhalt = k.inhalt;
    z.kontoLeer = false;
    z.konto.speichern(KONTO[z.w], k.stand);
  }

  function kontoMerken(z) {
    var k = kontoTexte(z);
    z.kontoText = k.text;
    z.kontoInhalt = k.inhalt;
  }

  /* Aufstellungsvertrag, angemeldet: Satz unter der Statuszeile, dass die Angaben zu Personen nicht ins Konto gehen */
  function personenHinweis(root, mv) {
    var z = zustand(root);
    if (!z || !PERSONEN_FELDER[z.w] || typeof mv.eingeloggt !== 'function' || !mv.eingeloggt()) return;
    var box = root.querySelector('[data-mv-konto-hinweis]');
    if (!box || !box.parentNode || root.querySelector('[data-mv-vorlagen-konto-personen]')) return;
    var p = document.createElement('p');
    p.className = 'mv-konto';
    p.setAttribute('data-mv-vorlagen-konto-personen', '');
    p.textContent = TEXTE.ui.kontoPersonen;
    box.parentNode.insertBefore(p, box.nextSibling);
  }

  /* Nach init: Statuszeile binden, Stand merken, mit Login den Konto-Stand abgleichen (ausser nach einem Neustart aus dem
     Abgleich) */
  function kontoStart(root, mv, ohneAbgleich) {
    var z = zustand(root);
    z.konto = mv;
    z.geaendert = false;
    z.kontoLeer = false;
    var angemeldet = typeof mv.eingeloggt === 'function' && mv.eingeloggt();
    z.kontoGelesen = !angemeldet || !!ohneAbgleich;
    kontoMerken(z);
    /* aus dem Snippet der Sektion; fehlt es (Sektion vor A-2b), baut MVKonto die Zeile am Ende des Kopftexts */
    var box = root.querySelector('[data-mv-konto-hinweis]') || root.querySelector('.mv-seitenkopf__text');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, KONTO[z.w]);
    personenHinweis(root, mv);
    if (z.kontoGelesen) return;
    mv.lesen(KONTO[z.w]).then(function (r) { kontoAbgleich(root, r); }, function () {
      var y = zustand(root);
      if (y) y.kontoGelesen = true;
    });
  }

  /* Antwort des Kontos: abweichender Stand (anderes Geraet) oder im Konto geloescht. Schon eingegeben: die Seite gilt
     und geht wieder ins Konto (nach "Eingaben loeschen": dort loeschen), auch bei nachgehender Geraeteuhr. Sonst startet
     die Wurzel neu und zeigt den Stand aus dem Spiegel, den MVKonto nachgefuehrt hat. */
  function kontoAbgleich(root, r) {
    var z = zustand(root);
    if (!z || !z.konto) return;
    z.kontoGelesen = true;
    if (!r || (!r.neu && !r.verworfen)) return;
    if (z.geaendert) {
      if (z.kontoLeer) z.konto.loeschen(KONTO[z.w]);
      else kontoSpeichern(root, true);
      return;
    }
    if (r.verworfen) personenEntfernen(z.w);
    init(root, true);
  }

  function publiziere(name, daten) {
    try {
      var s = window.Shopify;
      if (s && s.analytics && typeof s.analytics.publish === 'function') s.analytics.publish(name, daten);
    } catch (e) { /* Analytics darf nie stoppen */ }
  }

  function melde(root, text) {
    var el = root.querySelector('[data-mv-vorlagen-status]');
    if (el) el.textContent = text;
  }

  function leseDaten(root) {
    var s = root.querySelector('script[type="application/json"][data-mv-vorlagen-daten]');
    if (!s) return {};
    try {
      var d = JSON.parse(s.textContent);
      return d && typeof d === 'object' ? d : {};
    } catch (e) {
      return {};
    }
  }

  function standardFuer(w, daten) {
    if (w === 'vertrag') return vertragStandard(daten);
    if (w === 'businessplan') return planStandard(daten);
    return pflichtenStandard();
  }

  function beispielFuer(w, daten) {
    if (w === 'vertrag') return vertragBeispiel(daten);
    if (w === 'businessplan') return planBeispiel(daten);
    return pflichtenBeispiel();
  }

  function felder(root) {
    return root.querySelectorAll('[data-mv-vorlagen-feld]');
  }

  function feldMitName(root, name) {
    var liste = felder(root);
    for (var i = 0; i < liste.length; i++) if (liste[i].name === name) return liste[i];
    return null;
  }

  function lesen(root) {
    var o = {};
    var liste = felder(root);
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      if (!el.name) continue;
      if (el.type === 'checkbox') o[el.name] = !!el.checked;
      else if (el.type === 'radio') {
        if (el.checked) o[el.name] = el.value;
      } else o[el.name] = el.value;
    }
    return o;
  }

  /* ---------------------------------------------------- Zeilen (Geraete, Standorte, Meilensteine) */

  function zeilenListe(gruppe) {
    var liste = gruppe.querySelector('[data-mv-vorlagen-zeilen-liste]');
    var z = [];
    if (!liste) return z;
    for (var i = 0; i < liste.children.length; i++) if (liste.children[i].hasAttribute('data-mv-vorlagen-zeile')) z.push(liste.children[i]);
    return z;
  }

  function grenze(gruppe, attr, standard) {
    var n = parseInt(gruppe.getAttribute(attr), 10);
    return isFinite(n) ? n : standard;
  }

  function nummeriereZeilen(gruppe) {
    var typ = gruppe.getAttribute('data-mv-vorlagen-zeilen');
    var nameRe = new RegExp('^' + typ + '\\.(?:\\d+|__i__)\\.');
    var idRe = new RegExp('-f-' + typ + '-(?:\\d+|__i__)-', 'g');
    var zeilen = zeilenListe(gruppe);
    zeilen.forEach(function (zeile, i) {
      zeile.setAttribute('data-mv-vorlagen-index', String(i));
      var alle = zeile.querySelectorAll('*');
      for (var j = 0; j < alle.length; j++) {
        var el = alle[j];
        if (el.hasAttribute('name')) el.setAttribute('name', el.getAttribute('name').replace(nameRe, typ + '.' + i + '.'));
        if (el.hasAttribute('data-mv-vorlagen-wenn')) el.setAttribute('data-mv-vorlagen-wenn', el.getAttribute('data-mv-vorlagen-wenn').replace(nameRe, typ + '.' + i + '.'));
        ['id', 'for', 'aria-describedby', 'aria-labelledby'].forEach(function (a) {
          if (el.hasAttribute(a)) el.setAttribute(a, el.getAttribute(a).replace(idRe, '-f-' + typ + '-' + i + '-'));
        });
      }
    });
    var min = grenze(gruppe, 'data-mv-vorlagen-min', 0);
    var max = grenze(gruppe, 'data-mv-vorlagen-max', 12);
    zeilen.forEach(function (zeile) {
      var weg = zeile.querySelector('[data-mv-vorlagen-zeile-weg]');
      if (weg) weg.hidden = zeilen.length <= min;
    });
    var neu = gruppe.querySelector('[data-mv-vorlagen-zeile-neu]');
    if (neu) neu.hidden = zeilen.length >= max;
  }

  function setzeZeilenzahl(gruppe, soll) {
    var vorlage = gruppe.querySelector('template[data-mv-vorlagen-vorlage]');
    var liste = gruppe.querySelector('[data-mv-vorlagen-zeilen-liste]');
    if (!liste) return;
    var zeilen = zeilenListe(gruppe);
    while (zeilen.length > soll) liste.removeChild(zeilen.pop());
    while (zeilen.length < soll && vorlage && vorlage.content) {
      var teil = document.importNode(vorlage.content, true);
      var zeile = teil.firstElementChild || null;
      if (!zeile) break;
      liste.appendChild(zeile);
      zeilen.push(zeile);
    }
    nummeriereZeilen(gruppe);
  }

  function zeilenAnpassen(root, werte) {
    var gruppen = root.querySelectorAll('[data-mv-vorlagen-zeilen]');
    for (var i = 0; i < gruppen.length; i++) {
      var g = gruppen[i];
      var typ = g.getAttribute('data-mv-vorlagen-zeilen');
      var re = new RegExp('^' + typ + '\\.(\\d+)\\.');
      var hoechste = -1;
      for (var k in werte) {
        if (!eigen(werte, k)) continue;
        var m = re.exec(k);
        if (m && +m[1] > hoechste) hoechste = +m[1];
      }
      var soll = Math.min(Math.max(hoechste + 1, grenze(g, 'data-mv-vorlagen-min', 0)), grenze(g, 'data-mv-vorlagen-max', 12));
      setzeZeilenzahl(g, soll);
    }
  }

  function anwenden(root, werte) {
    var z = zustand(root);
    zeilenAnpassen(root, werte);
    if (z && z.w === 'businessplan') fuelleGeraeteWahl(root, z.daten);
    var liste = felder(root);
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      var v = eigen(werte, el.name) ? werte[el.name] : undefined;
      if (el.type === 'checkbox') el.checked = istJa(v);
      else if (el.type === 'radio') el.checked = v !== undefined && String(v) === el.value;
      else if (el.tagName === 'SELECT') {
        el.value = v === undefined ? '' : String(v);
        if (el.selectedIndex < 0 && el.options.length) el.selectedIndex = 0;
      } else el.value = v === undefined || v === null ? '' : String(v);
      el.removeAttribute('data-mv-vorlagen-eigen');
      el.removeAttribute('data-mv-vorlagen-auto');
    }
  }

  /* ---------------------------------------------------- Werkzeug-Helfer */

  function geraeteLabels(daten) {
    var z = [];
    ((daten && daten.geraete) || []).forEach(function (g) {
      (g.varianten || []).forEach(function (v) {
        z.push({ wert: g.handle + ':' + v.id, text: g.title + (v.titel ? ' \u2013 ' + v.titel : ''), preis: typeof v.preis === 'number' ? v.preis / 100 : NaN, energie: v.energie || '' });
      });
    });
    return z;
  }

  function fuelleGeraeteliste(root, daten) {
    var dl = root.querySelector('datalist[data-mv-vorlagen-geraeteliste]');
    if (!dl) return;
    while (dl.firstChild) dl.removeChild(dl.firstChild);
    var gesehen = {};
    geraeteLabels(daten).forEach(function (g) {
      if (gesehen[g.text]) return;
      gesehen[g.text] = true;
      var o = document.createElement('option');
      o.value = g.text;
      dl.appendChild(o);
    });
  }

  function fuelleGeraeteWahl(root, daten) {
    var g = geraetAus(daten);
    var labels = geraeteLabels(daten);
    var liste = felder(root);
    for (var i = 0; i < liste.length; i++) {
      var sel = liste[i];
      if (sel.tagName !== 'SELECT' || !/^standorte\.\d+\.geraet$/.test(sel.name)) continue;
      var alt = sel.value;
      while (sel.firstChild) sel.removeChild(sel.firstChild);
      var neu = [{ wert: 'standard', text: g.name + ' \u2013 ' + euro(g.preis) + ' ' + TEXTE.ui.netto }];
      labels.forEach(function (l) { if (isFinite(l.preis) && l.preis > 0) neu.push({ wert: l.wert, text: l.text + ' \u2013 ' + euro(l.preis) + ' ' + TEXTE.ui.netto }); });
      neu.push({ wert: 'eigen', text: TEXTE.ui.eigenesGeraet });
      neu.forEach(function (n) {
        var o = document.createElement('option');
        o.value = n.wert;
        o.textContent = n.text;
        sel.appendChild(o);
      });
      sel.value = alt;
      if (sel.selectedIndex < 0) sel.value = 'standard';
    }
  }

  function wendeReiterAn(root, z, i, typ) {
    var r = reiterAus(z.daten)[typ];
    if (!r) return;
    ['verkaeufe', 'preis', 'tage'].forEach(function (k) {
      var f = feldMitName(root, 'standorte.' + i + '.' + k);
      if (f && f.getAttribute('data-mv-vorlagen-eigen') !== '1') f.value = feldZahl(r[k]);
    });
  }

  function wendeGeraetAn(root, z, i, wert) {
    var f = feldMitName(root, 'standorte.' + i + '.geraetPreis');
    if (!f || wert === 'eigen') return;
    if (wert === 'standard') {
      f.value = feldZahl(geraetAus(z.daten).preis);
      return;
    }
    var l = geraeteLabels(z.daten).filter(function (x) { return x.wert === wert; })[0];
    if (l && isFinite(l.preis)) f.value = feldZahl(l.preis);
  }

  /* eigene Werte: weichen sie von der Voreinstellung des Typs ab, bleiben sie beim Typwechsel stehen */
  function markiereEigen(root, z) {
    var r = reiterAus(z.daten);
    var liste = felder(root);
    for (var i = 0; i < liste.length; i++) {
      var m = /^standorte\.(\d+)\.(verkaeufe|preis|tage)$/.exec(liste[i].name);
      if (!m) continue;
      var typ = feldMitName(root, 'standorte.' + m[1] + '.typ');
      var vor = typ && r[typ.value] ? r[typ.value][m[2]] : NaN;
      if (zahl(liste[i].value) !== vor) liste[i].setAttribute('data-mv-vorlagen-eigen', '1');
    }
    /* K-2: die Abschreibung ist eigen, wenn sie vom Vorschlag je Geraetetyp abweicht */
    var afa = feldMitName(root, 'investition.afaJahre');
    if (afa && zahl(afa.value) !== afaVorschlag(lesen(root), z.daten)) afa.setAttribute('data-mv-vorlagen-eigen', '1');
  }

  /* K-2: Abschreibung folgt dem Vorschlag je Geraetetyp (gekaufte Geraete), solange der Nutzer sie nicht selbst setzt */
  function wendeAfaAn(root, z) {
    var f = feldMitName(root, 'investition.afaJahre');
    if (!f || f.getAttribute('data-mv-vorlagen-eigen') === '1') return;
    var v = feldZahl(afaVorschlag(lesen(root), z.daten));
    if (f.value !== v) f.value = v;
  }

  function geraetZuName(daten, name) {
    var n = txt(name).toLowerCase();
    if (!n) return null;
    var l = geraeteLabels(daten).filter(function (x) { return x.text.toLowerCase() === n; });
    return l[0] || null;
  }

  function automatischKwh(root, z, el) {
    var g = geraetZuName(z.daten, el.value);
    var f = feldMitName(root, 'strom.kwh');
    if (!g || !f) return;
    var kwh = kwhAus(g.energie);
    if (kwh && (!f.value || f.getAttribute('data-mv-vorlagen-auto') === '1')) {
      f.value = String(kwh);
      f.setAttribute('data-mv-vorlagen-auto', '1');
    }
  }

  function stromVorschlag(root, z) {
    var out = root.querySelector('[data-mv-vorlagen-vorschlag="strom"]');
    if (!out) return;
    var knopf = root.querySelector('[data-mv-vorlagen-uebernehmen="strom"]');
    var p = stromPauschale(z.werte['strom.kwh'], z.werte['strom.preis']);
    z.vorschlag = p;
    if (p === null) {
      out.textContent = TEXTE.ui.vorschlagLeer;
      if (knopf) knopf.hidden = true;
      return;
    }
    out.textContent = TEXTE.ui.vorschlag + ': ' + euro(p, 2) + ' ' + TEXTE.ui.proMonat + ' (' + zahlText(zahl(z.werte['strom.kwh'])) + ' kWh \u00d7 ' + zahlText(zahl(z.werte['strom.preis']), 2) + NBSP + '\u20ac ' + TEXTE.ui.jeKwh + ' \u00f7 12)';
    if (knopf) knopf.hidden = false;
  }

  /* Bedingte Felder: data-mv-vorlagen-wenn="name:wert1,wert2" oder "name" (Haken gesetzt) */
  function bedingungen(root, werte) {
    var liste = root.querySelectorAll('[data-mv-vorlagen-wenn]');
    for (var i = 0; i < liste.length; i++) {
      var teile = liste[i].getAttribute('data-mv-vorlagen-wenn').split(':');
      var v = werte[teile[0]];
      var ok = teile.length > 1 ? teile[1].split(',').indexOf(String(v)) !== -1 : istJa(v);
      liste[i].hidden = !ok;
    }
  }

  /* ---------------------------------------------------- Dokument im DOM */

  function textKnoten(t) {
    return document.createTextNode(satz(t));
  }

  function knoten(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text !== undefined && text !== null) e.textContent = satz(text);
    return e;
  }

  function svgKnoten(tag, attr) {
    var e = document.createElementNS(SVG_NS, tag);
    for (var k in attr) if (eigen(attr, k)) e.setAttribute(k, attr[k]);
    return e;
  }

  function icon(root, name) {
    var t = root.querySelector('template[data-mv-vorlagen-icon="' + name + '"]');
    return t && t.content ? document.importNode(t.content, true) : null;
  }

  function grafikDom(b, id) {
    var g = balkenAus(b.werte, { breite: 720, hoehe: 240 });
    var figur = knoten('figure', 'mv-bplan-figur');
    var svg = svgKnoten('svg', { 'class': 'mv-bplan-grafik', viewBox: '0 0 720 240', role: 'img', 'aria-labelledby': id + '-t ' + id + '-d' });
    var titel = svgKnoten('title', { id: id + '-t' });
    titel.textContent = b.titel;
    var desc = svgKnoten('desc', { id: id + '-d' });
    desc.textContent = b.beschreibung;
    svg.appendChild(titel);
    svg.appendChild(desc);
    g.trenner.forEach(function (x) { svg.appendChild(svgKnoten('line', { 'class': 'mv-bplan-trenner', x1: x.toFixed(1), y1: '8', x2: x.toFixed(1), y2: String(g.hoehe - 26) })); });
    g.balken.forEach(function (s) {
      svg.appendChild(svgKnoten('rect', { 'class': 'mv-bplan-balken mv-bplan-balken--' + s.art, x: s.x.toFixed(1), y: s.y.toFixed(1), width: s.b.toFixed(1), height: Math.max(s.h, 0.5).toFixed(1) }));
    });
    svg.appendChild(svgKnoten('line', { 'class': 'mv-bplan-null', x1: '8', y1: g.nulllinie.toFixed(1), x2: '712', y2: g.nulllinie.toFixed(1) }));
    g.jahre.forEach(function (j) {
      var t = svgKnoten('text', { 'class': 'mv-bplan-jahr', x: j.x.toFixed(1), y: String(j.y), 'text-anchor': 'middle' });
      t.textContent = j.text;
      svg.appendChild(t);
    });
    figur.appendChild(svg);
    figur.appendChild(knoten('figcaption', 'mv-bplan-figur__text', b.beschreibung));
    return figur;
  }

  function blockDom(root, b, id) {
    var e;
    var i;
    switch (b.art) {
      case 'absatz':
        e = knoten('p', DOK_KLASSE.absatz);
        if (b.nr) {
          e.appendChild(knoten('span', DOK_KLASSE.absatznr, b.nr));
          e.appendChild(textKnoten(' '));
        }
        e.appendChild(textKnoten(b.text));
        return e;
      case 'liste':
        e = knoten('ul', DOK_KLASSE.liste);
        b.punkte.forEach(function (p) { e.appendChild(knoten('li', '', p)); });
        return e;
      case 'hinweis':
        e = knoten('aside', DOK_KLASSE.hinweis);
        e.setAttribute('role', 'note');
        var ic = icon(root, 'info');
        if (ic) e.appendChild(ic);
        e.appendChild(knoten('strong', DOK_KLASSE.hinweisTitel, (b.label || TEXTE.pruefhinweis) + ':'));
        e.appendChild(textKnoten(' ' + b.text));
        return e;
      case 'tabelle': {
        e = knoten('div', DOK_KLASSE.tabelle);
        e.setAttribute('role', 'region');
        e.setAttribute('tabindex', '0');
        e.setAttribute('aria-label', b.titel || b.kopf.join(', '));
        var tab = knoten('table', DOK_KLASSE.tab);
        if (b.titel) tab.appendChild(knoten('caption', DOK_KLASSE.tabTitel, b.titel));
        var kopf = knoten('thead');
        var kz = knoten('tr');
        b.kopf.forEach(function (k, n) {
          var th = knoten('th', b.zahlen.indexOf(n) !== -1 ? DOK_KLASSE.zahl : '', k);
          th.setAttribute('scope', 'col');
          kz.appendChild(th);
        });
        kopf.appendChild(kz);
        tab.appendChild(kopf);
        var rumpf = knoten('tbody');
        b.zeilen.forEach(function (r) {
          var tr = knoten('tr');
          r.forEach(function (c, n) { tr.appendChild(knoten('td', b.zahlen.indexOf(n) !== -1 ? DOK_KLASSE.zahl : '', c)); });
          rumpf.appendChild(tr);
        });
        tab.appendChild(rumpf);
        e.appendChild(tab);
        return e;
      }
      case 'kennzahlen':
        e = knoten('ul', 'mv-bplan-kennzahlen');
        e.setAttribute('role', 'list');
        b.werte.forEach(function (w) {
          var li = knoten('li', 'mv-bplan-kennzahl');
          li.appendChild(knoten('span', 'mv-bplan-kennzahl__label', w.label));
          li.appendChild(knoten('span', 'mv-bplan-kennzahl__wert', w.wert));
          if (w.text) li.appendChild(knoten('span', 'mv-bplan-kennzahl__text', w.text));
          e.appendChild(li);
        });
        return e;
      case 'grafik':
        return grafikDom(b, id + '-grafik');
      case 'zeile':
        return knoten('p', 'mv-vertrag-zwischen', b.text);
      case 'partei':
        e = knoten('p', 'mv-vertrag-partei');
        e.appendChild(knoten('span', 'mv-vertrag-partei__zeilen', b.zeilen.join(', ')));
        e.appendChild(textKnoten(' '));
        e.appendChild(knoten('span', 'mv-vertrag-partei__rolle', '\u2013 nachfolgend \u201e' + b.rolle + '\u201c \u2013'));
        return e;
      case 'pflicht': {
        var hid = id + '-haken-' + b.id;
        e = knoten('li', 'mv-pflicht-eintrag mv-pflicht-eintrag--' + b.status);
        e.setAttribute('data-mv-pflicht-eintrag', b.id);
        if (b.erledigt) e.setAttribute('data-mv-pflicht-erledigt', '');
        var zeile = knoten('div', 'mv-pflicht-eintrag__kopf');
        var cb = knoten('input', 'mv-pflicht-haken');
        cb.type = 'checkbox';
        cb.id = hid;
        cb.setAttribute('data-mv-pflicht-haken', b.id);
        cb.checked = !!b.erledigt;
        var lab = knoten('label', 'mv-pflicht-titel', b.titel);
        lab.setAttribute('for', hid);
        zeile.appendChild(cb);
        zeile.appendChild(lab);
        zeile.appendChild(knoten('span', 'mv-pflicht-status mv-pflicht-status--' + b.status, b.statusText));
        e.appendChild(zeile);
        e.appendChild(knoten('p', 'mv-pflicht-text', b.text));
        var norm = knoten('p', 'mv-pflicht-norm');
        norm.appendChild(knoten('span', 'mv-pflicht-norm__label', TEXTE.grundlage + ':'));
        norm.appendChild(textKnoten(' ' + b.norm));
        e.appendChild(norm);
        if (b.fuer) e.appendChild(knoten('p', 'mv-pflicht-fuer', TEXTE.giltFuer + ': ' + b.fuer));
        if (b.links.length) {
          var lp = knoten('p', 'mv-pflicht-links');
          lp.appendChild(knoten('span', 'mv-pflicht-links__label', TEXTE.mehr + ':'));
          for (i = 0; i < b.links.length; i++) {
            lp.appendChild(textKnoten(i ? ', ' : ' '));
            var a = knoten('a', 'mv-pflicht-link', b.links[i].text);
            a.setAttribute('href', b.links[i].href);
            lp.appendChild(a);
          }
          e.appendChild(lp);
        }
        return e;
      }
      case 'fortschritt': {
        e = knoten('div', 'mv-pflicht-fortschritt');
        var pr = knoten('progress', 'mv-pflicht-fortschritt__balken');
        pr.setAttribute('max', String(Math.max(b.gesamt, 1)));
        pr.setAttribute('value', String(b.erledigt));
        pr.setAttribute('aria-label', TEXTE.erledigt);
        e.appendChild(pr);
        var st = knoten('p', 'mv-pflicht-fortschritt__text', b.erledigt + ' ' + TEXTE.von + ' ' + b.gesamt + ' ' + TEXTE.erledigt);
        st.setAttribute('data-mv-pflicht-stand', '');
        e.appendChild(st);
        return e;
      }
      case 'angaben':
        e = knoten('p', 'mv-pflicht-angaben');
        e.appendChild(knoten('span', 'mv-pflicht-angaben__label', TEXTE.angaben + ':'));
        e.appendChild(textKnoten(' ' + b.punkte.join(' \u00b7 ')));
        return e;
      default:
        return erweiterterBlock('blockDom', b, { root: root, id: id });
    }
  }

  function bloeckeDom(root, bloecke, ziel, id) {
    var ul = null;
    bloecke.forEach(function (b) {
      var e = blockDom(root, b, id);
      if (!e) return;
      if (b.art === 'pflicht') {
        if (!ul) {
          ul = knoten('ul', 'mv-pflicht-liste');
          ul.setAttribute('role', 'list');
          ziel.appendChild(ul);
        }
        ul.appendChild(e);
      } else {
        ul = null;
        ziel.appendChild(e);
      }
    });
  }

  /* Ueberschriften im Blatt: Seite H1 (Werkzeug), Blatt H2 (unsichtbar), Dokument H3, Abschnitte H4 */
  function baueDokument(root, dok, id) {
    var art = knoten('div', DOK_KLASSE.dok + ' ' + DOK_KLASSE.dok + '--' + dok.werkzeug);
    var kopf = knoten('header', DOK_KLASSE.kopf);
    kopf.setAttribute('data-mv-vorlagen-teil', 'kopf');
    kopf.appendChild(knoten('p', DOK_KLASSE.marke, TEXTE.marke[dok.werkzeug] || TEXTE.marke.vertrag));
    kopf.appendChild(knoten('h3', DOK_KLASSE.titel, dok.titel));
    if (dok.untertitel) kopf.appendChild(knoten('p', DOK_KLASSE.untertitel, dok.untertitel));
    bloeckeDom(root, dok.kopf || [], kopf, id);
    art.appendChild(kopf);
    (dok.abschnitte || []).forEach(function (a) {
      var s = knoten('section', DOK_KLASSE.abschnitt);
      s.setAttribute('data-mv-vorlagen-abschnitt', a.id);
      var h = knoten('h4', DOK_KLASSE.ueberschrift);
      if (a.nr) {
        h.appendChild(knoten('span', DOK_KLASSE.nr, a.nr));
        h.appendChild(textKnoten(' '));
      }
      h.appendChild(textKnoten(a.titel));
      s.appendChild(h);
      bloeckeDom(root, a.bloecke, s, id);
      art.appendChild(s);
    });
    (dok.anlagen || []).forEach(function (a) {
      var s = knoten('section', DOK_KLASSE.abschnitt + ' ' + DOK_KLASSE.anlage);
      s.setAttribute('data-mv-vorlagen-anlage', a.id);
      var h = knoten('h4', DOK_KLASSE.ueberschrift);
      h.appendChild(knoten('span', DOK_KLASSE.nr, a.nr));
      h.appendChild(textKnoten(' \u2013 ' + a.titel));
      s.appendChild(h);
      bloeckeDom(root, a.bloecke, s, id);
      art.appendChild(s);
    });
    if (dok.unterschriften && dok.unterschriften.length) {
      var u = knoten('div', 'mv-vertrag-unterschriften');
      u.setAttribute('data-mv-vorlagen-teil', 'unterschriften');
      dok.unterschriften.forEach(function (x) {
        var feldU = knoten('div', 'mv-vertrag-unterschrift');
        feldU.appendChild(knoten('p', 'mv-vertrag-unterschrift__ort', (x.ort ? x.ort + ', ' : '') + 'den'));
        feldU.appendChild(knoten('span', 'mv-vertrag-unterschrift__linie'));
        feldU.appendChild(knoten('p', 'mv-vertrag-unterschrift__rolle', x.rolle + ': ' + x.name));
        u.appendChild(feldU);
      });
      art.appendChild(u);
    }
    return art;
  }

  var NEU_MS = 1600;

  function teilId(el) {
    return el.getAttribute('data-mv-vorlagen-abschnitt') || 'anlage-' + el.getAttribute('data-mv-vorlagen-anlage');
  }

  /* Abschnitte mit geaendertem Inhalt fuer NEU_MS markieren (nicht beim ersten Zeichnen, nicht bei Beispiel oder
     Loeschen). Die Frist haengt an der Kennung, nicht am Element: input und change zeichnen je neu, die Markierung
     bleibt bis zum Ablauf stehen. */
  function zeichne(root, z, dok) {
    var ziel = root.querySelector('[data-mv-vorlagen-dokument]');
    if (!ziel) return;
    var neu = baueDokument(root, dok, root.id || 'mv-vorlagen');
    var teile = neu.querySelectorAll('[data-mv-vorlagen-abschnitt], [data-mv-vorlagen-anlage]');
    var texte = {};
    var jetzt = Date.now();
    if (z.erstmals || z.ruhig) z.neuBis = {};
    for (var i = 0; i < teile.length; i++) {
      var id = teilId(teile[i]);
      texte[id] = teile[i].textContent;
      if (!z.erstmals && !z.ruhig && z.texte[id] !== undefined && z.texte[id] !== texte[id]) z.neuBis[id] = jetzt + NEU_MS;
      if (z.neuBis[id] > jetzt) teile[i].setAttribute('data-mv-vorlagen-neu', '');
    }
    z.texte = texte;
    while (ziel.firstChild) ziel.removeChild(ziel.firstChild);
    ziel.appendChild(neu);
    planeNeuEnde(root, z);
  }

  /* Ein Zeitgeber je Werkzeug nimmt abgelaufene Markierungen vom jeweils aktuellen Blatt */
  function planeNeuEnde(root, z) {
    if (z.neuZeit) window.clearTimeout(z.neuZeit);
    z.neuZeit = 0;
    var jetzt = Date.now();
    var naechste = Infinity;
    for (var id in z.neuBis) if (eigen(z.neuBis, id) && z.neuBis[id] > jetzt && z.neuBis[id] < naechste) naechste = z.neuBis[id];
    if (!isFinite(naechste)) return;
    z.neuZeit = window.setTimeout(function () {
      var nun = Date.now();
      var liste = root.querySelectorAll('[data-mv-vorlagen-dokument] [data-mv-vorlagen-neu]');
      for (var k = 0; k < liste.length; k++) if (!(z.neuBis[teilId(liste[k])] > nun)) liste[k].removeAttribute('data-mv-vorlagen-neu');
      planeNeuEnde(root, z);
    }, naechste - jetzt + 20);
  }

  function markiereBezug(root, z) {
    var fs = root.querySelector('fieldset[data-mv-vorlagen-schritt="' + z.schritt + '"]');
    var bezug = fs ? (fs.getAttribute('data-mv-vorlagen-bezug') || '').split(/\s+/) : [];
    var teile = root.querySelectorAll('[data-mv-vorlagen-dokument] [data-mv-vorlagen-abschnitt], [data-mv-vorlagen-dokument] [data-mv-vorlagen-anlage], [data-mv-vorlagen-dokument] [data-mv-vorlagen-teil]');
    var erster = null;
    for (var i = 0; i < teile.length; i++) {
      var el = teile[i];
      var id = el.getAttribute('data-mv-vorlagen-abschnitt') || el.getAttribute('data-mv-vorlagen-teil') || (el.hasAttribute('data-mv-vorlagen-anlage') ? 'anlagen' : '');
      if (bezug.indexOf(id) !== -1) {
        el.setAttribute('data-mv-vorlagen-markiert', '');
        if (!erster) erster = el;
      } else el.removeAttribute('data-mv-vorlagen-markiert');
    }
    return erster;
  }

  function aktualisiereCta(root, z) {
    var cta = root.querySelector('[data-mv-vorlagen-cta]');
    if (!cta) return;
    var w = z.werte || {};
    var teile;
    var produkt = cta.getAttribute('data-produkt') || '';
    if (z.w === 'vertrag') {
      var titel = Object.keys(w).filter(function (k) { return /^geraete\.\d+\.titel$/.test(k) && txt(w[k]); }).map(function (k) { return txt(w[k]); });
      if (titel.length) produkt = titel[0];
      teile = ['Aufstellungsvertrag (Muster)', titel.length ? 'Ger\u00e4te: ' + titel.join(', ') : '', 'Verg\u00fctung: ' + (MODELL_NAME[w['verguetung.modell']] || ''), 'Strom: ' + (STROM_NAME[w['strom.art']] || ''),
        'Laufzeit: ' + (w['laufzeit.art'] === 'befristet' ? 'Mindestlaufzeit ' + monateAkk(w['laufzeit.mindest']) : 'unbefristet')];
    } else if (z.w === 'businessplan' && z.plan) {
      var kz = z.plan.kennzahlen;
      var aktiv = z.plan.standorte.filter(function (s) { return s.aktiv; });
      if (aktiv.length) produkt = aktiv[0].geraet;
      teile = ['Businessplan (Muster)', 'Standorte: ' + aktiv.length, 'Ger\u00e4te: ' + aktiv.map(function (s) { return s.geraet; }).join(', '), 'Kapitalbedarf: ' + euro(kz.kapitalbedarf),
        'Finanzierung: ' + euro(kz.finanzierung), 'Ergebnis Jahr 1: ' + euro(z.plan.jahre[0].ergebnis), 'Liquidit\u00e4t Tiefpunkt: ' + euro(kz.tiefpunkt.wert)];
    } else if (z.w === 'pflichten') {
      var liste = pflichten(w);
      var fertig = liste.filter(function (q) { return (z.erledigt || []).indexOf(q.id) !== -1; }).length;
      teile = ['Pflichten-Check', liste.length + ' Punkte, davon ' + fertig + ' erledigt'];
    }
    var konf = konfigurationText(teile || []);
    cta.setAttribute('data-konfiguration', konf);
    cta.setAttribute('data-produkt', produkt);
    var basis = cta.getAttribute('data-mv-vorlagen-anfrage') || '/pages/contact?anfrage=1&interesse=Beratung';
    cta.setAttribute('href', basis + '&produkt=' + encodeURIComponent(produkt) + '&konfiguration=' + encodeURIComponent(konf));
  }

  function aktualisiereFortschritt(root, z) {
    var liste = pflichten(z.werte);
    var fertig = liste.filter(function (q) { return z.erledigt.indexOf(q.id) !== -1; }).length;
    var st = root.querySelector('[data-mv-pflicht-stand]');
    if (st) st.textContent = fertig + ' ' + TEXTE.von + ' ' + liste.length + ' ' + TEXTE.erledigt;
    var pr = root.querySelector('[data-mv-vorlagen-dokument] .mv-pflicht-fortschritt__balken');
    if (pr) {
      pr.setAttribute('max', String(Math.max(liste.length, 1)));
      pr.setAttribute('value', String(fertig));
    }
  }

  function aktualisiere(root, opt) {
    var z = zustand(root);
    if (!z) return;
    var o = opt || {};
    if (z.w === 'businessplan') wendeAfaAn(root, z);
    z.werte = mischeFlach(standardFuer(z.w, z.daten), lesen(root));
    bedingungen(root, z.werte);
    var kontext = { rechne: globaleRechne(), daten: z.daten };
    var dok = null;
    z.plan = null;
    try {
      if (z.w === 'vertrag') {
        stromVorschlag(root, z);
        dok = vertrag(z.werte, kontext);
      } else if (z.w === 'businessplan') {
        var bp = erweiterung();
        if (bp) kontext.datum = bp.heute();
        z.plan = bp ? bp.plan(z.werte, kontext) : rechnePlan(z.werte, kontext);
        kontext.plan = z.plan;
        dok = bp ? bp.dokument(z.werte, kontext) : businessplan(z.werte, kontext);
      } else dok = pflichtenDokument(z.werte, z.erledigt, kontext);
    } catch (e) {
      dok = null;
    }
    z.dok = dok;
    if (dok) zeichne(root, z, dok);
    else melde(root, TEXTE.ui.fehler);
    aktualisiereCta(root, z);
    var erster = markiereBezug(root, z);
    if (o.zeigen && erster && typeof erster.scrollIntoView === 'function') erster.scrollIntoView({ block: 'nearest' });
    if (o.speichern !== false) sichere(root);
    z.erstmals = false;
  }

  /* ---------------------------------------------------- Schritte und Ansicht */

  function schrittIds(root) {
    var liste = root.querySelectorAll('fieldset[data-mv-vorlagen-schritt]');
    var ids = [];
    for (var i = 0; i < liste.length; i++) ids.push(liste[i].getAttribute('data-mv-vorlagen-schritt'));
    return ids;
  }

  function zeigeSchritt(root, id, fokus, speichern) {
    var z = zustand(root);
    var ids = schrittIds(root);
    var n = ids.indexOf(id);
    if (n < 0) n = 0;
    z.schritt = ids[n];
    var liste = root.querySelectorAll('fieldset[data-mv-vorlagen-schritt]');
    var aktiv = null;
    for (var i = 0; i < liste.length; i++) {
      var an = i === n;
      liste[i].hidden = !an;
      if (an) aktiv = liste[i];
      var nav = liste[i].querySelector('[data-mv-vorlagen-nav]');
      if (!nav) continue;
      var zur = nav.querySelector('[data-mv-vorlagen-zurueck]');
      var wei = nav.querySelector('[data-mv-vorlagen-weiter]');
      var fer = nav.querySelector('[data-mv-vorlagen-fertig]');
      if (zur) zur.disabled = i === 0;
      if (wei) wei.hidden = i === ids.length - 1;
      if (fer) fer.hidden = i !== ids.length - 1;
    }
    var knoepfe = root.querySelectorAll('[data-mv-vorlagen-schritt-wahl]');
    for (var k = 0; k < knoepfe.length; k++) {
      var kid = knoepfe[k].getAttribute('data-mv-vorlagen-schritt-wahl');
      var pos = ids.indexOf(kid);
      if (kid === z.schritt) knoepfe[k].setAttribute('aria-current', 'step');
      else knoepfe[k].removeAttribute('aria-current');
      if (pos !== -1 && pos < n) knoepfe[k].setAttribute('data-mv-vorlagen-erreicht', '');
      else knoepfe[k].removeAttribute('data-mv-vorlagen-erreicht');
    }
    zeigeImStreifen(root);
    var pr = root.querySelector('[data-mv-vorlagen-fortschritt]');
    if (pr) {
      pr.setAttribute('max', String(ids.length));
      pr.setAttribute('value', String(n + 1));
    }
    var pt = root.querySelector('[data-mv-vorlagen-fortschritt-text]');
    if (pt) pt.textContent = TEXTE.ui.schritt + ' ' + (n + 1) + ' ' + TEXTE.von + ' ' + ids.length;
    var erster = markiereBezug(root, z);
    if (fokus && aktiv) {
      var t = aktiv.querySelector('[data-mv-vorlagen-schritt-titel]');
      if (t && typeof t.focus === 'function') t.focus();
      if (erster && typeof erster.scrollIntoView === 'function' && !z.erstmals) erster.scrollIntoView({ block: 'nearest' });
    }
    if (speichern !== false) sichere(root);
  }

  /* Mobil wischt die Schrittleiste waagrecht: den aktuellen Schritt sichtbar halten, ohne die Seite zu bewegen
     (scrollLeft der Liste statt scrollIntoView; die Liste ist per CSS positioniert, offsetLeft bezieht sich auf sie) */
  function zeigeImStreifen(root) {
    var aktuell = root.querySelector('[data-mv-vorlagen-schritt-wahl][aria-current="step"]');
    var eintrag = aktuell ? aktuell.parentNode : null;
    var liste = eintrag ? eintrag.parentNode : null;
    if (!liste || !(liste.scrollWidth > liste.clientWidth)) return;
    var links = eintrag.offsetLeft;
    if (links < liste.scrollLeft || links + eintrag.offsetWidth > liste.scrollLeft + liste.clientWidth) liste.scrollLeft = Math.max(0, links - 16);
  }

  function setzeAnsicht(root, ansicht) {
    var wz = root.querySelector('[data-mv-vorlagen-werkzeug]');
    if (!wz) return;
    wz.setAttribute('data-mv-vorlagen-ansicht', ansicht);
    var knoepfe = root.querySelectorAll('[data-mv-vorlagen-ansicht-wahl]');
    for (var i = 0; i < knoepfe.length; i++) knoepfe[i].setAttribute('aria-pressed', knoepfe[i].getAttribute('data-mv-vorlagen-ansicht-wahl') === ansicht ? 'true' : 'false');
  }

  /* ---------------------------------------------------- Aktionen */

  function lade(root, inhalt, typ, endung) {
    var z = zustand(root);
    try {
      var blob = new Blob([inhalt], { type: typ });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = TEXTE.datei[z.w] + endung;
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) { /* schon frei */ } }, 4000);
      melde(root, TEXTE.ui.gespeichert);
    } catch (e) {
      melde(root, TEXTE.ui.fehler);
    }
  }

  function kopiere(root) {
    var z = zustand(root);
    if (!z || !z.dok) return;
    var text = dokumentText(z.dok);
    var hand = function () {
      var ta = root.querySelector('[data-mv-vorlagen-kopie]');
      if (ta) {
        ta.hidden = false;
        ta.value = text;
        if (typeof ta.focus === 'function') ta.focus();
        if (typeof ta.select === 'function') ta.select();
      }
      melde(root, TEXTE.ui.kopierenHand);
    };
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text).then(function () { melde(root, TEXTE.ui.kopiert); }, hand);
        return;
      }
    } catch (e) { /* Rueckfall unten */ }
    hand();
  }

  function aktion(root, name) {
    var z = zustand(root);
    publiziere('mv_vorlagen_aktion', { werkzeug: z.w, aktion: name });
    if (name === 'beispiel') {
      /* ruhig: alles ist neu, keine Markierung ueber das ganze Blatt */
      z.ruhig = true;
      anwenden(root, beispielFuer(z.w, z.daten));
      if (z.w === 'businessplan') markiereEigen(root, z);
      z.erledigt = [];
      aktualisiere(root);
      z.ruhig = false;
      melde(root, TEXTE.ui.beispiel);
    } else if (name === 'leeren') {
      if (typeof window.confirm === 'function' && !window.confirm(TEXTE.ui.leerenFrage)) return;
      vergiss(z.w);
      z.ruhig = true;
      anwenden(root, standardFuer(z.w, z.daten));
      z.erledigt = [];
      zeigeSchritt(root, schrittIds(root)[0], false, false);
      aktualisiere(root, { speichern: false });
      z.ruhig = false;
      if (z.konto) {
        /* A-2b: geleert ist eine Eingabe; ein spaeter eintreffender Konto-Stand ersetzt sie nicht (dort loeschen) */
        kontoMerken(z);
        z.geaendert = true;
        z.kontoLeer = true;
      }
      melde(root, TEXTE.ui.geleert);
    } else if (name === 'drucken') {
      document.documentElement.setAttribute('data-mv-vorlagen-druck', z.w);
      if (typeof window.print === 'function') window.print();
    } else if (name === 'kopieren') {
      kopiere(root);
    } else if (z.dok && name === 'speichern') {
      lade(root, dokumentHtml(z.dok, { standalone: true }), 'text/html;charset=utf-8', '.html');
    } else if (z.dok && name === 'text') {
      lade(root, dokumentText(z.dok), 'text/plain;charset=utf-8', '.txt');
    } else if (z.plan && name === 'csv') {
      lade(root, planCsv(z.plan), 'text/csv;charset=utf-8', '.csv');
    }
  }

  function neueZeile(root, typ) {
    var z = zustand(root);
    var gruppe = root.querySelector('[data-mv-vorlagen-zeilen="' + typ + '"]');
    if (!gruppe) return;
    var anzahlVorher = zeilenListe(gruppe).length;
    if (anzahlVorher >= grenze(gruppe, 'data-mv-vorlagen-max', 12)) return;
    setzeZeilenzahl(gruppe, anzahlVorher + 1);
    var zeile = zeilenListe(gruppe)[anzahlVorher];
    if (z.w === 'businessplan') fuelleGeraeteWahl(root, z.daten);
    var vorgabe = typ === 'standorte' ? standortZeile(anzahlVorher, 'buero', z.daten) : typ === 'geraete' ? (function () {
      var g = {};
      g['geraete.' + anzahlVorher + '.eigentuemer'] = 'betreiber';
      return g;
    })() : {};
    var liste = zeile ? zeile.querySelectorAll('[data-mv-vorlagen-feld]') : [];
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      var v = vorgabe[el.name];
      if (el.type === 'checkbox') el.checked = istJa(v);
      else if (v !== undefined) el.value = String(v);
      else if (el.tagName !== 'SELECT') el.value = '';
    }
    aktualisiere(root);
    if (liste[0] && typeof liste[0].focus === 'function') liste[0].focus();
  }

  function entferneZeile(root, knopf) {
    var zeile = knopf.closest('[data-mv-vorlagen-zeile]');
    var gruppe = knopf.closest('[data-mv-vorlagen-zeilen]');
    if (!zeile || !gruppe) return;
    if (zeilenListe(gruppe).length <= grenze(gruppe, 'data-mv-vorlagen-min', 0)) return;
    zeile.parentNode.removeChild(zeile);
    nummeriereZeilen(gruppe);
    aktualisiere(root);
    var neu = gruppe.querySelector('[data-mv-vorlagen-zeile-neu]');
    if (neu && !neu.hidden && typeof neu.focus === 'function') neu.focus();
  }

  function hake(root, el) {
    var z = zustand(root);
    var id = el.getAttribute('data-mv-pflicht-haken');
    var pos = z.erledigt.indexOf(id);
    if (el.checked && pos === -1) z.erledigt.push(id);
    if (!el.checked && pos !== -1) z.erledigt.splice(pos, 1);
    var eintrag = el.closest('[data-mv-pflicht-eintrag]');
    if (eintrag) {
      if (el.checked) eintrag.setAttribute('data-mv-pflicht-erledigt', '');
      else eintrag.removeAttribute('data-mv-pflicht-erledigt');
    }
    aktualisiereFortschritt(root, z);
    aktualisiereCta(root, z);
    sichere(root);
  }

  /* ---------------------------------------------------- Start und Ereignisse */

  function init(root, ohneAbgleich) {
    var w = root.getAttribute('data-mv-vorlagen');
    if (WERKZEUGE.indexOf(w) === -1) return;
    /* A-2b: Altschluessel bei MVKonto anmelden, bevor ladeStand den Spiegel liest */
    var mv = kontoApi();
    if (mv) kontoAnmelden(mv);
    var daten = leseDaten(root);
    var z = { w: w, daten: daten, werte: {}, schritt: '', erledigt: [], texte: {}, erstmals: true, ruhig: false, neuBis: {}, neuZeit: 0, dok: null, plan: null, vorschlag: null };
    merke(root, z);
    var js = root.querySelectorAll('[data-mv-vorlagen-leiste], [data-mv-vorlagen-schrittleiste], [data-mv-vorlagen-umschalter], [data-mv-vorlagen-aktion], [data-mv-vorlagen-nav], [data-mv-vorlagen-zeile-neu]');
    for (var i = 0; i < js.length; i++) js[i].hidden = false;
    if (w === 'vertrag') fuelleGeraeteliste(root, daten);
    var stand = ladeStand(w);
    anwenden(root, mischeFlach(standardFuer(w, daten), stand ? stand.werte : {}));
    if (w === 'businessplan') markiereEigen(root, z);
    z.erledigt = stand && stand.erledigt ? stand.erledigt.slice() : [];
    var ids = schrittIds(root);
    setzeAnsicht(root, 'eingaben');
    zeigeSchritt(root, stand && ids.indexOf(stand.schritt) !== -1 ? stand.schritt : ids[0], false, false);
    aktualisiere(root, { speichern: false });
    root.setAttribute('data-mv-vorlagen-bereit', '');
    if (mv) kontoStart(root, mv, ohneAbgleich === true);
  }

  function start(bereich) {
    var b = bereich && typeof bereich.querySelectorAll === 'function' ? bereich : document;
    var liste = b.querySelectorAll('[data-mv-vorlagen]');
    for (var i = 0; i < liste.length; i++) init(liste[i]);
    if (b !== document && typeof b.matches === 'function' && b.matches('[data-mv-vorlagen]')) init(b);
  }

  function wurzel(el) {
    return el && typeof el.closest === 'function' ? el.closest('[data-mv-vorlagen][data-mv-vorlagen-bereit]') : null;
  }

  document.addEventListener('input', beiEingabe);
  document.addEventListener('change', beiEingabe);

  function beiEingabe(e) {
    var el = e.target;
    var root = wurzel(el);
    if (!root || !zustand(root)) return;
    var z = zustand(root);
    if (el.hasAttribute('data-mv-pflicht-haken')) {
      if (e.type === 'change') hake(root, el);
      return;
    }
    if (!el.hasAttribute('data-mv-vorlagen-feld')) return;
    var n = el.name || '';
    if (z.w === 'vertrag') {
      if (/^geraete\.\d+\.titel$/.test(n)) automatischKwh(root, z, el);
      if (n === 'strom.kwh' && e.type === 'input') el.removeAttribute('data-mv-vorlagen-auto');
    } else if (z.w === 'businessplan') {
      var m = /^standorte\.(\d+)\.(typ|geraet|verkaeufe|preis|tage)$/.exec(n);
      if (m && m[2] === 'typ') wendeReiterAn(root, z, m[1], el.value);
      else if (m && m[2] === 'geraet') wendeGeraetAn(root, z, m[1], el.value);
      else if (m && e.type === 'input') el.setAttribute('data-mv-vorlagen-eigen', '1');
      else if (n === 'investition.afaJahre' && e.type === 'input') el.setAttribute('data-mv-vorlagen-eigen', '1');
    }
    aktualisiere(root);
  }

  document.addEventListener('click', function (e) {
    var el = e.target && typeof e.target.closest === 'function' ? e.target.closest('[data-mv-vorlagen-aktion], [data-mv-vorlagen-weiter], [data-mv-vorlagen-zurueck], [data-mv-vorlagen-fertig], [data-mv-vorlagen-schritt-wahl], [data-mv-vorlagen-zeile-neu], [data-mv-vorlagen-zeile-weg], [data-mv-vorlagen-ansicht-wahl], [data-mv-vorlagen-uebernehmen]') : null;
    var root = wurzel(el);
    if (!el || !root) return;
    var z = zustand(root);
    if (!z) return;
    e.preventDefault();
    var ids = schrittIds(root);
    var n = ids.indexOf(z.schritt);
    if (el.hasAttribute('data-mv-vorlagen-aktion')) aktion(root, el.getAttribute('data-mv-vorlagen-aktion'));
    else if (el.hasAttribute('data-mv-vorlagen-weiter')) zeigeSchritt(root, ids[Math.min(n + 1, ids.length - 1)], true);
    else if (el.hasAttribute('data-mv-vorlagen-zurueck')) zeigeSchritt(root, ids[Math.max(n - 1, 0)], true);
    else if (el.hasAttribute('data-mv-vorlagen-schritt-wahl')) zeigeSchritt(root, el.getAttribute('data-mv-vorlagen-schritt-wahl'), true);
    else if (el.hasAttribute('data-mv-vorlagen-fertig')) {
      setzeAnsicht(root, 'dokument');
      var blatt = root.querySelector('[data-mv-vorlagen-blatt-titel]');
      if (blatt && typeof blatt.focus === 'function') blatt.focus();
    } else if (el.hasAttribute('data-mv-vorlagen-zeile-neu')) neueZeile(root, el.getAttribute('data-mv-vorlagen-zeile-neu'));
    else if (el.hasAttribute('data-mv-vorlagen-zeile-weg')) entferneZeile(root, el);
    else if (el.hasAttribute('data-mv-vorlagen-ansicht-wahl')) setzeAnsicht(root, el.getAttribute('data-mv-vorlagen-ansicht-wahl'));
    else if (el.hasAttribute('data-mv-vorlagen-uebernehmen') && z.vorschlag !== null) {
      var f = feldMitName(root, 'strom.pauschale');
      if (f) f.value = zahlText(z.vorschlag, 2);
      aktualisiere(root);
    }
  });

  /* Enter im Formular sendet nichts ab (kein Server) */
  document.addEventListener('submit', function (e) {
    if (e.target && typeof e.target.hasAttribute === 'function' && e.target.hasAttribute('data-mv-vorlagen-form')) e.preventDefault();
  });

  /* Druck: nur das Blatt des Werkzeugs (Druckregeln in assets/mv-sortiment.vorlagen.css), auch bei Strg+P */
  window.addEventListener('beforeprint', function () {
    if (document.documentElement.hasAttribute('data-mv-vorlagen-druck')) return;
    var r = document.querySelector('[data-mv-vorlagen][data-mv-vorlagen-bereit]');
    if (r) document.documentElement.setAttribute('data-mv-vorlagen-druck', r.getAttribute('data-mv-vorlagen'));
  });
  window.addEventListener('afterprint', function () {
    document.documentElement.removeAttribute('data-mv-vorlagen-druck');
  });

  /* Theme-Editor laedt Sektionen einzeln neu */
  document.addEventListener('shopify:section:load', function (e) {
    start(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); });
  } else {
    start(document);
  }
})();
